import { Injectable } from "@nestjs/common";
import { StyleEntity } from "./entittes/style-entity";
import {
  BomCreationFiltersReq,
  BomDataForStyleAndSeasonModel,
  BomExcelreq,
  BomGenerationReq,
  BomInfo,
  BomProposalDataModel,
  BomProposalReq,
  BomReportModel,
  BomReportSizeModel,
  BomResponseModel,
  CommonResponseModel,
  ImCodeItemMapReq,
  ItemInfoFilterReq,
  NikeBomsModal,
  PoDataForBomGenerationModel,
  PpmDateFilterRequest,
  SelectedItemsDto,
  ShippingTypeEnum,
  SizeMatrixFabricCodeDto,
  StyleAndTrimReq,
  StyleNumReq,
  StylesComboResponseModel,
  StylesResponseModel,
  ThreadBomGenerationReq,
  UOMEnum,
  styleAndItemreq,
  updateItemId,
} from "@project-management-system/shared-models";
import { DataSource, Not } from "typeorm";
import { StyleDto } from "./dto/style-dto";
import { BomEntity } from "./entittes/bom-entity";
import { StyleComboEntity } from "./entittes/style-combo-entity";
import { StyleRepo } from "./dto/style-repo";
import { BomRepo } from "./dto/bom-repo";
import { StyleComboRepo } from "./dto/style-combo-repo";
import { BomDto } from "./dto/bom-dto";
import { StyleComboDto } from "./dto/style-combo-dto";
import { DpomRepository } from "../dpom/repositories/dpom.repository";
import { StyleIdReq } from "./dto/api-requests";
import { PoBomEntity } from "./entittes/po-bom.entity";
import { GenericTransactionManager } from "../../typeorm-transactions";
import { FileUploadEntity } from "./entittes/file-upload-entity";
// import * as XLSX from "xlsx";      //  commit for excel download style
import { DpomEntity } from "../dpom/entites/dpom.entity";
import { AppDataSource2 } from "../app-datasource";
import { PoBomRepo } from "./repo/po-bom-repo";
import { ZFactorsRepo } from "./repo/z-factors-repo";
import { ItemsRepo } from "./repo/items-repo";
import { DestinationsRepo } from "./repo/destination-repo";
import { ZFactorsBomRepo } from "./repo/z-factors-bom-repo";
import { ZFactorsBomEntity } from "./entittes/z-factors-bom.entity";
import { ItemEntity } from "./entittes/item-entity";
import { itemWiseMOQ } from "./moq-data";
import { ApiSizeMatrixRepo } from "./repo/apasizematrix-repo";
import { convertDimensions } from "@project-management-system/backend-utils";
import { ItemImcodeMappingRepo } from "./repo/item-imcode-mapping-repo";
import { isArray } from "class-validator";
import { CartonBoxEntity } from "./entittes/carton_box_entity";
import { CartonBoxRepo } from "./repo/carton-box.repo";
import { PoQty } from "../dpom/dto/poqty.req";
import { StyleReqDto } from "./dto/style-master-req";
import { ErrorResponse } from "packages/libs/backend-utils/src/models/global-res-object";
import { StyleBomDto } from "./dto/bom-style.dto";
import { BomMasterDto } from "./dto/bom-master.dto";
import { StyleComboMasterDto } from "./dto/style-combo-master.dto";
import { BomFormDto } from "./dto/bom-form-dto";
import path = require("path");
import fs = require("fs");
import { Content } from "antd/es/layout/layout";
import { StyleComboMastersDto } from "./dto/style-comb-masters-dto";
const XLSX = require("xlsx-style");
const ExcelJS = require("exceljs");
import { config as config } from "../../../../../libs/shared-services/config";
import axios from "axios";
import { PPMDataRepository } from "../dpom/repositories/ppm-data.repository";
import * as moment from "moment";
import { message } from "antd";
import { OrderFormMappingDto } from "./dto/order-form-im-mapping";
const FormData = require("form-data");
@Injectable()
export class BomService {
  constructor(
    private styleRepo: StyleRepo,
    private bomRepo: BomRepo,
    private styleComboRepo: StyleComboRepo,
    private dataSource: DataSource,
    private dpomRepo: DpomRepository,
    private poBomRepo: PoBomRepo,
    private zFactorsRepo: ZFactorsRepo,
    private itemsRepo: ItemsRepo,
    private destinationsRepo: DestinationsRepo,
    private zFactorsBomRepo: ZFactorsBomRepo,
    private apaSizeamtrixRepo: ApiSizeMatrixRepo,
    private itemImcodeMappingRepo: ItemImcodeMappingRepo,
    private cartonBoxRepo: CartonBoxRepo,
    private ppmDataRepo: PPMDataRepository
  ) { }

  async createBom(req: StyleDto): Promise<CommonResponseModel> {
    try {
      const entity = new StyleEntity();
      entity.style = req.style;
      entity.season = req.season;
      entity.styleName = req.styleName;
      entity.mscCode = req.msc;

      let bomEntityArray = [];
      for (const bom of req.bomdto) {
        const bomEntity = new BomEntity();
        bomEntity.description = bom.description;
        bomEntity.imCode = bom.imCode;
        bomEntity.itemType = bom.itemType;
        bomEntity.use = bom.use;
        let styleComboArray = [];
        for (const styleCombo of bom.styleCombo) {
          const styleComboEntity = new StyleComboEntity();
          styleComboEntity.combination = styleCombo.combination;
          styleComboEntity.primaryColor = styleCombo.primaryColor;
          styleComboEntity.secondaryColor = styleCombo.secondaryColor;
          styleComboEntity.logoColor = styleCombo.logoColor;
          styleComboEntity.styleEntity = entity;
          styleComboArray.push(styleComboEntity);
        }
        bomEntity.styleComboEntity = styleComboArray;
        bomEntityArray.push(bomEntity);
      }
      entity.bomEntity = bomEntityArray;

      const save = await this.styleRepo.save(entity);
      if (save) {
        return new CommonResponseModel(true, 1, "Created Sucessfully");
      } else {
        return new CommonResponseModel(false, 0, "Something Went Wrong");
      }
    } catch (err) {
      throw err;
    }
  }

  async getAllStylesData(): Promise<CommonResponseModel> {
    try {
      let stylesArray = [];
      const style = await this.styleRepo.getStyelsData();
      if (style.length > 0) {
        for (const styleDetails of style) {
          let bomdetailsArray = [];
          styleDetails.bomData = await this.bomRepo.getBomData(styleDetails.id);
          for (const bom of styleDetails.bomData) {
            const combo = await this.styleComboRepo.getStyleComboData(
              bom.bomId
            );
            let styleCombosArray = [];
            for (const rec of combo) {
              styleCombosArray.push(
                new StyleComboDto(
                  rec.combination,
                  rec.primaryColor,
                  rec.secondaryColor,
                  rec.logoColor
                )
              );
            }
            bomdetailsArray.push(
              new BomDto(
                bom.itemName,
                bom.description,
                bom.imCode,
                bom.itemType,
                bom.use,
                styleCombosArray,
                bom.bomId,
                bom.styleId
              )
            );
          }
          stylesArray.push(
            new StyleDto(
              styleDetails.style,
              styleDetails.styleName,
              styleDetails.season,
              styleDetails.expNo,
              styleDetails.msc,
              styleDetails.factoryLo,
              styleDetails.status,
              styleDetails.fileData,
              bomdetailsArray
            )
          );
        }
      }
      // console.log(stylesArray, 'stylesarray')
      if (stylesArray) {
        return new CommonResponseModel(
          true,
          1,
          "Data Retrived Sucessfully",
          stylesArray
        );
      } else {
        return new CommonResponseModel(false, 1, "No Data Found", []);
      }
    } catch (err) {
      throw err;
    }
  }

  async getAll(): Promise<CommonResponseModel> {
    try {
      const query =
        "SELECT b.use,s.id as styeleId,s.style, s.style_name AS styleName,s.season,s.exp_no AS expNo,b.id AS bomId,b.style_id as bstyleId,b.item_name AS itemName,b.DESCRIPTION,b.im_code AS imCode,b.item_type AS itemType ,sc.id AS styleComboId,sc.bom_id AS sbomId,sc.style_id AS sstyleId,sc.combination,sc.primary_color AS primaryColor,sc.secondary_color AS secondaryColor,sc.logo_color AS logoColor FROM styles s  LEFT JOIN bom b ON b.style_id=s.id LEFT JOIN style_combos sc ON sc.bom_id=b.id";
      const result = await this.dataSource.query(query);
      const bomDetailsmap = new Map<number, BomDto>();
      if (result.length > 0) {
        for (const rec of result) {
          if (!bomDetailsmap.has(rec.bomId)) {
            bomDetailsmap.set(
              rec.bomId,
              new BomDto(
                rec.itemName,
                rec.DESCRIPTION,
                rec.imCode,
                rec.itemType,
                rec.use,
                [],
                rec.bomId,
                rec.bstyleId
              )
            );
          }
          bomDetailsmap
            .get(rec.bomId)
            .styleCombo.push(
              new StyleComboDto(
                rec.combination,
                rec.primaryColor,
                rec.secondaryColor,
                rec.logoColor
              )
            );
        }
        const bomInfo: BomDto[] = [];
        bomDetailsmap.forEach((e) => {
          bomInfo.push(e);
        });
        const finalData = new StyleDto(
          result.style,
          result.styleName,
          result.season,
          result.expNo,
          result.msc,
          result.factoryLo,
          result.status,
          result.fileData,
          bomInfo
        );

        return new CommonResponseModel(
          true,
          1,
          "Data Retrived Sucessfully",
          finalData
        );
      } else {
        return new CommonResponseModel(false, 1, "No Data Found", []);
      }
    } catch (err) {
      throw err;
    }
  }

  async getPpmPoLineData(
    req: PpmDateFilterRequest
  ): Promise<CommonResponseModel> {
    // console.log(req)
    const details = await this.dpomRepo.getPoLineData(req);
    if (details.length < 0) {
      return new CommonResponseModel(false, 0, "data not found");
    }

    const sizeDateMap = new Map<string, BomReportModel>();

    for (const rec of details) {
      let sizeData = sizeDateMap.get(rec.po_and_line);
      if (!sizeData) {
        sizeData = new BomReportModel(
          rec.id,
          rec.po_number,
          rec.po_and_line,
          // rec.DPOMLineItemStatus, // Assuming this property exists in your data
          rec.style_number,
          rec.destination_country_code,
          rec.destination_country,
          rec.planning_season_code,
          rec.planning_season_year,
          rec.geo_code,
          rec.total_item_qty, // Assuming this property exists in your data
          [],
          rec.gender_age_desc,
          "",
          rec.item,
          rec.plant
        );
        sizeDateMap.set(rec.po_and_line, sizeData);
      }
      if (!sizeData.sizeWiseData) {
        sizeData.sizeWiseData = [];
      }
      sizeData.sizeWiseData.push(
        new BomReportSizeModel(rec.size_description, rec.size_qty)
      );
    }
    const dataModelArray: BomReportModel[] = [];
    sizeDateMap.forEach((sizeData) => dataModelArray.push(sizeData));
    return new CommonResponseModel(true, 1, "data retrieved", dataModelArray);
  }

  async getPoLineDataForCihinaInserttag(
    req: ItemInfoFilterReq
  ): Promise<CommonResponseModel> {
    const details = await this.dpomRepo.getPoLineDataForCihinaInserttag(req);
    if (details.length < 0) {
      return new CommonResponseModel(false, 0, "data not found");
    }
    const sizeDateMap = new Map<string, BomReportModel>();
    for (const rec of details) {
      let sizeData = sizeDateMap.get(rec.po_and_line);
      // console.log(rec, 'RECCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCC')
      if (!sizeData) {
        sizeData = new BomReportModel(
          rec.po_number,
          rec.po_and_line,
          rec.DPOMLineItemStatus, // Assuming this property exists in your data
          rec.style_number,
          rec.destination_country_code,
          rec.destination_country,
          rec.planning_season_code,
          rec.planning_season_year,
          rec.geo_code,
          rec.total_item_qty, // Assuming this property exists in your data
          [],
          rec.gender_age_desc,
          rec.ogac
        );
        sizeDateMap.set(rec.po_and_line, sizeData);
      }

      if (!sizeData.sizeWiseData) {
        sizeData.sizeWiseData = [];
      }

      sizeData.sizeWiseData.push(
        new BomReportSizeModel(rec.size_description, rec.size_qty)
      );
    }

    const dataModelArray: BomReportModel[] = [];
    sizeDateMap.forEach((sizeData) => dataModelArray.push(sizeData));

    return new CommonResponseModel(true, 1, "data retrieved", dataModelArray);
  }

  async getStylesData(req: StyleReqDto): Promise<CommonResponseModel> {
    const stylesData = await this.styleRepo.getStyelsDatawithReq(req);
    if (stylesData.length) {
      return new CommonResponseModel(
        true,
        1111,
        "Date retreived sucessfully",
        stylesData
      );
    } else {
      return new CommonResponseModel(false, 1110, "No data found");
    }
  }

  async getBomDataForStyle(req: StyleIdReq): Promise<CommonResponseModel> {
    // const bomData = await this.bomRepo.getBomData(req.styleId)
    // const bomdetailsArray: BomDto[] = []
    // for (const bom of bomData) {
    //     const combo = await this.styleComboRepo.getStyleComboData(bom.bomId)
    //     let styleCombosArray: StyleComboDto[] = []
    //     for (const rec of combo) {
    //         styleCombosArray.push(new StyleComboDto(rec.combination, rec.primaryColor, rec.secondaryColor, rec.logoColor,rec.color))
    //     }
    //     bomdetailsArray.push(new BomDto(bom.itemName, bom.description, bom.imCode, bom.itemType, bom.use, styleCombosArray, bom.bomId, bom.styleId))
    // }
    const bomData = await this.bomRepo.getAllBomData(req.styleId);
    const bomMap = new Map<number, BomDto>();
    for (const rec of bomData) {
      if (!bomMap.has(rec.bomId)) {
        bomMap.set(
          rec.bomId,
          new BomDto(
            rec.itemName,
            rec.description,
            rec.imCode,
            rec.itemType,
            rec.use,
            [],
            rec.bomId,
            rec.styleId,
            rec.sequence,
            rec.vendorName,
            rec.orderForm
          )
        );
      }

      bomMap
        .get(rec.bomId)
        .styleCombo.push(
          new StyleComboMastersDto(
            rec.styleComboid,
            rec.combination,
            rec.primaryColor,
            rec.itemColor
          )
        );
    }
    const bomInfo: BomDto[] = [];
    bomMap.forEach((rec) => {
      bomInfo.push(rec);
    });
    return new CommonResponseModel(
      true,
      11111,
      "Data retreived sucessfully",
      bomInfo
    );
  }

  async getBomCreationData(
    req: BomCreationFiltersReq
  ): Promise<CommonResponseModel> {
    const data = await this.ppmDataRepo.getBomCreationData(req);
    return new CommonResponseModel(
      true,
      11111,
      "Data retreived sucessfully",
      data
    );
  }

  async calculateMOQForEachItem(
    bomQty: number,
    geoCode: string,
    regionSum: number,
    itemId: number
  ): Promise<number> {
    if (itemId == 1) {
      const moq = itemWiseMOQ[itemId].find((v) => (v.geoCode = geoCode)).qty;
      if (moq > regionSum) {
        const excessQty = moq - regionSum;
        const adjustmentRatio = bomQty / regionSum;
        const additionalQty = Math.round(adjustmentRatio * excessQty);
        return bomQty + additionalQty;
      }
      return bomQty;
    }
    return bomQty;
  }

  async getPcsPerCarton(
    size,
    style
  ): Promise<{ noOfPcs: number; cartonCode: string }> {
    const sizeOne = ["2XS", "XS", "S", "M", "L"];
    const sizeTwo = [
      "XL",
      "2XL",
      "3XL",
      "4XL",
      "5XL",
      "XS-S",
      "S-S",
      "M-S",
      "L-S",
      "XL-S",
      "2XL-S",
      "3XL-S",
      "4XL-S",
      "XS-T",
      "S-T",
      "M-T",
      "L-T",
      "XS-T",
      "S-T",
      "M-T",
      "L-T",
      "XL-T",
      "2XL-T",
      "3XL-T",
      "4XL-T",
      "5XL-T",
      "STT",
      "MTT",
      "LTT",
      "XLTT",
      "2XLTT",
      "3XLTT",
      "S+",
      "M+",
      "L+",
      "Custm",
    ];
    if (sizeOne.includes(size)) {
      const res = await this.cartonBoxRepo.findOne({
        select: ["stoL", "cartonCode"],
        where: { style: style },
      });
      return {
        cartonCode: res?.cartonCode,
        noOfPcs: res?.stoL ? res?.stoL : 0,
      };
    } else {
      const res = await this.cartonBoxRepo.findOne({
        select: ["xlToBal", "cartonCode"],
        where: { style: style },
      });
      return {
        cartonCode: res?.cartonCode,
        noOfPcs: res?.xlToBal ? res?.xlToBal : 0,
      };
    }
  }

  async calculateGumTapeRequirement(poQty: number, styleDesc: string) {
    if (styleDesc.includes("POLO")) {
      return poQty / 36;
    } else if (styleDesc.includes("TEE")) {
      return poQty / 40;
    } else {
      return poQty / 18;
    }
  }

  async generateBom(req: BomGenerationReq): Promise<CommonResponseModel> {
    // console.log(req)
    const transactionManager = new GenericTransactionManager(this.dataSource);
    await transactionManager.startTransaction();
    try {
      const { poLine, updatedSizes, isConsumptionRequired, fileId } = req;
      const poData = await this.ppmDataRepo.getPoDataForBomGeneration({
        poLine,
        fileId,
      });
      // console.log(poData.length, 'po data length')
      const destinations = await this.destinationsRepo.find({
        select: ["destination", "geoCode"],
      });
      const styleDataMap = new Map<string, BomDataForStyleAndSeasonModel[]>();
      const dryFitStyles =
        req.itemId === 3 ? await this.bomRepo.getAllDriFitStyle() : [];
      const driFitIms = ["726724", "726726", "726728", "726731", "726733"];
      const standardFitStyles =
        req.itemId === 3 ? await this.bomRepo.getAllStandardFitStyle() : [];
        // console.log(await this.bomRepo.getAllStandardFitStyle() )
      const standardFitIms = ["726722", "726725", "726727", "726729", "726732"];

      // console.log(dryFitStyles, standardFitStyles)
      const regionDataMap = new Map<
        string,
        { poData: PoDataForBomGenerationModel[]; totalQty: number }
      >();
      // moq logic for wash care label

      function calculateBomQty(
        poQty: number,
        consumption: number,
        directExcess: number,
        distributeExcess: number,
        shippingType: ShippingTypeEnum,
        toUOM: UOMEnum,
        fromUOM: UOMEnum,
        geoCode?: string,
        zfactorId?: number
      ) {
        // console.log(poQty,consumption,directExcess,distributeExcess,shippingType)
        // const excessQty = shippingType == ShippingTypeEnum.DIRECT ? 1.02 : 1.03
        const convertedQty = convertDimensions(fromUOM, toUOM, poQty);
        let excessQty =
          shippingType == ShippingTypeEnum.DIRECT
            ? directExcess
            : distributeExcess;
        const factor = 1 + excessQty / 100;
        const bomQty = convertedQty * consumption;
        // Adding 3% excess
        // if (req.itemId == 1 && zfactorId !== 10) {
        // exception fro wash care label removed logic as of now
        // if (geoCode == "APA" && bomQty < 150) {
        //     return bomQty;
        // }
        // }
        if (req.itemId == 54) {
          // exception case for spare button label
          return (convertedQty * factor * 5) / 100;
        }
        return bomQty * factor;
      }

      function getUpdatedQty(poLine: string, poQty) {
        if (updatedSizes.length) {
          const updatedSize = updatedSizes.find((u) => u.poLine == poLine);
          if (updatedSize) {
            return updatedSize.qty;
          }
        }
        return poQty;
      }
      const zfactors = await this.zFactorsBomRepo.getZfactorBomValues(
        req.itemId
      );
      // console.log(zfactors, 'z factors')
      const zfactorsToAdd = await this.zFactorsBomRepo.getZfactorBomValuesToAdd(
        req.itemId
      );
      // console.log(zfactorsToAdd)

      const poBomEntities: PoBomEntity[] = [];

      poDataLoop: for (const po of poData) {
        const bomDestinations = destinations.find(
          (v) => v.destination == po.destination
        );

        const { geoCode } = bomDestinations;
        if (!regionDataMap.has(geoCode)) {
          regionDataMap.set(geoCode, { poData: [po], totalQty: po.qty });
        } else {
          const poData = regionDataMap.get(geoCode).poData;
          poData.push(po);
          const totalQty = regionDataMap.get(geoCode).totalQty + po.qty;
          regionDataMap.set(geoCode, { poData, totalQty });
        }

        let styleData: BomDataForStyleAndSeasonModel[] = [];
        const seasonStyleKey = po.styleNumber + po.season + po.year;
        if (!styleDataMap.has(seasonStyleKey)) {
          styleData = await this.bomRepo.getTrimBomDataForStyleAndSeason({
            style: po.styleNumber,
            season: po.season,
            year: po.year,
            itemId: req.itemId,
          });
          styleDataMap.set(seasonStyleKey, styleData);
        } else {
          styleData = styleDataMap.get(seasonStyleKey);
        }
        const updatedQty = getUpdatedQty(po.poLineNo, po.qty);

        for (const styleBom of styleData) {
          const { consumption, toUOM, fromUOM } = req.isConsumptionRequired
            ? req.updatedConsumptions.length
              ? req.updatedConsumptions.find((v) => {
                if (v.consumptionAgainst == "item") {
                  if (v.isImCodeWiseConsumption) {
                    return v.item == po.item && v.imCode == styleBom.imCode;
                  }
                  if (req.itemId == 23) {
                    if (v.itemId) {
                      return v.itemId && v.item == po.item && v.use == styleBom.use;
                    } else {
                      return { consumption: 1, toUOM: UOMEnum.PCS, fromUOM: UOMEnum.PCS }
                    }
                  }
                  return v.item == po.item;
                } else {
                  if (v.isImCodeWiseConsumption) {
                    return (
                      v.style == po.styleNumber && v.imCode == styleBom.imCode
                    );
                  }
                  return v.style == po.styleNumber;
                }
              })
              : { consumption: 1, toUOM: UOMEnum.PCS, fromUOM: UOMEnum.PCS }
            : { consumption: 1, toUOM: UOMEnum.PCS, fromUOM: UOMEnum.PCS };

          const tempConsumption = Array.isArray(consumption)
            ? consumption.find((v) => v.size == po.size)?.sizeConsumption
            : consumption;
          // console.log(po.size, tempConsumption)
          const bomQty = calculateBomQty(
            updatedQty,
            tempConsumption,
            req.updatedExcessPercentages.DIRECT,
            req.updatedExcessPercentages.DISTRIBUTION_CENTER,
            po.shippingType,
            toUOM,
            fromUOM,
            geoCode
          );
          if (req.itemId == 10) {
            // size strip exception logic
            if (
              (styleBom.use.toLowerCase().includes("only") &&
                po.destination !== "USA") ||
              po.itemVasText?.toLowerCase().includes("hanger") ||
              po.itemVasText?.toLowerCase().includes("hclr")
            ) {
              continue poDataLoop;
            }
          }

          const poBomEntity = new PoBomEntity();
          const bom = new BomEntity();

          bom.id = styleBom.bomId;
          poBomEntity.bom = bom;
          poBomEntity.consumption = tempConsumption ? tempConsumption : 1;
          poBomEntity.moq = 1;
          poBomEntity.wastage =
            po.shippingType == ShippingTypeEnum.DIRECT ? 1.02 : 1.03;
          poBomEntity.bomQty = bomQty;
          poBomEntity.poQty = po.qty;
          poBomEntity.opUom = toUOM;
          poBomEntity.ipUom = fromUOM;
          const dpom = new DpomEntity();
          dpom.id = po.id;
          poBomEntity.dpom = dpom;

          // console.log(zfactors, 'z factors')
          for (const zfactor of zfactors) {
            if (
              styleBom.imCode == zfactor.actualIm &&
              styleBom.itemId == zfactor.itemId
            ) {
              // console.log(styleBom.imCode, zfactor.actualIm)
              if (
                req.itemId === 3 &&
                zfactor.plantCode == null &&
                (zfactor.gender
                  ? po.gender.toLowerCase() === zfactor.gender.toLowerCase()
                  : true) &&
                (zfactor.geoCode ? geoCode == zfactor.geoCode : true) &&
                (zfactor.destination
                  ? po.destination.toLowerCase() ==
                  zfactor.destination.toLowerCase()
                  : true)
              ) {
                const zfactorID = new ZFactorsBomEntity();
                zfactorID.id = zfactor.id;
                poBomEntity.zFactorBom = zfactorID;
                poBomEntity.bom = null;
              } else if (req.itemId === 3 && zfactor.plantCode != null) {
                if (
                  geoCode == zfactor.geoCode &&
                  zfactor.destination === null &&
                  (po.destination == "China"
                    ? zfactor.plantCode.includes(po.plant)
                    : true)
                ) {
                  const zfactorID = new ZFactorsBomEntity();
                  zfactorID.id = zfactor.id;
                  poBomEntity.zFactorBom = zfactorID;
                  poBomEntity.bom = null;
                } else if (
                  geoCode == zfactor.geoCode &&
                  zfactor.destination === "China" &&
                  zfactor.destination == po.destination &&
                  !zfactor.plantCode.includes(po.plant)
                ) {
                  // console.log(zfactor.destination, '-- destination 1 --')
                  // console.log(zfactor.imCode, '-- im code 2 --')
                  const zfactorID = new ZFactorsBomEntity();
                  zfactorID.id = zfactor.id;
                  poBomEntity.zFactorBom = zfactorID;
                  poBomEntity.bom = null;
                }
              } else if (
                (req.itemId !== 3 && geoCode == zfactor.geoCode) ||
                po.destination == zfactor.destination
              ) {
                const zfactorID = new ZFactorsBomEntity();
                zfactorID.id = zfactor.id;
                poBomEntity.zFactorBom = zfactorID;
                poBomEntity.bom = null;
                // console.log(poBomEntity)
              }
            }
          }
          poBomEntities.push(poBomEntity);
          // await transactionManager.getRepository(PoBomEntity).insert(poBomEntity)
        }
        // console.log(styleData)
        // console.log(zfactorsToAdd)
        for (const ab of zfactorsToAdd) {
          const bomQty = calculateBomQty(
            updatedQty,
            1,
            req.updatedExcessPercentages.DIRECT,
            req.updatedExcessPercentages.DISTRIBUTION_CENTER,
            po.shippingType,
            UOMEnum.PCS,
            UOMEnum.PCS,
            geoCode,
            ab.id
          );

          if (
            (req.itemId === 1 && po.destination === ab.destination) ||
            po.styleNumber === ab.style ||
            ab.destination === "ALL" ||
            (req.itemId === 1 &&
              geoCode == ab.geoCode &&
              ab.imCode == "445602" &&
              po.gender == ab.gender)
          ) {
            if (req.itemId == 1 && ab.plantCode?.split(",").includes(po.plant))
              continue;
            const poBomExtraITem = new PoBomEntity();
            poBomExtraITem.consumption = 1;
            poBomExtraITem.moq = 1;
            poBomExtraITem.wastage =
              po.shippingType == ShippingTypeEnum.DIRECT ? 1.02 : 1.03;
            poBomExtraITem.bomQty = bomQty;
            if (req.itemId == 56) {
              const res = await this.getPcsPerCarton(po.size, po.styleNumber);
              poBomExtraITem.wastage = 1.03;
              poBomExtraITem.bomQty = res.noOfPcs
                ? (po.qty / res.noOfPcs) * 1.03
                : 0;
            }
            poBomExtraITem.poQty = updatedQty;
            const dpom = new DpomEntity();
            dpom.id = po.id;
            poBomExtraITem.dpom = dpom;
            const zfactorID = new ZFactorsBomEntity();
            zfactorID.id = ab.id;
            poBomExtraITem.zFactorBom = zfactorID;
            poBomExtraITem.bom = null;
            poBomEntities.push(poBomExtraITem);
            // await transactionManager.getRepository(PoBomEntity).insert(poBomExtraITem)
          }
          if (req.itemId == 14 || req.itemId === 12) {
            const poBomExtraITem = new PoBomEntity();
            poBomExtraITem.consumption = 1;
            poBomExtraITem.moq = 1.03;
            poBomExtraITem.wastage = 1;
            poBomExtraITem.bomQty = bomQty;
            poBomExtraITem.poQty = updatedQty;
            const dpom = new DpomEntity();
            dpom.id = po.id;
            poBomExtraITem.dpom = dpom;
            const zfactorID = new ZFactorsBomEntity();
            zfactorID.id = ab.id;
            poBomExtraITem.zFactorBom = zfactorID;
            poBomExtraITem.bom = null;
            poBomEntities.push(poBomExtraITem);
          }
          if (req.itemId == 7) {
            if (ab.destination == po.destination) {
              const poBomExtraITem = new PoBomEntity();
              poBomExtraITem.consumption = 1;
              poBomExtraITem.moq = 1.03;
              poBomExtraITem.wastage = 1;
              poBomExtraITem.bomQty = bomQty;
              poBomExtraITem.poQty = updatedQty;
              const dpom = new DpomEntity();
              dpom.id = po.id;
              poBomExtraITem.dpom = dpom;
              const zfactorID = new ZFactorsBomEntity();
              zfactorID.id = ab.id;
              poBomExtraITem.zFactorBom = zfactorID;
              poBomExtraITem.bom = null;
              poBomEntities.push(poBomExtraITem);
            }
          }
          // carton box dependent rims logic
          if (req.itemId === 51 || req.itemId === 15) {
            const poBomExtraITem = new PoBomEntity();
            poBomExtraITem.consumption = 1;
            poBomExtraITem.moq = 1.03;
            poBomExtraITem.wastage = 1.03;
            const styleObj = await this.styleRepo.findOne({
              where: {
                style: po.styleNumber,
                season: po.season,
                year: po.year,
              },
            });
            const cartonsReq = await this.calculateGumTapeRequirement(
              updatedQty,
              styleObj.styleName
            );
            if (req.itemId === 15) {
              poBomExtraITem.bomQty = cartonsReq / 825;
            } else {
              poBomExtraITem.bomQty = (cartonsReq * 3.5) / 100;
            }
            poBomExtraITem.poQty = updatedQty;
            const dpom = new DpomEntity();
            dpom.id = po.id;
            poBomExtraITem.dpom = dpom;
            const zfactorID = new ZFactorsBomEntity();
            zfactorID.id = ab.id;
            poBomExtraITem.zFactorBom = zfactorID;
            poBomExtraITem.bom = null;
            poBomEntities.push(poBomExtraITem);
          }

       

          if (
            req.itemId === 3 &&
            (ab.gender
              ? po.gender.toLowerCase() === ab.gender.toLowerCase()
              : true) &&
            (ab.destination ? po.destination.toLowerCase() === ab.destination.toLowerCase() : true) &&
            (ab.plantCode
              ? Number(ab.isEqualTo) === 1
                ? !ab.plantCode.includes(po.plant)
                : ab.plantCode.includes(po.plant)
              : true) &&
            (ab.imCode === "1028705" ? po.productName.includes("FLC") : true) &&
            ab.itemName !== "HT SIZE INSERT"
          ) {
            const poBomExtraITem = new PoBomEntity();
            poBomExtraITem.consumption = 1;
            poBomExtraITem.moq = 1;
            poBomExtraITem.wastage =
              po.shippingType == ShippingTypeEnum.DIRECT ? 1.02 : 1.03;
            poBomExtraITem.bomQty = bomQty;
            poBomExtraITem.poQty = updatedQty;
            const dpom = new DpomEntity();
            dpom.id = po.id;
            poBomExtraITem.dpom = dpom;
            const zfactorID = new ZFactorsBomEntity();
            zfactorID.id = ab.id;
            poBomExtraITem.zFactorBom = zfactorID;
            poBomExtraITem.bom = null;
            poBomEntities.push(poBomExtraITem);
          }

          // if(po.size.includes("-T") || po.size.includes("-S")){
          //   console.log("po.size includes",po.size,po.productName,ab.imCode)
          //   console.log( driFitIms.includes(ab.imCode))
          //   console.log(standardFitStyles.some((obj) => obj.style === po.styleNumber))
          // }
          // console.log(po.size, (po.size.includes("-T") || po.size.includes("-S")), "size validation")
          if (
            req.itemId === 3 &&
            ab.itemName === "HT SIZE INSERT" &&
            ab.geoCode == geoCode &&
            (po.productName.includes("TEE") ||
              po.productName.includes("POLO") ||
              po.productName.includes("HOODIE") ||
              po.productName.includes("CRW") ||
              po.productName.includes("CREW")) &&
            (po.size.includes("-T") || po.size.includes("-S")) &&
            ((dryFitStyles.some((obj) => obj.style === po.styleNumber) &&
              driFitIms.includes(ab.imCode)) ||
              (standardFitIms.includes(ab.imCode) &&
                standardFitStyles.some((obj) => obj.style === po.styleNumber)))
          ) {

            if (ab.plantCode !== null) {
              if (
                geoCode == ab.geoCode &&
                ab.destination === null &&
                (po.destination == "China"
                  ? ab.plantCode.includes(po.plant)
                  : true)
              ) {
                const poBomExtraITem = new PoBomEntity();
                poBomExtraITem.consumption = 1;
                poBomExtraITem.moq = 1;
                poBomExtraITem.wastage =
                  po.shippingType == ShippingTypeEnum.DIRECT ? 1.02 : 1.03;
                poBomExtraITem.bomQty = bomQty;
                poBomExtraITem.poQty = updatedQty;
                const dpom = new DpomEntity();
                dpom.id = po.id;
                poBomExtraITem.dpom = dpom;
                const zfactorID = new ZFactorsBomEntity();
                zfactorID.id = ab.id;
                poBomExtraITem.zFactorBom = zfactorID;
                poBomExtraITem.bom = null;
                poBomEntities.push(poBomExtraITem);
              } else if (
                geoCode == ab.geoCode &&
                ab.destination === "China" &&
                ab.destination == po.destination &&
                !ab.plantCode.includes(po.plant)
              ) {
                const poBomExtraITem = new PoBomEntity();
                poBomExtraITem.consumption = 1;
                poBomExtraITem.moq = 1;
                poBomExtraITem.wastage =
                  po.shippingType == ShippingTypeEnum.DIRECT ? 1.02 : 1.03;
                poBomExtraITem.bomQty = bomQty;
                poBomExtraITem.poQty = updatedQty;
                const dpom = new DpomEntity();
                dpom.id = po.id;
                poBomExtraITem.dpom = dpom;
                const zfactorID = new ZFactorsBomEntity();
                zfactorID.id = ab.id;
                poBomExtraITem.zFactorBom = zfactorID;
                poBomExtraITem.bom = null;
                poBomEntities.push(poBomExtraITem);
              }
            } else {
              const poBomExtraITem = new PoBomEntity();
              poBomExtraITem.consumption = 1;
              poBomExtraITem.moq = 1;
              poBomExtraITem.wastage =
                po.shippingType == ShippingTypeEnum.DIRECT ? 1.02 : 1.03;
              poBomExtraITem.bomQty = bomQty;
              poBomExtraITem.poQty = updatedQty;
              const dpom = new DpomEntity();
              dpom.id = po.id;
              poBomExtraITem.dpom = dpom;
              const zfactorID = new ZFactorsBomEntity();
              zfactorID.id = ab.id;
              poBomExtraITem.zFactorBom = zfactorID;
              poBomExtraITem.bom = null;
              poBomEntities.push(poBomExtraITem);
            }
          }
        }
      }
      const moqData = [
        {
          region: "NA",
          moqQty: 300,
        },
        {
          region: "EMEA",
          moqQty: 500,
        },
        {
          region: "AAO",
          moqQty: 500,
        },
        {
          region: "APA",
          moqQty: 500,
        },
      ];
      if (req.itemId == 1) {
        for (const reg of ["EMEA", "APA", "AAO", "NA"]) {
          if (regionDataMap.has(reg)) {
            const moq = moqData.find((v) => v.region == reg)?.moqQty;
            const regionTotal = regionDataMap.get(reg).totalQty;
            if (regionTotal < moq) {
              for (const regPOObj of regionDataMap.get(reg).poData) {
                const div = moq / regionTotal;
                const moqPoQty = regPOObj.qty * div;
                if (poBomEntities.find((p) => p.dpom.id == regPOObj.id)) {
                  poBomEntities.find((p) => p.dpom.id == regPOObj.id).bomQty =
                    moqPoQty;
                }
              }
            }
          }
        }
      }

      // saving to database with bulk update and bulk insert

      await transactionManager
        .getRepository(PoBomEntity)
        .createQueryBuilder()
        .delete()
        .execute();
      await transactionManager.getRepository(PoBomEntity).insert(poBomEntities);

      await transactionManager.completeTransaction();
      if (poBomEntities.length) {
        return new CommonResponseModel(
          true,
          11111,
          "Bom generated sucessfully"
        );
      } else {
        return new CommonResponseModel(
          true,
          11111,
          "Bom not found for the selected item"
        );
      }
    } catch (err) {
      console.log(err);
      await transactionManager.releaseTransaction();
      throw err;
    }
  }

  async saveExcelData(val): Promise<CommonResponseModel> {
    try {
      // await transactionManager.startTransaction()
      const itemImcodeData = await this.itemImcodeMappingRepo.find({
        select: ["imCode", "itemId"],
      });

      const imCodeToItemIdMap = new Map<string, number>();

      itemImcodeData.forEach((data) => {
        imCodeToItemIdMap.set(data.imCode.trim(), data.itemId); // Overwrites if imCode already exists
      });

      const jsonData: any[] = await this.convertExcelToJson(val);
      const headerRow = jsonData[0];

      if (!jsonData.length) {
        return new CommonResponseModel(true, 1110, "No data found in excel");
      }
      // console.log(jsonData)
      // const data = await this.updatePath(val.path, val.filename, transactionManager);
      const jsonArray: any = jsonData.slice(1).map((row, arrInd) => {
        const obj: any = {};
        headerRow.forEach((header: any, index: any) => {
          let headerWithoutSpace = header
            .replace(/[^a-zA-Z0-9]/g, " ")
            .split(" ")
            .map((word, index) =>
              index === 0
                ? word.toLowerCase()
                : word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
            )
            .join("");

          obj[headerWithoutSpace] = row[index];
        });
        return obj;
      });

      const styleMap = new Map<string, StyleEntity>();
      const bomMap = new Map<string, BomEntity>();
      for (const rec of jsonArray) {
        if (!styleMap.has(rec.styleNbr)) {
          const styleEntityObj = new StyleEntity();
          styleEntityObj.styleName = rec.styleNm;
          styleEntityObj.mscLevelOne = rec.mscLevel1;
          styleEntityObj.mscLevelTwo = rec.mscLevel2;
          styleEntityObj.mscLevelThree = rec.mscLevel3;
          styleEntityObj.mscCode = rec.mscCode;
          styleEntityObj.season = rec.seasonCd;
          styleEntityObj.style = rec.styleNbr;
          styleEntityObj.year = rec.seasonYr;
          styleEntityObj.bomEntity = [];
          styleMap.set(rec.styleNbr, styleEntityObj);
        }

        if (!bomMap.has(rec.styleNbr + rec.itemNbr)) {
          const bomEntityObj = new BomEntity();
          bomEntityObj.imCode = rec.itemNbr?.trim();
          bomEntityObj.itemType = rec.itemType1?.trim();
          bomEntityObj.use = rec.use?.trim();
          bomEntityObj.qty = rec.qty;
          bomEntityObj.uom = rec.uom;
          bomEntityObj.description = rec.description?.trim();
          bomEntityObj.itemTypeOne = rec.itemType1;
          // let itemName = rec.itemType2
          bomEntityObj.itemName = "";

          // bomEntityObj.styleEnityy = style
          const itemID = imCodeToItemIdMap.get(rec.itemNbr?.trim())
          const item = new ItemEntity();
          item.itemId = itemID;
          bomEntityObj.itemEntity = item;
          bomEntityObj.styleComboEntity = [];
          bomMap.set(rec.styleNbr + rec.itemNbr, bomEntityObj);
          // console.log(bomEntityObj)
        }
        const styleComboEntityObj = new StyleComboEntity();
        styleComboEntityObj.combination = rec.styleCwCd;
        styleComboEntityObj.logoColor = rec.logo;
        styleComboEntityObj.primaryColor = rec.prmry;
        styleComboEntityObj.secondaryColor = rec.scndy;
        styleComboEntityObj.itemColor =
          rec?.itemColorCd ? rec?.itemColorCd : "" + " " + rec.itemColorAbrv ? rec.itemColorAbrv : "";

        // console.log(bomMap.get(rec.styleNm + rec.itemNbr))
        bomMap
          .get(rec.styleNbr + rec.itemNbr)
          .styleComboEntity.push(styleComboEntityObj);
        styleMap
          .get(rec.styleNbr)
          .bomEntity.push(bomMap.get(rec.styleNbr + rec.itemNbr));
      }
      for (const obj of styleMap.values()) {
        // console.log(obj)
        await this.styleRepo.save(obj);
      }

      return new CommonResponseModel(
        true,
        1111,
        "Data saved sucessfully",
        styleMap.keys()
      );
    } catch (err) {
      console.log(err);
      // await transactionManager.releaseTransaction()
      throw "Error Occured";
    }
  }

  async convertExcelToJson(file): Promise<any[]> {
    return new Promise((resolve, reject) => {
      try {
        const workbook = XLSX.readFile(file.path);
        const sheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[sheetName];
        const jsonData = XLSX.utils.sheet_to_json(worksheet, {
          header: 1,
          defval: "",
          raw: false,
          // dateNF: 'DD/MM/YYYY HH:mm'
        });
        resolve(jsonData);
      } catch (error) {
        reject(error);
      }
    });
  }

  async updatePath(
    filePath: string,
    filename: string,
    transactionManager: GenericTransactionManager
  ): Promise<any> {
    try {
      const entity = new FileUploadEntity();
      entity.fileName = filename;
      entity.filePath = filePath;
      const filePathUpdate = await transactionManager
        .getRepository(FileUploadEntity)
        .save(entity);
      if (filePathUpdate) {
        return new CommonResponseModel(
          true,
          11,
          "uploaded successfully",
          filePathUpdate
        );
      } else {
        return new CommonResponseModel(false, 11, "uploaded failed");
      }
    } catch (error) {
      await transactionManager.releaseTransaction();
    }
  }

  async migrateData() {
    await AppDataSource2.initialize();
    const data = await AppDataSource2.getRepository(StyleComboEntity).find({
      relations: ["styleEntity", "bomEntity"],
    });
    for (const rec of data) {
      rec.createdAt = "2024-01-25 09:51:07.522162";
      rec.updatedAt = "2024-01-25 09:51:07.522162";
      await this.styleComboRepo.insert(rec);
    }
  }

  async generateProposal(req: BomProposalReq): Promise<CommonResponseModel> {
    const destinations = await this.destinationsRepo.find({
      select: ["destination", "geoCode"],
    });

    const poBomData = await this.poBomRepo.getProposalsData(req);
    const poBomZfactorData = await this.poBomRepo.getZfactorsData(req);
    const sortData = [...poBomData, ...poBomZfactorData];
    const data = sortData.sort((a, b) => a.sequence - b.sequence);
    const groupedData: any = data.reduce(
      (result, currentItem: BomProposalDataModel, i, arr) => {
        let {
          styleNumber,
          imCode,
          bomQty,
          description,
          use,
          itemNo,
          itemId,
          destination,
          size,
          poNumber,
          gender,
          season,
          year,
          ogacDate,
          shipToNumber,
          dpomId,
          poQty,
          wastage,
          zFactorBomId,
        } = currentItem;
        //console.log(ogacDate)
        ogacDate = moment(ogacDate, "MM/DD/YYYY").format("YYYY-MM");
        //console.log('ogac date',ogacDate)
        const bomGeoCode = destinations.find(
          (v) => v.destination == destination
        );
        const { geoCode } = bomGeoCode;
        let key = `${geoCode}-${itemNo}-${imCode}_${styleNumber}`;

        if (["Brazil", "Argenftina"].includes(destination)) {
          key = `${key}-${destination}`;
          if (destination == "Brazil") {
            key = `${key}-${shipToNumber}`;
          }
        }
        if (!result[key]) {
          result[key] = {
            geoCode,
            styleNumber,
            description,
            use,
            imCode,
            itemNo,
            bomQty: 0,
            destination,
            itemId,
            poNumber,
            gender,
            season,
            year,
            shipToNumber,
            displayInMainReq: true,
            sizeWiseQty: [],
            chinaSizes: [],
            indonesiaSize: [],
            ogacDateWiseQty: [],
            shipToWiseQty: [],
            dpomIdSet: new Set(),
            zFactorIdSet: new Set(),
            stylesSet: new Set(),
            imCodes: "",
          };
        }
        if (!result[key].dpomIdSet.has(dpomId)) {
          result[key].bomQty += Number(bomQty);
          result[key].dpomIdSet.add(dpomId); // Mark dpomId as seen
        }

        if (!result[key].stylesSet.has(styleNumber)) {
          result[key].stylesSet.add(styleNumber); // Mark dpomId as seen
        }

        if (geoCode == "APA") {
          if (
            !result[key].sizeWiseQty.some(
              (entry: any) => entry.ogacDate === ogacDate
            )
          ) {
            const sizeWiseEntry: any = {
              ogacDate,
              dpomIdSet: new Set([dpomId]),
            };
            sizeWiseEntry[size] = Number(bomQty);
            result[key].sizeWiseQty.push(sizeWiseEntry);
          } else {
            const existingEntry = result[key].sizeWiseQty.find(
              (entry: any) => entry.ogacDate === ogacDate
            );
            if (!existingEntry.dpomIdSet.has(dpomId)) {
              existingEntry[size] = (existingEntry[size] || 0) + Number(bomQty);
              existingEntry.dpomIdSet.add(dpomId); // Mark dpomId as seen
            }
            // existingEntry[size] =+ Number(bomQty);
          }

          if (destination == "China" && imCode == "110044") {
            result[key].displayInMainReq = false;
            const sizeIndex = result[key]["chinaSizes"].findIndex(
              (v) => v.size === size
            );
            if (sizeIndex >= 0) {
              result[key]["chinaSizes"][sizeIndex].qty += Number(bomQty);
            } else {
              result[key].chinaSizes.push({ size, qty: Number(bomQty) });
            }
          }

          if (destination == "Indonesia") {
            result[key].displayInMainReq = false;
            const sizeIndex = result[key]["indonesiaSize"].findIndex(
              (v) => v.size === size
            );
            if (sizeIndex >= 0) {
              if (
                !result[key]["indonesiaSize"][sizeIndex].dpomIdSet.has(dpomId)
              ) {
                result[key]["indonesiaSize"][sizeIndex].qty =
                  result[key]["indonesiaSize"][sizeIndex].qty +
                  Number(poQty) * Number(wastage);
                result[key]["indonesiaSize"][sizeIndex].dpomIdSet.add(dpomId);
              }
            } else {
              result[key].indonesiaSize.push({
                size,
                qty: Number(poQty) * Number(wastage),
                dpomIdSet: new Set([dpomId]),
                poNumber,
                itemNo,
                styleNumber,
                destination,
              });
            }
          }
        }
        return result;
      },
      {}
    );
    const groupedArray: any[] = Object.values(groupedData);
    return new CommonResponseModel(true, 11, "Data retreived", groupedArray);
  }

  async generateProposalForWashcareLabel(req: BomProposalReq) {
    const proposalInitialData = await this.generateProposal(req);
    const itemWiseGroupedData = await this.itemWiseGroupData(
      proposalInitialData.data
    );
    const clubbedData = await this.clubData(itemWiseGroupedData);
    return new CommonResponseModel(true, 11, "Data retreived", clubbedData);
  }

  async itemWiseGroupData(bomInfo) {
    const newBomInfo = [...bomInfo];
    const itemWiseGroup = newBomInfo.reduce((acc, row) => {
      const { itemNo, geoCode, destination, styleNumber } = row;
      const key = `${itemNo}_${geoCode}_${styleNumber}`;

      // If the destination is Brazil, include it in the key
      if (destination === "Brazil") {
        const brazilKey = `${key}_Brazil`;

        // If the key doesn't exist in the accumulator, create a new object with the key
        if (!acc[brazilKey]) {
          acc[brazilKey] = [row];
        } else {
          // If the key already exists, check if the itemNo, geoCode, or destination has changed
          const lastRow = acc[brazilKey][acc[brazilKey].length - 1];
          if (
            lastRow.itemNo !== itemNo ||
            lastRow.geoCode !== geoCode ||
            lastRow.destination !== destination
          ) {
            // If either itemNo, geoCode, or destination has changed, create a new object with the key
            acc[brazilKey] = [row];
          } else {
            // If itemNo, geoCode, and destination are the same, simply push the row to the existing array
            acc[brazilKey].push(row);
          }
        }
      } else {
        // For destinations other than Brazil, follow the previous logic
        if (!acc[key]) {
          acc[key] = [row];
        } else {
          const lastRow = acc[key][acc[key].length - 1];
          if (
            lastRow.itemNo !== itemNo ||
            lastRow.geoCode !== geoCode ||
            lastRow.styleNumber !== styleNumber
          ) {
            acc[key] = [row];
          } else {
            acc[key].push(row);
          }
        }
      }

      return acc;
    }, {});
    return itemWiseGroup;
  }

  async clubData(itemWiseGroupedData: any) {
    const clubbedData = {};
    const moqCLubbedData = {};
    const itemWiseGroupNew = itemWiseGroupedData;
    for (const key in { ...itemWiseGroupNew }) {
      const itemWiseArr = itemWiseGroupNew[key];
      // console.log(itemWiseArr,itemWiseArr[2])
      const { geoCode, itemNo, bomQty, styleNumber, destination, imCode } =
        itemWiseArr[2] ? itemWiseArr[2] : itemWiseArr[0];
      const imCodeKeyWiseSets = {};
      imCodeKeyWiseSets[key] = new Set();

      itemWiseArr.forEach((item, index, arr) => {
        const { imCode } = item;
        imCodeKeyWiseSets[key].add(imCode);
      });

      const imCodeKeyWiseString = Array.from(imCodeKeyWiseSets[key]).join("_");

      let clubingkey = `${itemNo}_${imCodeKeyWiseString}_${geoCode}`;
      if (geoCode === "APA") {
        clubingkey = `${geoCode}_${itemNo}_${styleNumber}`;
      }
      if (geoCode === "AAO" && destination === "Brazil") {
        clubingkey = `${itemNo}_${geoCode}_${styleNumber}_${destination}`;
      }
      if (!clubbedData[clubingkey]) {
        clubbedData[clubingkey] = [...itemWiseArr];
      } else {
        clubbedData[clubingkey].forEach((v, i, carr) => {
          v.bomQty = Number(v.bomQty) + Number(bomQty);
          v.styleNumber = v.styleNumber + "," + styleNumber;
        });
      }
      if (geoCode !== "APA") {
        let moqClubbingKey = `${imCodeKeyWiseString}_${geoCode}`;

        if (geoCode === "AAO" && destination === "Brazil") {
          moqClubbingKey = `${itemNo}_${geoCode}_${styleNumber}_${destination}`;
        }
        if (!moqCLubbedData[moqClubbingKey]) {
          moqCLubbedData[moqClubbingKey] = {
            qty: bomQty,
            items: itemNo,
          };
        } else {
          moqCLubbedData[moqClubbingKey].qty += bomQty;
          moqCLubbedData[moqClubbingKey].items += "," + itemNo;
        }
      }
    }

    Object.keys(clubbedData).forEach((clubKey) => {
      const bomObj = clubbedData[clubKey][2] ? clubbedData[clubKey][2] : clubbedData[clubKey][0]
      Object.keys(moqCLubbedData).forEach((moqKey) => {
        if (clubKey.includes(moqKey) && moqCLubbedData[moqKey]) {
          if (moqCLubbedData[moqKey].qty < 500) {
            console.log(clubbedData[clubKey][2])
            const moqQty = this.overAllSizeWiseMoq(
              bomObj.bomQty,
              moqCLubbedData[moqKey].qty,
              500
            );

            clubbedData[clubKey].forEach((c) => {
              c.moqQty = moqQty;
            });
          }
          if (bomObj.bomQty < 500) {
            clubbedData[clubKey].forEach((c) => {
              c.items = moqCLubbedData[moqKey].items
            })
            // clubbedData[clubKey][2].items = 
          }
        }
      });
    });
    return clubbedData;
  }

  overAllSizeWiseMoq(poQty: number, overAllQty: number, moqQty: number) {
    const remaingQty = moqQty - overAllQty;
    const addQty = remaingQty * (poQty / overAllQty);
    return Math.ceil(poQty + addQty);
  }

  async getBomExcel(req?: BomExcelreq): Promise<CommonResponseModel> {
    let query = ` SELECT pb.dpom_id, dp.style_number AS style, dp.item AS item, dp.geo_code AS geo_code,count(dp.style_number) as style_number_count
          FROM po_bom pb
           LEFT JOIN dpom dp ON dp.id = pb.dpom_id
            Where 1=1`;
    if (req?.style) {
      query += ` and dp.style_number = '${req.style}'`;
    }
    if (req?.geoCode) {
      query += ` and dp.geo_code = '${req.geoCode}'`;
    }
    query = query + ` GROUP BY pb.dpom_id`;
    const records = await this.bomRepo.query(query);
    return new CommonResponseModel(
      true,
      12345,
      "Data Retrieved Successfully",
      records
    );
  }

  async getBom(req?: any): Promise<CommonResponseModel> {
    const query = `SELECT pb.bom_id ,pb.bom_qty,b.im_code FROM po_bom pb
        LEFT JOIN bom b ON b.id = pb.bom_id 
        WHERE pb.dpom_id IN (${req})`;
    const records = await this.bomRepo.query(query);
    return new CommonResponseModel(
      true,
      65486,
      "Data Retrieved Successfully",
      records
    );
  }

  async getStyle(req?: any): Promise<CommonResponseModel> {
    const query = `SELECT dp.style_number AS style
        FROM po_bom pb
        LEFT JOIN dpom dp ON dp.id = pb.dpom_id
        GROUP BY dp.style_number`;

    const data = await this.bomRepo.query(query);
    if (data.length) {
      return new CommonResponseModel(true, 1, "data retrived", data);
    } else {
      return new CommonResponseModel(false, 0, "error");
    }
  }

  async getGeoCode(): Promise<CommonResponseModel> {
    const query = `SELECT dp.id AS id, dp.geo_code AS geoCode
        FROM dpom dp
        WHERE dp.geo_code IS NOT NULL
        GROUP BY dp.geo_code`;

    const data = await this.bomRepo.query(query);
    if (data.length) {
      return new CommonResponseModel(true, 1, "data retrived", data);
    } else {
      return new CommonResponseModel(false, 0, "error");
    }
  }

  async generateProposalForButton(
    req: BomProposalReq
  ): Promise<CommonResponseModel> {
    const destinations = await this.destinationsRepo.find({
      select: ["destination", "geoCode"],
    });

    const poBomData = await this.poBomRepo.getProposalsDataForButton(req);
    const imItemColorSet = new Map<string, string>();

    const groupedData: any = poBomData.reduce(
      (result, currentItem: BomProposalDataModel) => {
        const {
          styleNumber,
          imCode,
          bomQty,
          description,
          use,
          itemNo,
          itemId,
          destination,
          size,
          poNumber,
          gender,
          season,
          year,
          color,
          itemColor,
          opUom,
          attribute,
          attributeValue,
          productCode,
          bQty,
          poQty,
          combination,
          vendorName,
        } = currentItem;
        // console.log(season)
        const bomGeoCode = destinations.find(
          (v) => v.destination == destination
        );
        const { geoCode } = bomGeoCode;

        let key = `${styleNumber}-${imCode}-${itemNo}-${itemColor}`;
        const imItemColorKey = `${styleNumber}-${imCode}-${itemNo}-${itemColor}`;
        //  console.log(imItemColorSet)
        const garColor = `${color}-${combination}`;
        if (!imItemColorSet.has(imItemColorKey)) {
          imItemColorSet.set(imItemColorKey, garColor);
        } else {
          let currentItemColorA = imItemColorSet.get(imItemColorKey);
          if (!currentItemColorA.split(",").includes(garColor)) {
            currentItemColorA = currentItemColorA + ("," + garColor);
          }
          imItemColorSet.set(imItemColorKey, currentItemColorA);
        }

        if (!result[key]) {
          result[key] = {
            geoCode,
            styleNumber,
            description,
            use,
            imCode,
            itemNo,
            bomQty: 0,
            destination,
            itemId,
            poNumber,
            gender,
            season,
            year,
            color,
            itemColor,
            productCode,
            bQty,
            poQty,
            attribute,
            attributeValue,
            combination,
            opUom,
            vendorName,
            sizeWiseQty: [],
            // colorData: []
          };
        }
        const sizeIndex = result[key]["sizeWiseQty"].findIndex(
          (v) => v.size === size
        );
        if (sizeIndex >= 0) {
          result[key]["sizeWiseQty"][sizeIndex].qty += Number(bomQty);
        } else {
          result[key].sizeWiseQty.push({ size, qty: Number(bomQty) });
        }
        result[key].bomQty += Number(bomQty);
        result[key].color = imItemColorSet.get(imItemColorKey);
        return result;
      },
      {}
    );
    // console.log(groupedData,'@@@@@@@@@@@@@@@')

    const groupedArray: any[] = Object.values(groupedData);
    return new CommonResponseModel(true, 11, "Data retreived", groupedArray);
  }

  // async generateProposalForNeckTape(req: BomProposalReq): Promise<CommonResponseModel> {
  //     const destinations = await this.destinationsRepo.find({ select: ['destination', 'geoCode'] })

  //     const poBomData = await this.poBomRepo.getProposalsDataForButton(req)

  //     let data = [...poBomData]
  //     const groupedData: any = poBomData.reduce((result, currentItem:BomProposalDataModel) => {
  //         const { styleNumber, imCode, bomQty, description, use, itemNo, itemId, destination, size ,poNumber,gender,season,year,color,itemColor,productCode} = currentItem;
  //         // console.log(season)
  //         const bomGeoCode = destinations.find((v) => v.destination == destination)
  //         const { geoCode } = bomGeoCode
  //         const key = `${geoCode}-${styleNumber}-${imCode}-${itemNo}`;

  //         if (!result[key]) {
  //             result[key] = {geoCode,styleNumber,description,use,imCode,
  //                 itemNo,bomQty: 0,destination,itemId,poNumber,gender, season,year, color,itemColor,productCode,};
  //         }
  //         result[key].bomQty += bomQty;
  //         return result;
  //     }, {});
  //     const groupedArray: any[] = Object.values(groupedData);
  //     return new CommonResponseModel(true, 11, 'Data retreived', groupedArray);
  // }
  async generateProposalForNeckTape(
    req: BomProposalReq
  ): Promise<CommonResponseModel> {
    const destinations = await this.destinationsRepo.find({
      select: ["destination", "geoCode"],
    });

    const poBomData = await this.poBomRepo.getProposalsDataForNeckTape(req);
    // console.log(poBomData,"poBomData")
    const groupedData: any = poBomData.reduce(
      (result, currentItem: BomProposalDataModel) => {
        const {
          styleNumber,
          imCode,
          combination,
          bomQty,
          description,
          use,
          itemNo,
          itemId,
          destination,
          size,
          poNumber,
          gender,
          season,
          year,
          color,
          itemColor,
          productCode,
          vendorName,
        } = currentItem;

        const bomGeoCode = destinations.find(
          (v) => v.destination === destination
        );
        const { geoCode } = bomGeoCode;
        const key = `${styleNumber}-${imCode}-${itemNo}-${color}-${itemColor}`;

        if (!result[key]) {
          result[key] = {
            geoCode,
            styleNumber,
            description,
            use,
            season,
            year,
            imCode,
            itemNo,
            vendorName,
            colors: [],
          };
        }

        // result[key].colors.push({
        //     color,
        //     itemColor,
        //     bomQty,
        // });

        const key2 = `${color}-${itemColor}`;
        const existingColor = result[key].colors.find(
          (c: any) => c.key === key2
        );
        if (existingColor) {
          existingColor.bomQty += Number(bomQty);
        } else {
          result[key].colors.push({
            key: key2,
            color,
            itemColor,
            bomQty: Number(bomQty),
            combination,
          });
        }
        // result[key].bomQty += Number(bomQty);
        return result;
      },
      {}
    );

    const groupedArray: any[] = Object.values(groupedData);
    return new CommonResponseModel(true, 11, "Data retrieved", groupedArray);
  }

  // async generatePropsalForHtLabel(req: BomProposalReq): Promise<CommonResponseModel> {
  //     const destinations = await this.destinationsRepo.find({ select: ['destination', 'geoCode'] })
  //     const poBomData = await this.poBomRepo.getProposalsDataForButton(req)
  //     const groupedData: any = poBomData.reduce((result, currentItem: BomProposalDataModel) => {
  //         const { styleNumber, imCode, bomQty, description, use, itemNo, itemId, destination, size, poNumber, gender, season, year, color, itemColor, productCode, combination } = currentItem;
  //         const bomGeoCode = destinations.find((v) => v.destination == destination)
  //         const { geoCode } = bomGeoCode

  //         const key = `${styleNumber}-${imCode}-${itemNo}-${color}-${itemColor}`;

  //         if (!result[key]) {
  //             result[key] = {
  //                 geoCode,
  //                 styleNumber,
  //                 description,
  //                 use,
  //                 imCode,
  //                 itemNo,
  //                 bomQty: 0,
  //                 destination,
  //                 itemId,
  //                 poNumber,
  //                 gender,
  //                 season,
  //                 year,
  //                 color,
  //                 itemColor,
  //                 productCode,
  //                 combination,
  //                 sizeWiseQty: [],
  //                 extraSizeWiseQty: []
  //             };
  //         }
  //         const sizeIndex = result[key]['sizeWiseQty'].findIndex((v) => v.size === size)
  //         if (size.includes('-')) {
  //             if (sizeIndex >= 0) {
  //                 result[key]['extraSizeWiseQty'][sizeIndex].qty += bomQty
  //             } else {
  //                 result[key].extraSizeWiseQty.push({ size, qty: bomQty });
  //             }
  //         }
  //         else {
  //             if (sizeIndex >= 0) {
  //                 result[key]['sizeWiseQty'][sizeIndex].qty += bomQty
  //             } else {
  //                 result[key].sizeWiseQty.push({ size, qty: bomQty });
  //             }
  //         }
  //         result[key].bomQty += bomQty;
  //         return result;
  //     }, { });
  // const groupedArray: any[] = Object.values(groupedData);
  // return new CommonResponseModel(true, 11, 'Data retreived', groupedArray);
  // }

  async generateProposalForTrims(
    req: BomProposalReq
  ): Promise<CommonResponseModel> {
    const destinations = await this.destinationsRepo.find({
      select: ["destination", "geoCode"],
    });
    const poBomData = await this.poBomRepo.getProposalsData(req);

    const groupedData: any = poBomData.reduce(
      (result, currentItem: BomProposalDataModel) => {
        const {
          styleNumber,
          imCode,
          bomQty,
          poQty,
          description,
          use,
          itemNo,
          itemId,
          destination,
          size,
          poNumber,
          gender,
          season,
          year,
          color,
          itemColor,
          productCode,
          uom,
          combination,
          consumption,
        } = currentItem;
        const bomGeoCode = destinations.find(
          (v) => v.destination == destination
        );
        const { geoCode } = bomGeoCode;
        let key = `${styleNumber}-${imCode}-${itemNo}`;
        if (
          req.trimName === "Interlining" ||
          req.trimName === "Jocktage Label"
        ) {
          key += `-${color}`;
        } else if (req.trimName === "Mobilon Tape") {
          key += `-${styleNumber}`;
        }
        if (!result[key]) {
          result[key] = {
            geoCode,
            styleNumber,
            description,
            poQty,
            use,
            imCode,
            itemNo,
            bomQty: 0,
            destination,
            itemId,
            poNumber,
            gender,
            season,
            year,
            color,
            itemColor,
            productCode,
            uom,
            combination,
            consumption,
          };
        }
        result[key].bomQty += Number(bomQty);

        return result;
      },
      {}
    );
    const groupedArray: any[] = Object.values(groupedData);
    return new CommonResponseModel(true, 1, "Data Retrived", groupedArray);
  }

  async generateProposalForTissuePaper(
    req: BomProposalReq
  ): Promise<CommonResponseModel> {
    const poBomData = await this.poBomRepo.generateProposalForTissuePaper(req);
    const groupedData: any[] = poBomData.reduce(
      (result, currentItem: BomProposalDataModel) => {
        const {
          styleNumber,
          bomQty,
          itemNo,
          destination,
          imCode,
          season,
          year,
          description,
          poQty,
          tissuePaperSize,
        } = currentItem;

        const key = `${styleNumber}-${itemNo}`;

        if (!result[key]) {
          result[key] = {
            key,
            styleNumber,
            itemNo,
            imCode,
            season,
            year,
            //  description,
            poQty: 0,
            bomQty: 0,
            tissuePaperSize,
          };
        }

        result[key].bomQty += Number(bomQty);
        result[key].poQty += Number(poQty);

        return result;
      },
      []
    );
    // console.log(groupedData)
    const groupedArray: any[] = Object.values(groupedData);

    return new CommonResponseModel(true, 1, "Data Retrieved", groupedArray);
  }

  async generatePropsalForHtLabel(
    req: BomProposalReq
  ): Promise<CommonResponseModel> {
    const destinations = await this.destinationsRepo.find({
      select: ["destination", "geoCode"],
    });
    const poBomData = await this.poBomRepo.getProposalsDataForButton(req);
    const groupedData: any = poBomData.reduce(
      (result, currentItem: BomProposalDataModel) => {
        const {
          styleNumber,
          imCode,
          bomQty,
          description,
          use,
          itemNo,
          itemId,
          destination,
          size,
          poNumber,
          gender,
          season,
          year,
          color,
          itemColor,
          productCode,
          combination,
        } = currentItem;
        const bomGeoCode = destinations.find(
          (v) => v.destination == destination
        );
        let htStyle;
        const { geoCode } = bomGeoCode;
        const key = `${styleNumber}-${imCode}-${itemNo}-${color}-${itemColor}`;

        if (!result[key]) {
          result[key] = {
            htStyle,
            geoCode,
            styleNumber,
            description,
            use,
            imCode,
            itemNo,
            bomQty: Number(bomQty),
            destination,
            itemId,
            poNumber,
            gender,
            season,
            year,
            color,
            itemColor,
            productCode,
            combination,
            teeStyelArray: [],
            poloStyleArray: [],
            sizeWiseQty: [],
            extraSizeWiseQty: [],
          };
        }
        const sizeIndex = result[key]["sizeWiseQty"].findIndex(
          (v) => v.size === size
        );
        if (size.includes("-")) {
          if (sizeIndex >= 0) {
            result[key]["extraSizeWiseQty"][sizeIndex].qty += Number(bomQty);
          } else {
            result[key].extraSizeWiseQty.push({ size, qty: Number(bomQty) });
          }
        } else {
          if (sizeIndex >= 0) {
            result[key]["sizeWiseQty"][sizeIndex].qty += Number(bomQty);
          } else {
            result[key].sizeWiseQty.push({ size, qty: Number(bomQty) });
          }
        }

        result[key].bomQty += Number(bomQty);
        return result;
      },
      {}
    );
    const groupedArray: any[] = Object.values(groupedData);
    // const obj=[groupedArray,teestylearray]
    return new CommonResponseModel(true, 11, "Data retreived", groupedArray);
  }
  // async getSizeHtLabelData(req: BomProposalReq): Promise<CommonResponseModel> {
  //     try {
  //         const destinations = await this.destinationsRepo.find({
  //             select: ["destination", "geoCode"],
  //         });

  //         const teeData = await this.poBomRepo.getProposalsDataForTeeStyle(req);
  //         const poloData = await this.poBomRepo.getProposalsDataForPoloStyle(req);

  //         const groupedTeeData: any = teeData.reduce(
  //             (result, currentItem: BomProposalDataModel) => {
  //                 const { styleNumber, imCode, bomQty, description, use, itemNo, itemId, destination, size, poNumber, gender, season, year, color, itemColor, productCode, combination, fabricCode, fabricCombination, fabricContent, fit,
  //                 } = currentItem;
  //                 const bomGeoCode = destinations.find(
  //                     (v) => v.destination == destination
  //                 );
  //                 let htStyle;
  //                 const { geoCode } = bomGeoCode;
  //                 const key = `${styleNumber}-${imCode}-${itemNo}-${color}-${itemColor}`;

  //                 if (!result[key]) {
  //                     result[key] = {
  //                         fabricCode,fabricCombination,fabricContent,fit,htStyle,geoCode,styleNumber,description,use,imCode,itemNo,bomQty: 0,destination,itemId,poNumber,gender,season,year,color,itemColor,productCode,combination,sizeWiseQty: [],
  //                     };
  //                 }
  //                 const sizeIndex = result[key]["sizeWiseQty"].findIndex(
  //                     (v) => v.size === size
  //                 );
  //                 if (!size.includes("-")) {
  //                     if (sizeIndex >= 0) {
  //                         result[key]["sizeWiseQty"][sizeIndex].qty += Number(bomQty);
  //                     } else {
  //                         result[key].sizeWiseQty.push({ size, qty: Number(bomQty) });
  //                     }
  //                 }
  //                 result[key].bomQty += Number(bomQty);
  //                 return result;
  //             },
  //             {}
  //         );
  //         const groupedTeeArray: any[] = Object.values(groupedTeeData);

  //         const groupedPoloData: any = poloData.reduce(
  //             (result, currentItem: BomProposalDataModel) => {
  //                 const {
  //                     styleNumber,
  //                     imCode,
  //                     bomQty,
  //                     description,
  //                     use,
  //                     itemNo,
  //                     itemId,
  //                     destination,
  //                     size,
  //                     poNumber,
  //                     gender,
  //                     season,
  //                     year,
  //                     color,
  //                     itemColor,
  //                     productCode,
  //                     combination,
  //                     fabricCode,
  //                     fabricCombination,
  //                     fabricContent,
  //                     fit,
  //                 } = currentItem;
  //                 const bomGeoCode = destinations.find(
  //                     (v) => v.destination == destination
  //                 );
  //                 const { geoCode } = bomGeoCode;
  //                 const key = `${styleNumber}-${imCode}-${itemNo}-${color}-${itemColor}`;
  //                 if (!result[key]) {
  //                     result[key] = {
  //                         fabricCode,
  //                         fabricCombination,
  //                         fabricContent,
  //                         fit,
  //                         geoCode,
  //                         styleNumber,
  //                         description,
  //                         use,
  //                         imCode,
  //                         itemNo,
  //                         bomQty: 0,
  //                         destination,
  //                         itemId,
  //                         poNumber,
  //                         gender,
  //                         season,
  //                         year,
  //                         color,
  //                         itemColor,
  //                         productCode,
  //                         combination,
  //                         teeStyelArray: [],
  //                         poloStyleArray: [],
  //                         sizeWiseQty: [],
  //                         extraSizeWiseQty: [],
  //                     };
  //                 }
  //                 const sizeIndex = result[key]["sizeWiseQty"].findIndex(
  //                     (v) => v.size === size
  //                 );
  //                 if (size.includes("-")) {
  //                     if (sizeIndex >= 0) {
  //                         result[key]["extraSizeWiseQty"][sizeIndex].qty += Number(bomQty);
  //                     } else {
  //                         result[key].extraSizeWiseQty.push({ size, qty: Number(bomQty) });
  //                     }
  //                 } else {
  //                     if (sizeIndex >= 0) {
  //                         result[key]["sizeWiseQty"][sizeIndex].qty += Number(bomQty);
  //                     } else {
  //                         result[key].sizeWiseQty.push({ size, qty: Number(bomQty) });
  //                     }
  //                 }

  //                 result[key].bomQty += Number(bomQty);
  //                 return result;
  //             },
  //             {}
  //         );
  //         const groupedPoloArray: any[] = Object.values(groupedPoloData);
  //         const obj = { teeStyle: groupedTeeArray, poloStyle: groupedPoloArray };
  //         return new CommonResponseModel(true, 1, "Data retrived", obj);
  //     } catch (err) {
  //         throw err;
  //     }
  // }

  async getSizeStrip(req: BomProposalReq): Promise<CommonResponseModel> {
    const destinations = await this.destinationsRepo.find({
      select: ["destination", "geoCode"],
    });

    const poBomData = await this.poBomRepo.getSizeStrip(req);
    // const poBomZfactorData = await this.poBomRepo.getZfactorsData(req)
    // console.log(poBomZfactorData, '---po bom zfactord data')
    let data = [...poBomData];
    const groupedData: any = poBomData.reduce(
      (result, currentItem: BomProposalDataModel) => {
        const {
          styleNumber,
          imCode,
          bomQty,
          description,
          use,
          itemNo,
          itemId,
          destination,
          size,
          poNumber,
          gender,
          season,
          year,
          color,
          itemColor,
          attribute,
          attributeValue,
          productCode,
          bQty,
          poQty,
        } = currentItem;
        // console.log(season)
        const bomGeoCode = destinations.find(
          (v) => v.destination == destination
        );
        const { geoCode } = bomGeoCode;
        let destinationKey = "ALL";

        if (use.toLowerCase().includes("only") && destination == "USA") {
          destinationKey = "USA";
        }
        const key = `${imCode}-${itemNo}-${destinationKey}`;
        if (!result[key]) {
          result[key] = {
            geoCode,
            styleNumber,
            // description,
            use,
            imCode,
            itemNo,
            bomQty: 0,
            destination: destinationKey,
            itemId,
            poNumber,
            gender,
            season,
            year,
            color,
            itemColor,
            productCode,
            bQty,
            poQty,
            attribute,
            attributeValue,
            sizeWiseQty: [],
            stylesSet: new Set(),
            // colorData: []
          };
        }
        if (!result[key].stylesSet.has(styleNumber)) {
          result[key].stylesSet.add(styleNumber);
        }

        const sizeIndex = result[key]["sizeWiseQty"].findIndex(
          (v) => v.size === size
        );
        if (sizeIndex >= 0) {
          result[key]["sizeWiseQty"][sizeIndex].qty += Number(bomQty);
        } else {
          result[key].sizeWiseQty.push({ size, qty: Number(bomQty) });
        }
        result[key].bomQty += Number(bomQty);
        return result;
      },
      {}
    );
    // console.log(groupedData,'@@@@@@@@@@@@@@@')
    const groupedArray: any[] = Object.values(groupedData).map((item: any) => ({
      ...item,
      stylesSet: Array.from(item.stylesSet),
      styleNumber: Array.from(item.stylesSet).join(","),
    }));
    return new CommonResponseModel(true, 11, "Data retreived", groupedArray);
  }

  async getImcodes(): Promise<CommonResponseModel> {
    const data = await this.bomRepo.getImcodes();
    if (data) {
      return new CommonResponseModel(true, 1, "Data Retrived", data);
    } else {
      return new CommonResponseModel(false, 0, "No Data", []);
    }
  }

  async getItemname(): Promise<CommonResponseModel> {
    const records = await this.bomRepo;
    const query = `SELECT i.item_id as itemId,i.item AS itemName FROM items i`;
    const result = await this.bomRepo.query(query);
    if (result) {
      return new CommonResponseModel(true, 1, "Data Retrived", result);
    } else {
      return new CommonResponseModel(false, 0, "No Data", []);
    }
  }

  async updateItemid(req: updateItemId): Promise<CommonResponseModel> {
    try {
      const query = ` UPDATE bom 
                SET item_id = '${req.itemId}'
                WHERE im_code = '${req.imCode}' `;
      const result = await this.dataSource.query(query);
      if (result) {
        return new CommonResponseModel(true, 1, "Data Updated", result);
      } else {
        return new CommonResponseModel(false, 0, "No Data Updated", []);
      }
    } catch (error) {
      // console.error("Error occurred during update:", error);
      return new CommonResponseModel(
        false,
        0,
        "Error occurred during update",
        []
      );
    }
  }
  async getApaSizeMatrix(req: StyleNumReq): Promise<CommonResponseModel> {
    try {
      // const query=`SELECT id,buy_month AS buyMonth,style_number AS styleNumber,style_type AS styleType,usa_size AS usaSize,china_size_matrixtype AS chinaSizeMatrixType,   china_top_size AS chinaTopSize,china_top_bodysize AS chinaTopBodySize,china_bottom_size AS chinaBottomSize,china_bottom_bodysize AS chinabottomBodySize,           korea_size_matrixtype AS koreaSizeMatrixType,korea_top_generic AS koreaTopGeneric,korea_top_chest AS koreaTopChest,            korea_top_height AS koreaTopHeight,korea_bottom_generic AS koreaBottomGeneric,korea_bottom_waist AS koreaBottomWaist,korea_bottom_hip AS koreaBottomWaist FROM apa_size_matrix where style_number in (:...style), { style: req.styleNumber }`
      // const result = await this.dataSource.query(query)
      const result = await this.apaSizeamtrixRepo.getApaSizeMatrixData(req);
      if (result) {
        return new CommonResponseModel(true, 1, "Data Retrived", result);
      } else {
        return new CommonResponseModel(true, 1, "Data Retrived", []);
      }
    } catch (err) {
      throw err;
    }
  }
  async generateProposalForPOIDLabel(
    req: BomProposalReq
  ): Promise<CommonResponseModel> {
    const destinations = await this.destinationsRepo.find({
      select: ["destination", "geoCode"],
    });
    const poBomData = await this.poBomRepo.getProposalsData(req);
    let comboSet = [];
    const groupedData: any = poBomData.reduce(
      (result, currentItem: BomProposalDataModel) => {
        const {
          styleNumber,
          imCode,
          bomQty,
          poQty,
          description,
          use,
          itemNo,
          itemId,
          destination,
          size,
          poNumber,
          gender,
          season,
          year,
          color,
          itemColor,
          productCode,
          poAndLine,
        } = currentItem;
        const bomGeoCode = destinations.find(
          (v) => v.destination == destination
        );
        const { geoCode } = bomGeoCode;
        let key = `${styleNumber}-${imCode}-${itemNo}`;
        let comboKey = `${poAndLine}-${size}`;
        if (!result[key]) {
          result[key] = {
            //geoCode,
            styleNumber,
            //  description,
            poQty: 0,
            use,
            imCode,
            itemNo,
            bomQty: 0,
            destination,
            itemId,
            poNumber,
            // gender,
            //season,
            // year,
            color,
            itemColor,
            productCode,
          };
        }
        if (!comboSet.includes(comboKey)) {
          comboSet.push(comboKey);
          result[key].bomQty += Number(bomQty);
          result[key].poQty += poQty;
        }

        return result;
      },
      {}
    );
    const groupedArray: any[] = Object.values(groupedData);
    return new CommonResponseModel(true, 1, "Data Retrived", groupedArray);
  }
  async generateProposalForKimble(
    req: BomProposalReq
  ): Promise<CommonResponseModel> {
    const poBomData = await this.poBomRepo.getZfactorsDataForKimble(req);
    const groupedData: any = poBomData.reduce(
      (result, currentItem: BomProposalDataModel) => {
        const {
          styleNumber,
          imCode,
          bomQty,
          poQty,
          primaryColor,
          use,
          itemNo,
          itemId,
          destination,
          size,
          ogacDate,
          poNumber,
          gender,
          season,
          year,
          color,
          itemColor,
          productCode,
          kimbleSize,
        } = currentItem;

        let key = `${styleNumber}-${itemNo}`;
        // console.log(kimbleSize, 'kimble size')
        if (!result[key]) {
          result[key] = {
            styleNumber,
            poQty: 0,
            itemNo,
            bomQty: 0,
            itemId,
            poNumber,
            gender,
            primaryColor,
            season,
            year,
            color,
            itemColor,
            productCode,
            ogacDate,
            kimbleSize,
          };
        }
        result[key].bomQty += Number(bomQty);
        result[key].poQty += Number(poQty);

        return result;
      },
      {}
    );
    const groupedArray: any[] = Object.values(groupedData);
    return new CommonResponseModel(true, 1, "Data Retrived", groupedArray);
  }

  async generateProposalForHmSheet(
    req: BomProposalReq
  ): Promise<CommonResponseModel> {
    const destinations = await this.destinationsRepo.find({
      select: ["destination", "geoCode"],
    });

    const poBomData = await this.poBomRepo.generateProposalForHmSheet(req);

    const groupedData: any = poBomData.reduce(
      (result, currentItem: BomProposalDataModel) => {
        const {
          styleNumber,
          imCode,
          bomQty,
          teflonSheetSize,
          description,
          itemNo,
          itemId,
          destination,
          size,
          poNumber,
          gender,
          season,
          year,
          color,
          itemColor,
          productCode,
        } = currentItem;
        // console.log(season)
        const bomGeoCode = destinations.find(
          (v) => v.destination == destination
        );
        const { geoCode } = bomGeoCode;
        const key = `${itemNo}-${styleNumber}-${teflonSheetSize}`;

        if (!result[key]) {
          result[key] = {
            geoCode,
            styleNumber,
            description,
            imCode,
            teflonSheetSize,
            itemNo,
            bomQty: 0,
            destination,
            itemId,
            poNumber,
            gender,
            season,
            year,
            color,
            itemColor,
            productCode,
          };
        }
        result[key].bomQty += Number(bomQty);
        return result;
      },
      {}
    );
    const groupedArray: any[] = Object.values(groupedData);
    return new CommonResponseModel(true, 11, "Data retreived", groupedArray);
  }

  async getProposalForGumtape(
    req: BomProposalReq
  ): Promise<CommonResponseModel> {
    const destinations = await this.destinationsRepo.find({
      select: ["destination", "geoCode"],
    });

    const poBomZfactorData = await this.poBomRepo.getZfactorsData(req);
    let data = [...poBomZfactorData];
    const groupedData: any = poBomZfactorData.reduce(
      (result, currentItem: BomProposalDataModel) => {
        const {
          styleNumber,
          imCode,
          bomQty,
          description,
          use,
          itemNo,
          itemId,
          destination,
          size,
          poNumber,
          gender,
          season,
          year,
          color,
          itemColor,
          attribute,
          attributeValue,
          productCode,
          bQty,
          poQty,
          consumption,
        } = currentItem;
        // console.log(season)
        const bomGeoCode = destinations.find(
          (v) => v.destination == destination
        );
        const { geoCode } = bomGeoCode;

        let key = `${styleNumber}-${imCode}-${itemNo}`;

        if (!result[key]) {
          result[key] = {
            geoCode,
            styleNumber,
            description,
            use,
            imCode,
            itemNo,
            bomQty: 0,
            destination,
            itemId,
            poNumber,
            gender,
            season,
            year,
            color,
            itemColor,
            productCode,
            bQty,
            poQty: 0,
            consumption,
            attribute,
            attributeValue,
            // colorData: []
          };
        }

        result[key].bomQty += Number(bomQty);
        result[key].poQty += Number(poQty);

        return result;
      },
      {}
    );
    // console.log(groupedData,'@@@@@@@@@@@@@@@')
    const groupedArray: any[] = Object.values(groupedData);
    return new CommonResponseModel(true, 11, "Data retreived", groupedArray);
  }

  async getUniqueSizeAgainstStyleAndItem(
    req: styleAndItemreq
  ): Promise<CommonResponseModel> {
    try {
      const data = await this.bomRepo.getUniqueSizeAgainstStyleAndItem(req);
      return new CommonResponseModel(true, 1, "data retrived", data);
    } catch (err) {
      throw err;
    }
  }

  async getBackingPaperV2(req: BomProposalReq): Promise<CommonResponseModel> {
    const destinations = await this.destinationsRepo.find({
      select: ["destination", "geoCode"],
    });

    // const poBomData = await this.poBomRepo.getBackingPaperV2(req)
    const poBomZfactorData = await this.poBomRepo.getZfactorsData(req);
    // console.log(poBomZfactorData, '---po bom zfactord data')
    let data = [...poBomZfactorData];
    const groupedData: any = poBomZfactorData.reduce(
      (result, currentItem: BomProposalDataModel) => {
        const {
          styleNumber,
          imCode,
          bomQty,
          description,
          use,
          itemNo,
          itemId,
          destination,
          size,
          poNumber,
          gender,
          season,
          year,
          color,
          itemColor,
          attribute,
          attributeValue,
          productCode,
          bQty,
          poQty,
          nonwovencolor,
          wastage,
          consumption,
          combination,
        } = currentItem;
        // console.log(season)
        const bomGeoCode = destinations.find(
          (v) => v.destination == destination
        );
        const { geoCode } = bomGeoCode;
        const key = `${styleNumber}-${imCode}-${itemNo}-${color}-${itemColor}`;
        if (!result[key]) {
          result[key] = {
            geoCode,
            styleNumber,
            description,
            use,
            imCode,
            itemNo,
            bomQty: 0,
            destination,
            itemId,
            poNumber,
            gender,
            season,
            year,
            color,
            itemColor,
            productCode,
            bQty,
            poQty,
            attribute,
            attributeValue,
            nonwovencolor,
            wastage,
            consumption,
            combination,
            sizeWiseQty: [],
            // colorData: []
          };
        }

        result[key].bomQty += Number(bomQty);
        return result;
      },
      {}
    );
    // console.log(groupedData,'@@@@@@@@@@@@@@@')
    const groupedArray: any[] = Object.values(groupedData);
    return new CommonResponseModel(true, 11, "Data retreived", groupedArray);
  }
  async getPatchLabel(req: BomProposalReq): Promise<CommonResponseModel> {
    const destinations = await this.destinationsRepo.find({
      select: ["destination", "geoCode"],
    });

    const poBomData = await this.poBomRepo.getProposalsDataForButton(req);
    const groupSet = [];
    const imItemColorSet = new Map<string, string>();
    const imCOlorSet = new Map<string, string>();

    const groupedData: any = poBomData.reduce(
      (result, currentItem: BomProposalDataModel) => {
        const {
          styleNumber,
          imCode,
          bomQty,
          description,
          use,
          itemNo,
          itemId,
          destination,
          size,
          poNumber,
          gender,
          season,
          year,
          color,
          itemColor,
          attribute,
          attributeValue,
          productCode,
          bQty,
          poQty,
          wastage,
          consumption,
          combination,
          poAndLine,
          vendorName, orderForm
        } = currentItem;
        // console.log(season)
        const bomGeoCode = destinations.find(
          (v) => v.destination == destination
        );
        const { geoCode } = bomGeoCode;
        const key = `${styleNumber}-${imCode}-${itemNo}`;
        const imItemColorKey = `${styleNumber + imCode}`;
        //  console.log(imItemColorSet)
        if (!imItemColorSet.has(imItemColorKey)) {
          imItemColorSet.set(imItemColorKey, itemColor);
        } else {
          let currentItemColorA = imItemColorSet.get(imItemColorKey);
          if (!currentItemColorA.split(",").includes(itemColor)) {
            currentItemColorA = currentItemColorA + ("," + itemColor);
          }
          imItemColorSet.set(imItemColorKey, currentItemColorA);
        }
        //--------------------//
        if (!imCOlorSet.has(imItemColorKey)) {
          imCOlorSet.set(imItemColorKey, color + "-" + combination);
        } else {
          let currentItemColor = imCOlorSet.get(imItemColorKey);
          if (
            !currentItemColor.split(",").includes(color + "-" + combination)
          ) {
            currentItemColor =
              currentItemColor + ("," + color + "-" + combination);
          }
          imCOlorSet.set(imItemColorKey, currentItemColor);
        }
        // console.log(imItemColorSet.get(styleNumber))
        //console.log(imCOlorSet.get(styleNumber))
        if (!result[key]) {
          result[key] = {
            geoCode,
            styleNumber,
            description,
            use,
            imCode,
            itemNo,
            bomQty: 0,
            destination,
            itemId,
            poNumber,
            gender,
            season,
            year,
            color,
            itemColor,
            productCode,
            bQty,
            poQty,
            attribute,
            attributeValue,
            wastage,
            consumption,
            combination,
            vendorName, orderForm,
            sizeWiseQty: [],
            // colorData: []
          };
        }
        const qtySumKey = `${poAndLine}-${size}-${imCode}`;
        if (!groupSet.includes(qtySumKey)) {
          groupSet.push(qtySumKey);
          result[key].bomQty += Number(bomQty);
        }
        result[key].itemColor = imItemColorSet.get(imItemColorKey);
        result[key].color = imCOlorSet.get(imItemColorKey);
        return result;
      },
      {}
    );
    // console.log(groupedData,'@@@@@@@@@@@@@@@')
    const groupedArray: any[] = Object.values(groupedData);
    return new CommonResponseModel(true, 11, "Data retreived", groupedArray);
  }
  async getProposalForCartonBox(
    req: BomProposalReq
  ): Promise<CommonResponseModel> {
    const destinations = await this.destinationsRepo.find({
      select: ["destination", "geoCode"],
    });

    const poBomZfactorData = await this.poBomRepo.getZfactorsDataForCartonBox(
      req
    );
    // console.log(poBomZfactorData,"poBomZfactorData")
    const groupedData: any = poBomZfactorData.reduce(
      (result, currentItem: BomProposalDataModel) => {
        const {
          styleNumber,
          bomQty,
          itemNo,
          itemId,
          destination,
          poNumber,
          poAndLine,
          gender,
          season,
          year,
          color,
          itemColor,
          ogacDate,
          attribute,
          attributeValue,
          gacDate,
          productCode,
          bQty,
          plant,
          poQty,
          factory,
          itemVasText,
          cartonCode,
          noOfPcsPerCarton,
          poLineItemNumber,
          cabCode,
        } = currentItem;
        const bomGeoCode = destinations.find(
          (v) => v.destination == destination
        );

        let key = `${poAndLine}`;
        if (!result[key]) {
          result[key] = {
            styleNumber,
            itemNo,
            bomQty: 0,
            itemId,
            poNumber,
            gender,
            season,
            year,
            color,
            itemColor,
            productCode,
            bQty,
            poQty: 0,
            attribute,
            attributeValue,
            plant,
            factory,
            ogacDate,
            gacDate,
            destination,
            poAndLine,
            itemVasText,
            cartonCode: cartonCode ? cartonCode : "Factory to Advise",
            poLineItemNumber,
            cabCode,
            noOfPcsPerCarton: "",
          };
        }
        result[key].noOfPcsPerCarton += noOfPcsPerCarton + ",";
        result[key].bomQty += Number(bomQty);
        result[key].poQty += Number(poQty);
        return result;
      },
      {}
    );
    const groupedArray: any[] = Object.values(groupedData);
    return new CommonResponseModel(true, 11, "Data retreived", groupedArray);
  }

  async generateGSISticker(req: BomProposalReq): Promise<CommonResponseModel> {
    const destinations = await this.destinationsRepo.find({
      select: ["destination", "geoCode"],
    });
    const poBomData = await this.poBomRepo.getZfactorsData(req);

    const groupedData: any = poBomData.reduce(
      (result, currentItem: BomProposalDataModel) => {
        const {
          styleNumber,
          imCode,
          bomQty,
          poQty,
          description,
          use,
          itemNo,
          consumption,
          itemId,
          destination,
          size,
          poNumber,
          gender,
          season,
          year,
          color,
          itemColor,
          productCode,
          uom,
          styleName,
        } = currentItem;

        let key = `${styleNumber}-${itemNo}`;

        if (!result[key]) {
          result[key] = {
            styleNumber,
            description,
            poQty,
            use,
            imCode,
            itemNo,
            bomQty: 0,
            destination,
            styleName,
            consumption,
            itemId,
            poNumber,
            gender,
            season,
            year,
            color,
            itemColor,
            productCode,
            uom,
          };
        }
        result[key].bomQty += Number(bomQty);

        return result;
      },
      {}
    );
    const groupedArray: any[] = Object.values(groupedData);
    return new CommonResponseModel(true, 1, "Data Retrived", groupedArray);
  }

  async generateProposalForElasticTrim(
    req: BomProposalReq
  ): Promise<CommonResponseModel> {
    const poBomData = await this.poBomRepo.getProposalsDataForElastic(req);
    const groupedData: any = poBomData.reduce(
      (result, currentItem: BomProposalDataModel) => {
        const {
          styleNumber,
          imCode,
          bomQty,
          description,
          use,
          itemNo,
          poQty,
          combination,
          itemId,
          uom,
          totalGarmentQty,
          poNumber,
          attributeValue,
          gender,
          season,
          year,
          color,
          itemColor,
          productCode,
          consumption,
        } = currentItem;
        const key = `${styleNumber}-${imCode}-${itemNo}-${itemColor}`;

        if (!result[key]) {
          result[key] = {
            styleNumber,
            description,
            use,
            imCode,
            itemNo,
            itemId,
            poNumber,
            bomQty: 0,
            poQty: 0,
            gender,
            season,
            year,
            color,
            productCode,
            uom,
            consumption,
            attributeValue,
            colors: [],
            itemColor,
          };
        }

        const key2 = `${imCode}-${color}-${itemColor}`; // Unique combination key
        const existingColor = result[key].colors.findIndex(
          (c: any) => c.key === key
        );
        if (existingColor == -1) {
          result[key].colors.push({
            key: key2,
            color,
            itemColor,
            poQty: 0,
            bomQty: 0,
            combination,
          });
        }
        const existingColorIndex2 = result[key].colors.findIndex(
          (c: any) => c.key === key2
        );
        result[key].colors[existingColorIndex2].poQty += poQty;
        result[key].colors[existingColorIndex2].bomQty += Number(bomQty);

        result[key].bomQty = (result[key].bomQty || 0) + Number(bomQty);
        result[key].poQty += poQty;
        // console.log(key,result[key])
        return result;
      },
      {}
    );
    const groupedArray: any[] = Object.values(groupedData);
    return new CommonResponseModel(true, 1, "Data Retrieved", groupedArray);
  }

  async generateProposalForZipperTrim(
    req: BomProposalReq
  ): Promise<CommonResponseModel> {
    const sizeOrder = [
      "XS",
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL",
      "5XL",
      "S-S",
      "M-S",
      "L-S",
      "XL-S",
      "2XS",
      "2XL-S",
      "3XL-S",
      "4XL-S",
      "5XL-S",
      "S-T",
      "M-T",
      "L-T",
      "XL-T",
      "2XL-T",
      "3XL-T",
      "4XL-T",
      "5XL-T",
      "STT",
      "MTT",
      "LTT",
      "XLTT",
      "2XLT",
    ];
    const destinations = await this.destinationsRepo.find({
      select: ["destination", "geoCode"],
    });
    const poBomData = await this.poBomRepo.getProposalsDataForZipper(req);
    const groupedData: any = poBomData.reduce(
      (result, currentItem: BomProposalDataModel) => {
        const {
          styleNumber,
          imCode,
          bomQty,
          description,
          use,
          itemNo,
          poQty,
          combination,
          itemId,
          uom,
          totalGarmentQty,
          poNumber,
          gender,
          season,
          year,
          color,
          itemColor,
          productCode,
          consumption,
          size,
          zipperConsumption,
        } = currentItem;

        const key = `${styleNumber}-${imCode}-${itemNo}`;

        if (!result[key]) {
          result[key] = {
            styleNumber,
            description,
            use,
            imCode,
            itemNo,
            bomQty: 0,
            itemId,
            poNumber,
            gender,
            season,
            year,
            color,
            itemColor,
            combination,
            productCode,
            uom,
            consumption,
            colors: [],
          };
        }

        const key2 = `${combination}`;
        // console.log(result[key]["colors"])
        const existingColorIndex = result[key].colors.findIndex(
          (c: any) => c.key === key2
        );

        const parsedBomQty = Number(bomQty);
        if (existingColorIndex === -1) {
          result[key].colors.push({
            key: key2,
            color,
            itemColor,
            combination,
            sizes: [
              {
                size,
                poQty,
                bomQty: parsedBomQty,
                combination,
                zipperConsumption,
              },
            ],
          });
        } else {
          const existingSizeIndex = result[key].colors[
            existingColorIndex
          ].sizes.findIndex((s: any) => s.size === size);
          if (existingSizeIndex === -1) {
            result[key].colors[existingColorIndex].sizes.push({
              size,
              poQty,
              bomQty: parsedBomQty,
              combination,
              zipperConsumption,
            });
          } else {
            result[key].colors[existingColorIndex].sizes[
              existingSizeIndex
            ].poQty += poQty;
            result[key].colors[existingColorIndex].sizes[
              existingSizeIndex
            ].bomQty += parsedBomQty;
            result[key].colors[existingColorIndex].sizes.sort(
              (a: any, b: any) => {
                return sizeOrder.indexOf(a.size) - sizeOrder.indexOf(b.size);
              }
            );
          }
        }

        return result;
      },
      {}
    );
    const groupedArray: any[] = Object.values(groupedData);
    return new CommonResponseModel(true, 1, "Data Retrieved", groupedArray);
  }

  async getAllStylesdynamic(): Promise<CommonResponseModel> {
    const query = `select distinct style from styles`;

    const data = await this.bomRepo.query(query);
    if (data.length) {
      return new CommonResponseModel(true, 1, "data retrived", data);
    } else {
      return new CommonResponseModel(false, 0, "error");
    }
  }

  async getConsumptionFromBOM(
    req: StyleAndTrimReq
  ): Promise<CommonResponseModel> {
    const data = await this.bomRepo.getConsumptionFromBOM(req);
    return new CommonResponseModel(true, 0, "Data retreived sucessfully", data);
  }

  async generateProposalForSnapButton(
    req: BomProposalReq
  ): Promise<CommonResponseModel> {
    const destinations = await this.destinationsRepo.find({
      select: ["destination", "geoCode"],
    });

    const poBomData = await this.poBomRepo.getProposalsDataForButton(req);

    let comboSet = [];
    let conctaedColor = "";
    const groupedData: any = poBomData.reduce(
      (result, currentItem: BomProposalDataModel, currentIndex) => {
        const {
          styleNumber,
          imCode,
          bomQty,
          description,
          use,
          itemNo,
          itemId,
          destination,
          size,
          poNumber,
          poAndLine,
          gender,
          season,
          year,
          color,
          itemColor,
          opUom,
          attribute,
          attributeValue,
          productCode,
          bQty,
          poQty,
          combination,
        } = currentItem;
        // console.log(season)
        const bomGeoCode = destinations.find(
          (v) => v.destination == destination
        );
        const { geoCode } = bomGeoCode;

        let previousColor;
        let sum = 0;
        if (previousColor !== null && itemColor !== previousColor) {
          conctaedColor += "," + (itemColor != null ? itemColor : "");
        }
        previousColor = itemColor;
        let key = `${styleNumber}-${imCode}-${itemNo}`;
        let comboKey = `${poAndLine}-${size}`;
        if (!result[key]) {
          //  console.log(key);
          result[key] = {
            geoCode,
            styleNumber,
            description,
            use,
            imCode,
            itemNo,
            bomQty: 0,
            destination,
            itemId,
            poNumber,
            gender,
            season,
            year,
            color,
            itemColor: "",
            productCode,
            bQty,
            poQty,
            attribute,
            attributeValue,
            combination,
            opUom,
            sizeWiseQty: [],
            // colorData: []
          };
        }
        // console.log(result[key])
        //  console.log(comboKey);
        if (!comboSet.includes(comboKey)) {
          comboSet.push(comboKey);
          result[key].bomQty += Number(bomQty);
        }
        result[key].itemColor = conctaedColor;

        return result;
      },
      {}
    );
    // console.log(groupedData,'@@@@@@@@@@@@@@@')
    const groupedArray: any[] = Object.values(groupedData);
    return new CommonResponseModel(true, 11, "Data retreived", groupedArray);
  }

  async generateProposalForJocktage(
    req: BomProposalReq
  ): Promise<CommonResponseModel> {
    const destinations = await this.destinationsRepo.find({
      select: ["destination", "geoCode"],
    });
    const poBomData = await this.poBomRepo.generateGSISticker(req);

    const groupedData: any = poBomData.reduce(
      (result, currentItem: BomProposalDataModel) => {
        const {
          styleNumber,
          imCode,
          bomQty,
          poQty,
          description,
          use,
          itemNo,
          consumption,
          itemId,
          destination,
          size,
          poNumber,
          gender,
          season,
          year,
          color,
          itemColor,
          productCode,
          uom,
          styleName,
        } = currentItem;
        const bomGeoCode = destinations.find(
          (v) => v.destination == destination
        );
        const { geoCode } = bomGeoCode;
        let key = `${styleNumber}-${imCode}-${itemNo}`;

        if (!result[key]) {
          result[key] = {
            year,
            geoCode,
            styleNumber,
            description,
            poQty,
            use,
            imCode,
            itemNo,
            bomQty: 0,
            destination,
            styleName,
            consumption,
            itemId,
            poNumber,
            gender,
            season,
            color,
            itemColor,
            productCode,
            uom,
          };
        }
        result[key].bomQty += Number(bomQty);

        return result;
      },
      {}
    );
    const groupedArray: any[] = Object.values(groupedData);
    return new CommonResponseModel(true, 1, "Data Retrived", groupedArray);
  }

  async generateProposalForCountrySticker(
    req: BomProposalReq
  ): Promise<CommonResponseModel> {
    const destinations = await this.destinationsRepo.find({
      select: ["destination", "geoCode"],
    });
    const poBomData = await this.poBomRepo.getZfactorsData(req);
    const groupedData: any = poBomData.reduce(
      (result, currentItem: BomProposalDataModel) => {
        const {
          styleNumber,
          imCode,
          bomQty,
          poQty,
          description,
          use,
          itemNo,
          consumption,
          itemId,
          destination,
          size,
          poNumber,
          gender,
          season,
          year,
          color,
          itemColor,
          productCode,
          uom,
          styleName,
        } = currentItem;
        const bomGeoCode = destinations.find(
          (v) => v.destination == destination
        );
        const { geoCode } = bomGeoCode;
        let key = `${styleNumber}-${itemNo}-${destination}`;

        if (!result[key]) {
          result[key] = {
            year: year,
            geoCode,
            styleNumber,
            description,
            poQty,
            use,
            imCode,
            itemNo,
            bomQty: 0,
            destination,
            styleName,
            consumption,
            itemId,
            poNumber,
            gender,
            season,
            color,
            itemColor,
            productCode,
            uom: uom,
          };
        }
        result[key].bomQty += Number(bomQty);

        return result;
      },
      {}
    );
    const groupedArray: any[] = Object.values(groupedData);
    return new CommonResponseModel(true, 1, "Data Retrived", groupedArray);
  }

  async generateProposalForSwoosh(
    req: BomProposalReq
  ): Promise<CommonResponseModel> {
    const destinations = await this.destinationsRepo.find({
      select: ["destination", "geoCode"],
    });

    const poBomData = await this.poBomRepo.getProposalsDataForButton(req);
    // const poBomZfactorData = await this.poBomRepo.getZfactorsData(req)
    // console.log(poBomData, '---po bom  data')
    let data = [...poBomData];
    const groupedData: any = poBomData.reduce(
      (result, currentItem: BomProposalDataModel) => {
        const {
          styleNumber,
          imCode,
          bomQty,
          description,
          use,
          itemNo,
          itemId,
          destination,
          size,
          poNumber,
          gender,
          season,
          year,
          color,
          itemColor,
          opUom,
          attribute,
          attributeValue,
          productCode,
          bQty,
          poQty,
          combination,
        } = currentItem;
        // console.log(season)
        const bomGeoCode = destinations.find(
          (v) => v.destination == destination
        );
        const { geoCode } = bomGeoCode;
        //let key = `${styleNumber}-${imCode}-${itemNo}-${color}-${itemColor}`;

        let key = `${color}-${itemColor}`;

        if (!result[key]) {
          result[key] = {
            geoCode,
            styleNumber,
            description,
            use,
            imCode,
            itemNo,
            bomQty: 0,
            destination,
            itemId,
            poNumber,
            gender,
            season,
            year,
            color,
            itemColor,
            productCode,
            bQty,
            poQty,
            attribute,
            attributeValue,
            combination,
            opUom,
            sizeWiseQty: [],

            // colorData: []
          };
        }

        const sizeIndex = result[key]["sizeWiseQty"].findIndex(
          (v) => v.size === size
        );
        if (sizeIndex >= 0) {
          result[key]["sizeWiseQty"][sizeIndex].qty += Number(bomQty);
        } else {
          result[key].sizeWiseQty.push({ size, qty: Number(bomQty) });
        }
        result[key].bomQty += Number(bomQty);
        //   console.log(result,"result")
        return result;
      },
      {}
    );

    const groupedArray: any[] = Object.values(groupedData);
    return new CommonResponseModel(true, 11, "Data retreived", groupedArray);
  }

  async generateProposalForSpareButtonLabel(
    req: BomProposalReq
  ): Promise<CommonResponseModel> {
    const destinations = await this.destinationsRepo.find({
      select: ["destination", "geoCode"],
    });

    const poBomData = await this.poBomRepo.getProposalsDataForButton(req);
    // const poBomZfactorData = await this.poBomRepo.getZfactorsData(req)
    // console.log(poBomData, '---po bom  data')
    const styleMap = new Map<string, string>();
    const groupedData: any = poBomData.reduce(
      (result, currentItem: BomProposalDataModel) => {
        const {
          styleNumber,
          imCode,
          bomQty,
          description,
          use,
          itemNo,
          itemId,
          destination,
          size,
          poNumber,
          gender,
          season,
          year,
          color,
          itemColor,
          opUom,
          attribute,
          attributeValue,
          productCode,
          bQty,
          poQty,
          combination,
        } = currentItem;
        // console.log(season)
        const bomGeoCode = destinations.find(
          (v) => v.destination == destination
        );
        const { geoCode } = bomGeoCode;
        //let key = `${styleNumber}-${imCode}-${itemNo}-${color}-${itemColor}`;

        let key = `${itemNo}`;

        if (!result[key]) {
          result[key] = {
            geoCode,
            styleNumber,
            description,
            use,
            imCode,
            itemNo,
            bomQty: 0,
            destination,
            itemId,
            poNumber,
            gender,
            season,
            year,
            color,
            itemColor,
            productCode,
            bQty,
            poQty,
            attribute,
            attributeValue,
            combination,
            opUom,
            sizeWiseQty: [],

            // colorData: []
          };
        }
        result[key].bomQty += Number(bomQty);
        if (!styleMap.has(itemNo)) {
          styleMap.set(itemNo, styleNumber);
        } else {
          let currentStyles = styleMap.get(itemNo);
          if (!currentStyles.split(",").includes(styleNumber)) {
            currentStyles = currentStyles + ("," + styleNumber);
          }
          styleMap.set(itemNo, currentStyles);
        }
        result[key].styleNumber = styleMap.get(key);
        //   console.log(result,"result")
        return result;
      },
      {}
    );

    const groupedArray: any[] = Object.values(groupedData);
    return new CommonResponseModel(true, 11, "Data retreived", groupedArray);
  }

  async generateProposalForMobillionTape(
    req: BomProposalReq
  ): Promise<CommonResponseModel> {
    const destinations = await this.destinationsRepo.find({
      select: ["destination", "geoCode"],
    });
    const styleMap = new Map<string, string>();
    const poBomData = await this.poBomRepo.generateProposalForMobillionTape(
      req
    );

    const groupedData: any = poBomData.reduce(
      (result, currentItem: BomProposalDataModel) => {
        const {
          styleNumber,
          imCode,
          bomQty,
          teflonSheetSize,
          description,
          use,
          itemNo,
          itemId,
          destination,
          size,
          poNumber,
          gender,
          season,
          year,
          color,
          itemColor,
          productCode,
          uom,
          consumption,
          poQty,
          opUom,
        } = currentItem;
        // console.log(season)
        const bomGeoCode = destinations.find(
          (v) => v.destination == destination
        );
        const { geoCode } = bomGeoCode;
        const key = `${itemNo}`;

        if (!result[key]) {
          result[key] = {
            geoCode,
            consumption,
            styleNumber,
            description,
            use,
            imCode,
            teflonSheetSize,
            itemNo,
            bomQty: 0,
            destination,
            itemId,
            poNumber,
            gender,
            season,
            year,
            color,
            itemColor,
            productCode,
            uom,
            poQty: 0,
            opUom,
          };
        }
        result[key].bomQty += Number(bomQty);
        result[key].poQty += Number(poQty);
        if (!styleMap.has(itemNo)) {
          styleMap.set(itemNo, styleNumber);
        } else {
          let currentStyles = styleMap.get(itemNo);
          if (!currentStyles.split(",").includes(styleNumber)) {
            currentStyles = currentStyles + ("," + styleNumber);
          }
          styleMap.set(itemNo, currentStyles);
        }
        result[key].styleNumber = styleMap.get(key);
        return result;
      },
      {}
    );
    const groupedArray: any[] = Object.values(groupedData);
    return new CommonResponseModel(true, 11, "Data retreived", groupedArray);
  }

  async getMainWovenLableData1(
    req: BomProposalReq
  ): Promise<CommonResponseModel> {
    const destinations = await this.destinationsRepo.find({
      select: ["destination", "geoCode"],
    });
    const styleSetS = new Map<string, string>();
    const styleSetT = new Map<string, string>();
    const styleSetTT = new Map<string, string>();
    const styleSetG = new Map<string, string>();

    const seasonSetS = new Map<string, string>();
    const seasonSetT = new Map<string, string>();
    const seasonSetTT = new Map<string, string>();
    const seasonSetG = new Map<string, string>();

    const poBomData = await this.poBomRepo.getProposalsDataForButton(req);

    const groupedData: any = {
      generalSize: {},
      tSizes: {},
      sSizes: {},
    };
    poBomData.forEach((currentItem: BomProposalDataModel) => {
      const {
        styleNumber,
        imCode,
        bomQty,
        itemNo,
        poNumber,
        gender,
        season,
        year,
        color,
        itemColor,
        productCode,
        bQty,
        poQty,
        size,
      } = currentItem;

      const bomGeoCode = destinations.find(
        (v) => v.destination == currentItem.destination
      );
      const { geoCode } = bomGeoCode;

      const key = `${imCode}-${itemNo}`;
      const sizeQty = { size, qty: Number(bomQty) };
      if (size.includes("-T")) {
        if (!groupedData["tSizes"][key]) {
          groupedData["tSizes"][key] = {
            styleNumber,
            imCode,
            itemNo,
            bomQty: 0,
            poNumber,
            gender,
            season,
            year,
            color,
            itemColor,
            productCode,
            bQty,
            poQty,
            sizeWiseQty: [],
          };
        }
        if (!styleSetT.has(key)) {
          styleSetT.set(key, styleNumber);
        } else {
          let curItem = styleSetT.get(key);
          curItem = curItem + ("," + styleNumber);
          styleSetT.set(key, curItem);
        }
        if (!seasonSetT.has(key)) {
          seasonSetT.set(key, season + "'" + String(year).substring(2));
        } else {
          let curItem = seasonSetT.get(key);
          curItem =
            curItem + ("," + (season + "'" + String(year).substring(2)));
          seasonSetT.set(key, curItem);
        }
        groupedData["tSizes"][key].bomQty += Number(bomQty);
        groupedData["tSizes"][key].styleNumber = styleSetT.get(key);
        groupedData["tSizes"][key].season = seasonSetT.get(key);
        const existingSize = groupedData["tSizes"][key].sizeWiseQty.find(
          (sizeObj) => sizeObj.size === sizeQty.size
        );
        if (existingSize) {
          existingSize.qty += sizeQty.qty;
        } else {
          groupedData["tSizes"][key].sizeWiseQty.push(sizeQty);
        }
      } else if (size.includes("-S")) {
        if (!groupedData["sSizes"][key]) {
          groupedData["sSizes"][key] = {
            styleNumber,
            imCode,
            itemNo,
            bomQty: 0,
            poNumber,
            gender,
            season,
            year,
            color,
            itemColor,
            productCode,
            bQty,
            poQty,
            attribute: currentItem.attribute,
            attributeValue: currentItem.attributeValue,
            sizeWiseQty: [],
          };
        }
        if (!styleSetS.has(key)) {
          styleSetS.set(key, styleNumber);
        } else {
          let curItem = styleSetS.get(key);
          curItem = curItem + ("," + styleNumber);
          styleSetS.set(key, curItem);
        }
        if (!seasonSetS.has(key)) {
          seasonSetS.set(key, season + "'" + String(year).substring(2));
        } else {
          let curItem = seasonSetS.get(key);
          curItem =
            curItem + ("," + (season + "'" + String(year).substring(2)));
          seasonSetS.set(key, curItem);
        }
        groupedData["sSizes"][key].bomQty += Number(bomQty);
        groupedData["sSizes"][key].styleNumber = styleSetS.get(key);
        groupedData["sSizes"][key].season = seasonSetS.get(key);

        const existingSize = groupedData["sSizes"][key].sizeWiseQty.find(
          (sizeObj) => sizeObj.size === sizeQty.size
        );

        if (existingSize) {
          existingSize.qty += sizeQty.qty;
        } else {
          groupedData["sSizes"][key].sizeWiseQty.push(sizeQty);
        }
      } else if (size.includes("TT")) {
        if (!groupedData["ttSizes"][key]) {
          groupedData["ttSizes"][key] = {
            styleNumber,
            imCode,
            itemNo,
            bomQty: 0,
            poNumber,
            gender,
            season,
            year,
            color,
            itemColor,
            productCode,
            bQty,
            poQty,
            sizeWiseQty: [],
          };
        }

        const existingSize = groupedData["ttSizes"][key].sizeWiseQty.find(
          (sizeObj) => sizeObj.size === sizeQty.size
        );

        if (existingSize) {
          existingSize.qty += sizeQty.qty;
        } else {
          groupedData["ttSizes"][key].sizeWiseQty.push(sizeQty);
        }
        if (!styleSetTT.has(key)) {
          styleSetTT.set(key, styleNumber);
        } else {
          let curItem = styleSetTT.get(key);
          curItem = curItem + ("," + styleNumber);
          styleSetTT.set(key, curItem);
        }
        if (!seasonSetTT.has(key)) {
          seasonSetTT.set(key, season + "'" + String(year).substring(2));
        } else {
          let curItem = seasonSetTT.get(key);
          curItem =
            curItem + ("," + (season + "'" + String(year).substring(2)));
          seasonSetTT.set(key, curItem);
        }
        // groupedData['generalSize'][key].sizeWiseQty.push(sizeQty);
        groupedData["ttSizes"][key].bomQty += Number(bomQty);
        groupedData["ttSizes"][key].styleNumber = styleSetTT.get(key);
        groupedData["ttSizes"][key].season = seasonSetTT.get(key);
      } else {
        if (!groupedData["generalSize"][key]) {
          groupedData["generalSize"][key] = {
            styleNumber,
            imCode,
            itemNo,
            bomQty: 0,
            poNumber,
            gender,
            season,
            year,
            color,
            itemColor,
            productCode,
            bQty,
            poQty,
            sizeWiseQty: [],
          };
        }

        const existingSize = groupedData["generalSize"][key].sizeWiseQty.find(
          (sizeObj) => sizeObj.size === sizeQty.size
        );

        if (existingSize) {
          existingSize.qty += sizeQty.qty;
        } else {
          groupedData["generalSize"][key].sizeWiseQty.push(sizeQty);
        }
        if (!styleSetG.has(key)) {
          styleSetG.set(key, styleNumber);
        } else {
          let curItem = styleSetG.get(key);
          curItem = curItem + ("," + styleNumber);
          styleSetG.set(key, curItem);
        }
        if (!seasonSetG.has(key)) {
          seasonSetG.set(key, season + "'" + String(year).substring(2));
        } else {
          let curItem = seasonSetG.get(key);
          curItem =
            curItem + ("," + (season + "'" + String(year).substring(2)));
          seasonSetG.set(key, curItem);
        }
        // groupedData['generalSize'][key].sizeWiseQty.push(sizeQty);
        groupedData["generalSize"][key].bomQty += Number(bomQty);
        groupedData["generalSize"][key].styleNumber = styleSetG.get(key);
        groupedData["generalSize"][key].season = seasonSetG.get(key);
      }
    });
    const groupedArray = Object.values(groupedData);
    const groupedArray2 = groupedArray.map((v) => Object.values(v));
    return new CommonResponseModel(true, 11, "Data retrieved", groupedArray2);
  }

  async generateProposalForTwilltape(
    req: BomProposalReq
  ): Promise<CommonResponseModel> {
    const destinations = await this.destinationsRepo.find({
      select: ["destination", "geoCode"],
    });

    const poBomData = await this.poBomRepo.getProposalsDataForButton(req);
    const groupSet = [];
    const imCOlorSet = new Map<string, string>();
    const itemSet = new Map<string, string>();
    const groupedData: any = poBomData.reduce(
      (result, currentItem: BomProposalDataModel) => {
        const {
          styleNumber,
          imCode,
          bomQty,
          description,
          use,
          itemNo,
          itemId,
          destination,
          size,
          poNumber,
          gender,
          season,
          year,
          color,
          itemColor,
          attribute,
          attributeValue,
          productCode,
          bQty,
          poQty,
          wastage,
          consumption,
          combination,
          poAndLine,
          opUom,
          bomId,
        } = currentItem;
        // console.log(season)
        const bomGeoCode = destinations.find(
          (v) => v.destination == destination
        );
        const { geoCode } = bomGeoCode;
        let key = `${styleNumber}-${itemNo}-${imCode}-${itemColor}`;
        const key2 = `${styleNumber}-${imCode}-${itemNo}-${itemColor}`;
        //  console.log(imItemColorSet)
        if (!itemSet.has(key2)) {
          itemSet.set(key2, itemNo);
        } else {
          let curItem = itemSet.get(key2);
          curItem = curItem + ("," + itemNo);
          itemSet.set(key2, curItem);
        }

        //--------------------//
        if (!imCOlorSet.has(key2)) {
          imCOlorSet.set(key2, combination);
        } else {
          let currentItemColor = imCOlorSet.get(key2);
          currentItemColor = currentItemColor + ("," + combination);
          imCOlorSet.set(key2, currentItemColor);
        }
        // console.log(imItemColorSet.get(styleNumber))
        //console.log(imCOlorSet.get(styleNumber))
        if (!result[key]) {
          result[key] = {
            geoCode,
            styleNumber,
            description,
            use,
            imCode,
            itemNo,
            bomQty: 0,
            destination,
            itemId,
            poNumber,
            gender,
            season,
            year,
            color,
            itemColor,
            productCode,
            bQty,
            poQty,
            attribute,
            attributeValue,
            wastage,
            consumption,
            combination,
            sizeWiseQty: [],
            opUom,
            // colorData: []
          };
        }
        const qtySumKey = `${poAndLine}-${size}`;
        if (!groupSet.includes(qtySumKey)) {
          groupSet.push(qtySumKey);
          result[key].bomQty += Number(bomQty);
        }
        result[key].color = imCOlorSet.get(key2);
        return result;
      },
      {}
    );
    // console.log(groupedData,'@@@@@@@@@@@@@@@')
    const groupedArray: any[] = Object.values(groupedData);
    return new CommonResponseModel(true, 11, "Data retreived", groupedArray);
  }

  async generateInterlining(req: BomProposalReq): Promise<CommonResponseModel> {
    const poBomData = await this.poBomRepo.generateInterlining(req);

    const groupedData: any = poBomData.reduce(
      (result, currentItem: BomProposalDataModel) => {
        const {
          styleNumber,
          imCode,
          bomQty,
          poQty,
          description,
          use,
          itemNo,
          itemId,
          destination,
          size,
          poNumber,
          gender,
          season,
          year,
          color,
          itemColor,
          productCode,
          uom,
          combination,
          consumption,
        } = currentItem;

        let key = `${styleNumber}-${imCode}-${itemNo}-${itemColor}`;
        if (!result[key]) {
          result[key] = {
            styleNumber,
            description,
            poQty,
            use,
            imCode,
            itemNo,
            bomQty: 0,
            destination,
            itemId,
            poNumber,
            gender,
            season,
            year,
            color,
            itemColor,
            productCode,
            uom,
            combination,
            consumption,
          };
        }
        result[key].bomQty += Number(bomQty);

        return result;
      },
      {}
    );
    const groupedArray: any[] = Object.values(groupedData);
    return new CommonResponseModel(
      true,
      1,
      "Data Retrived for Interlining",
      groupedArray
    );
  }

  async getSizeHtLabelData(req: BomProposalReq): Promise<CommonResponseModel> {
    try {
      const destinations = await this.destinationsRepo.find({
        select: ["destination", "geoCode"],
      });

      const teeData = await this.poBomRepo.getProposalsDataForTeeStyle(req);
      const poloData = await this.poBomRepo.getProposalsDataForPoloStyle(req);

      const groupedTeeData: any = teeData.reduce(
        (result, currentItem: BomProposalDataModel) => {
          const {
            styleNumber,
            imCode,
            bomQty,
            description,
            use,
            itemNo,
            itemId,
            destination,
            size,
            poNumber,
            gender,
            season,
            year,
            color,
            itemColor,
            productCode,
            combination,
            fabricCode,
            fabricCombination,
            fabricContent,
            fit,
          } = currentItem;
          const bomGeoCode = destinations.find(
            (v) => v.destination == destination
          );
          let htStyle;
          const { geoCode } = bomGeoCode;
          // console.log(combination, itemColor)
          const key = `${styleNumber}-${imCode}-${itemNo}-${color}-${itemColor}`;
          const hueCode = currentItem.combination;
          let htLebleColors;
          if (!result[key]) {
            result[key] = {
              fabricCode,
              fabricCombination,
              fabricContent,
              fit,
              htStyle,
              geoCode,
              styleNumber,
              description,
              use,
              imCode,
              itemNo,
              bomQty: 0,
              destination,
              itemId,
              poNumber,
              gender,
              season,
              year,
              color,
              itemColor,
              productCode,
              combination,
              sizeWiseQty: [],
              tSizeArray: [],
              htLebleColors: "",
            };
          }
          const sizeIndex = result[key]["sizeWiseQty"].findIndex(
            (v) => v.size === size
          );
          const TsizeIndex = result[key]["tSizeArray"].findIndex(
            (v) => v.size === size
          );

          if (!size.includes("-") && !size.endsWith("TT")) {
            if (sizeIndex >= 0) {
              result[key]["sizeWiseQty"][sizeIndex].qty += Number(bomQty);
            } else {
              result[key].sizeWiseQty.push({ size, qty: Number(bomQty) });
            }
          }
          if (size.endsWith("TT") || size.includes("-")) {
            if (sizeIndex >= 0) {
              result[key]["tSizeArray"][TsizeIndex].qty += Number(bomQty);
            } else {
              result[key].tSizeArray.push({ size, qty: Number(bomQty) });
            }
          }

          // if (hueCode != null) {
          //     if (hueCode.startsWith("1") || hueCode.startsWith("7") || hueCode == "051") {
          //         htLebleColors = "GCW#3 PMSCG6C"
          //     }
          //     else {
          //         htLebleColors = "GCW#2 White";
          //     }
          // }

          result[key].htLebleColors = itemColor;
          result[key].bomQty += Number(bomQty);
          return result;
        },
        {}
      );
      const consolidateSizes = (array) => {
        const consolidated = array
          .reduce((acc, item) => {
            const existing = acc.find((v) => v.size === item.size);
            if (existing) {
              existing.qty += item.qty;
            } else {
              acc.push({ ...item });
            }
            return acc;
          }, [])
          .map((item) => ({
            ...item,
            qty: Math.ceil(item.qty),
          }));
        return consolidated;
      };

      for (let key in groupedTeeData) {
        groupedTeeData[key].tSizeArray = consolidateSizes(
          groupedTeeData[key].tSizeArray
        );
      }
      Object.values(groupedTeeData).forEach((item: any) => {
        if (item.tSizeArray.length > 0) {
          const totalQty = item.tSizeArray.reduce(
            (acc: number, cur: any) => acc + Math.ceil(cur.qty),
            0
          );
          item.tSizeArray.push({ size: "TOTAL", qty: totalQty });
        }
      });

      Object.values(groupedTeeData).forEach((item: any) => {
        if (item.sizeWiseQty.length > 0) {
          const totalQty = item.sizeWiseQty.reduce(
            (acc: number, cur: any) => acc + Math.ceil(cur.qty),
            0
          );
          item.sizeWiseQty.push({ size: "TOTAL", qty: totalQty });
        }
      });
      const groupedTeeArray: any[] = Object.values(groupedTeeData);

      const groupedPoloData: any = poloData.reduce(
        (result, currentItem: BomProposalDataModel) => {
          const {
            styleNumber,
            imCode,
            bomQty,
            description,
            use,
            itemNo,
            itemId,
            destination,
            size,
            poNumber,
            gender,
            season,
            year,
            color,
            itemColor,
            productCode,
            combination,
            fabricCode,
            fabricCombination,
            fabricContent,
            fit,
          } = currentItem;
          const bomGeoCode = destinations.find(
            (v) => v.destination == destination
          );
          const { geoCode } = bomGeoCode;
          const key = `${styleNumber}-${imCode}-${itemNo}-${color}-${itemColor}`;
          if (!result[key]) {
            result[key] = {
              fabricCode,
              fabricCombination,
              fabricContent,
              fit,
              geoCode,
              styleNumber,
              description,
              use,
              imCode,
              itemNo,
              bomQty: 0,
              destination,
              itemId,
              poNumber,
              gender,
              season,
              year,
              color,
              itemColor,
              productCode,
              combination,
              teeStyelArray: [],
              poloStyleArray: [],
              sizeWiseQty: [],
              extraSizeWiseQty: [],
              tSizeArray: [],
            };
          }
          const sizeIndex = result[key]["sizeWiseQty"].findIndex(
            (v) => v.size === size
          );
          if (size.includes("-")) {
            if (sizeIndex >= 0) {
              result[key]["extraSizeWiseQty"][sizeIndex].qty += Number(bomQty);
            } else {
              result[key].extraSizeWiseQty.push({ size, qty: Number(bomQty) });
            }
          }
          if (size.endsWith("TT")) {
            if (sizeIndex >= 0) {
              result[key]["tSizeArray"][sizeIndex].qty += Number(bomQty);
            } else {
              result[key].tSizeArray.push({ size, qty: Number(bomQty) });
            }
          } else {
            if (sizeIndex >= 0) {
              result[key]["sizeWiseQty"][sizeIndex].qty += Number(bomQty);
            } else {
              result[key].sizeWiseQty.push({ size, qty: Number(bomQty) });
            }
          }

          result[key].bomQty += Number(bomQty);
          return result;
        },
        {}
      );
      const groupedPoloArray: any[] = Object.values(groupedPoloData);
      const obj = { teeStyle: groupedTeeArray, poloStyle: groupedPoloArray };
      return new CommonResponseModel(true, 1, "Data retrived", obj);
    } catch (err) {
      throw err;
    }
  }
  async getStylesAndImsForSelectedItems(
    req: SelectedItemsDto
  ): Promise<CommonResponseModel> {
    const data = await this.poBomRepo.getStylesAndImsForSelectedItems(req);
    return new CommonResponseModel(true, 1111, "data retreived", data);
  }

  async generateForbackingPaper(
    req: BomProposalReq
  ): Promise<CommonResponseModel> {
    const poBomData = await this.poBomRepo.generateForbackingPaper(req);
    const groupedData: any = poBomData.reduce(
      (result, currentItem: BomProposalDataModel) => {
        const {
          styleNumber,
          imCode,
          bomQty,
          poQty,
          description,
          use,
          itemNo,
          itemId,
          destination,
          size,
          poNumber,
          gender,
          season,
          year,
          color,
          itemColor,
          productCode,
          uom,
          combination,
          consumption,
          nonWovenColor,
          bvCombination,
        } = currentItem;

        const itemColor1 = itemColor ? itemColor : nonWovenColor;
        let key = `${styleNumber}-${imCode}-${itemNo}-${itemColor1}`;
        if (!result[key]) {
          result[key] = {
            styleNumber,
            description,
            poQty,
            use,
            imCode,
            itemNo,
            bomQty: 0,
            destination,
            itemId,
            poNumber,
            gender,
            season,
            year,
            color: "",
            itemColor: itemColor1,
            productCode,
            uom,
            combination,
            consumption,
            nonWovenColor,
            bvCombination,
          };
        }
        result[key].bomQty += Number(bomQty);
        result[key].color += color + "-" + combination + ",";
        return result;
      },
      {}
    );
    const groupedArray: any[] = Object.values(groupedData);
    return new CommonResponseModel(
      true,
      1,
      "Data Retrived for Interlining",
      groupedArray
    );
  }

  async generatePRoposalForSizeHt(req: BomProposalReq) {
    const styleSetS = new Map<string, string>();
    const styleSetT = new Map<string, string>();
    const styleSetTT = new Map<string, string>();
    const styleSetG = new Map<string, string>();

    const seasonSetS = new Map<string, string>();
    const seasonSetT = new Map<string, string>();
    const seasonSetTT = new Map<string, string>();
    const seasonSetG = new Map<string, string>();

    const combinationsSetS = new Map<string, string>();
    const combinationsSetT = new Map<string, string>();
    const combinationsSetTT = new Map<string, string>();
    const combinationsSetG = new Map<string, string>();

    const poBomData = await this.poBomRepo.generatePRoposalForSizeHt(req);
    function getColorForTeeAndPolo(
      styleName: string,
      combination: string,
      itemColor: string,
      htColor: string
    ) {
      // console.log(combination, combination[0], 'combination')
      // console.log(styleName, 'style name')
      if (styleName.includes("POLO")) return itemColor;
      return htColor;
      // if (combination[0] == "7" || combination[0] == "1") return "GCW#3 PMSCG6C"
      // if (combination[0] == "1") return "GCW#3 PMSCG6C"
      // return "GCW#2 White"
    }
    const groupedData: any = {
      generalSize: {},
      tSizes: {},
      sSizes: {},
      ttSizes: {},
    };
    poBomData.forEach((currentItem: BomProposalDataModel) => {
      const {
        styleNumber,
        imCode,
        bomQty,
        itemNo,
        poNumber,
        gender,
        season,
        year,
        color,
        itemColor,
        productCode,
        bQty,
        poQty,
        size,
        styleName,
        combination,
        fabricCode,
        fabricContent,
        fit,
        htColor,
      } = currentItem;
      // console.log(productCode)
      const deriviedItemColor = getColorForTeeAndPolo(
        styleName,
        combination,
        itemColor,
        htColor
      );
      const key = `${imCode}-${itemNo}-${deriviedItemColor}`;
      const sizeQty = { size, qty: Number(bomQty) };
      if (size.includes("-T")) {
        if (!groupedData["tSizes"][key]) {
          groupedData["tSizes"][key] = {
            styleNumber,
            imCode,
            itemNo,
            bomQty: 0,
            poNumber,
            gender,
            season,
            year,
            color,
            itemColor: deriviedItemColor,
            productCode,
            bQty,
            poQty,
            combination,
            sizeWiseQty: [],
            fabricCode,
            fabricContent,
            fit,
          };
        }
        if (!styleSetT.has(key)) {
          styleSetT.set(key, styleNumber);
        } else {
          let curItem = styleSetT.get(key);
          curItem = curItem + ("," + styleNumber);
          styleSetT.set(key, curItem);
        }
        if (!seasonSetT.has(key)) {
          seasonSetT.set(key, season + "'" + String(year).substring(2));
        } else {
          let curItem = seasonSetT.get(key);
          curItem =
            curItem + ("," + (season + "'" + String(year).substring(2)));
          seasonSetT.set(key, curItem);
        }
        if (!combinationsSetT.has(key)) {
          combinationsSetT.set(key, combination);
        } else {
          let curItem = combinationsSetT.get(key);
          curItem = curItem + ("," + combination);
          combinationsSetT.set(key, curItem);
        }
        groupedData["tSizes"][key].bomQty += Number(bomQty);
        groupedData["tSizes"][key].styleNumber = styleSetT.get(key);
        groupedData["tSizes"][key].season = seasonSetT.get(key);
        groupedData["tSizes"][key].combination = combinationsSetT.get(key);

        const existingSize = groupedData["tSizes"][key].sizeWiseQty.find(
          (sizeObj) => sizeObj.size === sizeQty.size
        );
        if (existingSize) {
          existingSize.qty += sizeQty.qty;
        } else {
          groupedData["tSizes"][key].sizeWiseQty.push(sizeQty);
        }
      } else if (size.includes("-S")) {
        if (!groupedData["sSizes"][key]) {
          groupedData["sSizes"][key] = {
            styleNumber,
            imCode,
            itemNo,
            bomQty: 0,
            poNumber,
            gender,
            season,
            year,
            color,
            itemColor: deriviedItemColor,
            productCode,
            bQty,
            poQty,
            combination,
            sizeWiseQty: [],
            fabricCode,
            fabricContent,
            fit,
          };
        }
        if (!styleSetS.has(key)) {
          styleSetS.set(key, styleNumber);
        } else {
          let curItem = styleSetS.get(key);
          curItem = curItem + ("," + styleNumber);
          styleSetS.set(key, curItem);
        }
        if (!seasonSetS.has(key)) {
          seasonSetS.set(key, season + "'" + String(year).substring(2));
        } else {
          let curItem = seasonSetS.get(key);
          curItem =
            curItem + ("," + (season + "'" + String(year).substring(2)));
          seasonSetS.set(key, curItem);
        }
        if (!combinationsSetS.has(key)) {
          combinationsSetS.set(key, combination);
        } else {
          let curItem = combinationsSetS.get(key);
          curItem = curItem + ("," + combination);
          combinationsSetS.set(key, curItem);
        }
        groupedData["sSizes"][key].bomQty += Number(bomQty);
        groupedData["sSizes"][key].styleNumber = styleSetS.get(key);
        groupedData["sSizes"][key].season = seasonSetS.get(key);
        groupedData["sSizes"][key].combination = combinationsSetS.get(key);

        const existingSize = groupedData["sSizes"][key].sizeWiseQty.find(
          (sizeObj) => sizeObj.size === sizeQty.size
        );

        if (existingSize) {
          existingSize.qty += sizeQty.qty;
        } else {
          groupedData["sSizes"][key].sizeWiseQty.push(sizeQty);
        }
      } else if (size.includes("TT")) {
        if (!groupedData["ttSizes"][key]) {
          groupedData["ttSizes"][key] = {
            styleNumber,
            imCode,
            itemNo,
            bomQty: 0,
            poNumber,
            gender,
            season,
            year,
            color,
            itemColor: deriviedItemColor,
            productCode,
            bQty,
            poQty,
            combination,
            sizeWiseQty: [],
            fabricCode,
            fabricContent,
            fit,
          };
        }

        const existingSize = groupedData["ttSizes"][key].sizeWiseQty.find(
          (sizeObj) => sizeObj.size === sizeQty.size
        );

        if (existingSize) {
          existingSize.qty += sizeQty.qty;
        } else {
          groupedData["ttSizes"][key].sizeWiseQty.push(sizeQty);
        }
        if (!styleSetTT.has(key)) {
          styleSetTT.set(key, styleNumber);
        } else {
          let curItem = styleSetTT.get(key);
          curItem = curItem + ("," + styleNumber);
          styleSetTT.set(key, curItem);
        }
        if (!seasonSetTT.has(key)) {
          seasonSetTT.set(key, season + "'" + String(year).substring(2));
        } else {
          let curItem = seasonSetTT.get(key);
          curItem =
            curItem + ("," + (season + "'" + String(year).substring(2)));
          seasonSetTT.set(key, curItem);
        }
        if (!combinationsSetTT.has(key)) {
          combinationsSetTT.set(key, combination);
        } else {
          let curItem = combinationsSetTT.get(key);
          curItem = curItem + ("," + combination);
          combinationsSetTT.set(key, curItem);
        }
        // groupedData['generalSize'][key].sizeWiseQty.push(sizeQty);
        groupedData["ttSizes"][key].bomQty += Number(bomQty);
        groupedData["ttSizes"][key].styleNumber = styleSetTT.get(key);
        groupedData["ttSizes"][key].season = seasonSetTT.get(key);
        groupedData["ttSizes"][key].combination = combinationsSetTT.get(key);
      } else {
        if (!groupedData["generalSize"][key]) {
          groupedData["generalSize"][key] = {
            styleNumber,
            imCode,
            itemNo,
            bomQty: 0,
            poNumber,
            gender,
            season,
            year,
            color,
            itemColor: deriviedItemColor,
            productCode,
            bQty,
            poQty,
            combination,
            sizeWiseQty: [],
            fabricCode,
            fabricContent,
            fit,
          };
        }

        const existingSize = groupedData["generalSize"][key].sizeWiseQty.find(
          (sizeObj) => sizeObj.size === sizeQty.size
        );

        if (existingSize) {
          existingSize.qty += sizeQty.qty;
        } else {
          groupedData["generalSize"][key].sizeWiseQty.push(sizeQty);
        }
        if (!styleSetG.has(key)) {
          styleSetG.set(key, styleNumber);
        } else {
          let curItem = styleSetG.get(key);
          curItem = curItem + ("," + styleNumber);
          styleSetG.set(key, curItem);
        }
        if (!seasonSetG.has(key)) {
          seasonSetG.set(key, season + "'" + String(year).substring(2));
        } else {
          let curItem = seasonSetG.get(key);
          curItem =
            curItem + ("," + (season + "'" + String(year).substring(2)));
          seasonSetG.set(key, curItem);
        }
        if (!combinationsSetG.has(key)) {
          combinationsSetG.set(key, combination);
        } else {
          let curItem = combinationsSetG.get(key);
          curItem = curItem + ("," + combination);
          combinationsSetG.set(key, curItem);
        }
        // groupedData['generalSize'][key].sizeWiseQty.push(sizeQty);
        groupedData["generalSize"][key].bomQty += Number(bomQty);
        groupedData["generalSize"][key].styleNumber = styleSetG.get(key);
        groupedData["generalSize"][key].season = seasonSetG.get(key);
        groupedData["generalSize"][key].combination = combinationsSetG.get(key);
      }
    });
    const groupedArray = Object.values(groupedData);
    const groupedArray2 = groupedArray.map((v) => Object.values(v));
    return new CommonResponseModel(true, 11, "Data retrieved", groupedArray2);
  }

  async getBomAndImsForSelectedItems(
    req: SelectedItemsDto
  ): Promise<CommonResponseModel> {
    const data = await this.poBomRepo.getBomAndImsForSelectedItems(req);
    return new CommonResponseModel(true, 1111, "data retreived", data);
  }
  async getStylefromBom(): Promise<CommonResponseModel> {
    const data = await this.styleRepo.getStylefroData();
    return new CommonResponseModel(true, 1111, "data retreived", data);
  }
  async getSeasonfromBom(): Promise<CommonResponseModel> {
    const data = await this.styleRepo.getSeasonsData();
    return new CommonResponseModel(true, 1111, "data retreived", data);
  }
  async getYearfromBom(): Promise<CommonResponseModel> {
    const data = await this.styleRepo.getYearData();
    return new CommonResponseModel(true, 1111, "data retreived", data);
  }

  async updateStyle(req: StyleBomDto): Promise<StylesResponseModel> {
    try {
      const existingStyles = await this.styleRepo.find({
        where: { id: Not(req.styleId) },
      });
      for (const style of existingStyles) {
        if (style.style === req.style) {
          throw new ErrorResponse(99999, "Style already existed");
        }
      }

      const styleToUpdate = await this.styleRepo.findOne({
        where: { id: req.styleId },
      });
      if (!styleToUpdate) {
        throw new ErrorResponse(99998, "Style not found");
      }

      styleToUpdate.style = req.style;
      styleToUpdate.styleName = req.styleName;
      styleToUpdate.season = req.season;
      styleToUpdate.mscLevelOne = req.msc;
      styleToUpdate.year = req.year;
      styleToUpdate.kimbleSize = req.kimbleSize;
      if (req.styleType) {
        styleToUpdate.styleType = req.styleType;
      }
      if (req.isFleece) {
        styleToUpdate.isFleece = req.isFleece;
      }
      await this.styleRepo.save(styleToUpdate);
      return new StylesResponseModel(true, 200, "Updated Data Successfully");
    } catch (err) {
      throw err;
    }
  }

  async updateBomTable(req: BomMasterDto): Promise<BomResponseModel> {
    try {
      const dataToUpdate = await this.bomRepo.findOne({
        where: { id: req.bomId },
      });
      if (!dataToUpdate) {
        throw new ErrorResponse(99998, "Bom data not found");
      }

      dataToUpdate.itemName = req.itemName;
      dataToUpdate.imCode = req.imCode;
      dataToUpdate.description = req.description;
      dataToUpdate.sequence = req.sequence;
      if (req.vendorName) {
        dataToUpdate.vendorName = req.vendorName;
      }
      if (req.orderForm) {
        dataToUpdate.orderForm = req.orderForm;
      }
      this.bomRepo.save(dataToUpdate);
      return new BomResponseModel(true, 200, "Updated Bom Data Successfully");
    } catch (err) {
      throw err;
    }
  }

  async updateStyleCombo(
    req: StyleComboMasterDto
  ): Promise<StylesComboResponseModel> {
    try {
      // console.log(req, "req at the services");
      const dataToUpdate = await this.styleComboRepo.findOne({
        where: { id: req.styleComboid },
      });
      if (!dataToUpdate) {
        throw new ErrorResponse(99998, "Bom data not found");
      }
      dataToUpdate.primaryColor = req.primaryColor;
      dataToUpdate.combination = req.combination;
      dataToUpdate.itemColor = req.itemColor;

      await this.styleComboRepo.save(dataToUpdate);

      return new StylesComboResponseModel(
        true,
        200,
        "Updated Style Combo Successfully"
      );
    } catch (err) {
      throw err;
    }
  }

  async getSizeHtMatrixData(): Promise<CommonResponseModel> {
    let query = `SELECT id , im_code AS imCode , fit ,style ,ht_color AS htColor , fabric_code AS fabricCode , fabric_content AS fabricContent 
        ,fabric_combinations AS fabricCombinations ,version_flag AS versionFlag ,is_active AS isActive FROM sizeht_matrix `;
    const data = await this.styleComboRepo.query(query);
    return new CommonResponseModel(true, 0, "No data found to update", data);
  }
  async getImcodesFromBOm(): Promise<CommonResponseModel> {
    const data = await this.bomRepo.getImcodeForSIZEMatrixData();
    return new CommonResponseModel(true, 0, "No data found to update", data);
  }

  async generateProposalForJokerTag(
    req: BomProposalReq
  ): Promise<CommonResponseModel> {
    const destinations = await this.destinationsRepo.find({
      select: ["destination", "geoCode"],
    });

    const poBomData = await this.poBomRepo.getProposalsData(req);
    const poBomZfactorData = await this.poBomRepo.getZfactorsData(req);
    const sortData = [...poBomData, ...poBomZfactorData];
    const data = sortData.sort((a, b) => a.sequence - b.sequence);

    const imCodeRegionMap = new Map<string, Set<string>>();

    // Separate arrays for APA and non-APA regions
    const groupedData = data.reduce(
      (result, currentItem: BomProposalDataModel, i, arr) => {
        const {
          styleNumber,
          imCode,
          bomQty,
          description,
          use,
          itemNo,
          itemId,
          destination,
          size,
          poNumber,
          gender,
          season,
          year,
          ogacDate,
          shipToNumber,
          dpomId,
        } = currentItem;

        const bomGeoCode = destinations.find(
          (v) => v.destination === destination
        );
        const { geoCode } = bomGeoCode || { geoCode: "NA" }; // Default geoCode to 'NA' if not found

        let key = `${itemNo}-${imCode}_${styleNumber}`;
        let imCodeKey = `${itemNo}-${imCode}`;

        if (!result[geoCode]) {
          result[geoCode] = {};
        }

        // Generate a unique key based on styleNumber and imCodes combination
        const imCodes = [imCode];
        let imCodeStyleKey = `${styleNumber}-${imCodes.sort().join(",")}`;

        if (!result[geoCode][key]) {
          result[geoCode][key] = {
            geoCode,
            styleNumber,
            description,
            use,
            imCode,
            itemNo,
            imCodes: [],
            bomQty: 0,
            destination,
            itemId,
            poNumber,
            gender,
            season,
            year,
            shipToNumber,
            sizeWiseQty: {
              isExist: false,
              imCodes: [],
              geoCodes: [],
              styles: [],
            },
            smallSizeWiseQty: {
              isExist: false,
              imCodes: [],
              geoCodes: [],
              styles: [],
            },
            tallSizeWiseQty: {
              isExist: false,
              imCodes: [],
              geoCodes: [],
              styles: [],
            },
            dpomIdSet: new Set(),
            geoCodes: new Set(),
            styles: new Set(),
          };
        }

        if (!imCodeRegionMap.has(imCodeKey)) {
          imCodeRegionMap.set(imCodeKey, new Set([imCode]));
        }
        imCodeRegionMap.get(imCodeKey).add(imCode);

        result[geoCode][key].geoCodes.add(geoCode);
        result[geoCode][key].styles.add(styleNumber);
        result[geoCode][key].imCodes = [
          ...Array.from(imCodeRegionMap.get(imCodeKey)),
        ];

        if (!result[geoCode][key].dpomIdSet.has(dpomId)) {
          result[geoCode][key].bomQty += Number(bomQty);
          result[geoCode][key].dpomIdSet.add(dpomId); // Mark dpomId as seen

          // Handling sizeWiseQty, smallSizeWiseQty, and tallSizeWiseQty
          let sizeWiseObject;
          if (size.includes("-S")) {
            sizeWiseObject = result[geoCode][key].smallSizeWiseQty;
          } else if (size.includes("-T")) {
            sizeWiseObject = result[geoCode][key].tallSizeWiseQty;
          } else {
            sizeWiseObject = result[geoCode][key].sizeWiseQty;
          }

          sizeWiseObject.isExist = true;
          if (!sizeWiseObject[size]) {
            sizeWiseObject[size] = 0;
          }
          sizeWiseObject[size] += Number(bomQty);

          sizeWiseObject.imCodes = Array.from(imCodeRegionMap.get(imCodeKey));
          sizeWiseObject.geoCodes = Array.from(result[geoCode][key].geoCodes);
          sizeWiseObject.styles = Array.from(result[geoCode][key].styles);
        }

        return result;
      },
      { APA: {}, NA: {}, EMEA: {}, AAO: {} } // Initialize with keys for each region type
    );

    // Convert groupedData into groupedArray
    const groupedArray: any[] = [];

    // Add APA regions first

    Object.keys(groupedData.APA).forEach((key) => {
      groupedArray.push(groupedData.APA[key]);
    });

    // Add NA, EMEA, and LA regions next
    ["NA", "EMEA", "AAO"].forEach((region) => {
      Object.keys(groupedData[region]).forEach((key) => {
        groupedArray.push(groupedData[region][key]);
      });
    });

    return new CommonResponseModel(true, 11, "Data retrieved", groupedArray);
  }

  async getStylesfromStyleTable(): Promise<CommonResponseModel> {
    const stylesData = await this.styleRepo.getAllStyels();
    if (stylesData.length) {
      return new CommonResponseModel(
        true,
        1111,
        "Date retreived sucessfully",
        stylesData
      );
    } else {
      return new CommonResponseModel(false, 1110, "No data found");
    }
  }

  async getCombinations(
    req?: SizeMatrixFabricCodeDto
  ): Promise<CommonResponseModel> {
    const stylesData = await this.styleRepo.getCombinations();
    if (stylesData.length) {
      return new CommonResponseModel(
        true,
        1111,
        "Date retreived sucessfully",
        stylesData
      );
    } else {
      return new CommonResponseModel(false, 1110, "No data found");
    }
  }

  async generateProposalForHangTag(
    req: BomProposalReq
  ): Promise<CommonResponseModel> {
    const destinations = await this.destinationsRepo.find({
      select: ["destination", "geoCode"],
    });

    const poBomData = await this.poBomRepo.getProposalsDataForHangtag(req);
    const poBomZfactorData = await this.poBomRepo.getZfactorsData(req);
    const sortData = [...poBomData, ...poBomZfactorData];
    const data = sortData.sort((a, b) => a.sequence - b.sequence);
    // console.log(data)
    let insertPresentFlag = false;
    const groupedData: any = data.reduce(
      (result, currentItem: BomProposalDataModel, currIndex, arr) => {
        const {
          styleNumber,
          imCode,
          bomQty,
          description,
          use,
          itemNo,
          itemId,
          destination,
          size,
          poNumber,
          gender,
          season,
          year,
          ogacDate,
          shipToNumber,
          dpomId,
          productName,
          plant,
        } = currentItem;
        const bomGeoCode = destinations.find(
          (v) => v.destination == destination
        );
        const { geoCode } = bomGeoCode;
        let tempImcode = imCode;
        let sizeGroup = "ALL";
        // imcodes to be get using queries in later implemenattion
        const doubleSidedIm = ["722460", "722459"];
        const foldedIms = [
          "722142",
          "722168",
          "722194",
          "722207",
          "722228",
          "722135",
          "722136",
          "722137",
          "722138",
          "722140",
        ];
        const looseFitIms = ["722882", "722904", "722921", "722929", "722936"];
        const overSizedFit = ["722889", "722913", "722924", "722931", "722938"];
        const driFitIms = ["726724", "726726", "726728", "726731", "726733"];
        const standardFitIms = [
          "726722",
          "726725",
          "726727",
          "726729",
          "726732",
        ];
        const chinaFleeceInsert = ["1028705"];
        const womensInsert = ["593516"];
        const koreanInsert = ["123608"];
        const thailandInsert = ["368494"];
        const otherInserts = ["655842", "593525", "1023951"];
        let tempGeoCode = geoCode;
        const dobuleTofoldedIms = {
          "722460": "722486",
          "722459": "722485",
        };
        // size insert logic

        if (
          doubleSidedIm.includes(imCode) &&
          (size.includes("-T") || size.includes("-S")) &&
          (productName.includes("TEE") ||
            productName.includes("POLO") ||
            productName.includes("HOODIE") ||
            productName.includes("CRW") ||
            productName.includes("CREW"))
        ) {
          tempImcode = dobuleTofoldedIms[imCode];
        }

        //country insert logic
        const countryInsertDestinations = ["Thailand", "South Korea", "China", "Argentina"];
        if (
          doubleSidedIm.includes(imCode) &&
          countryInsertDestinations.includes(destination)
        ) {
          if (destination == "China" && (plant == "1076" || plant == "1077")) {
            tempImcode = imCode;
          } else {
            tempImcode = dobuleTofoldedIms[imCode];
          }
        }
        if (destination == "China" && plant !== "1076" && plant !== "1077") {
          tempGeoCode = "China";
        }
        // }

        let category = "general";
        if (doubleSidedIm.includes(imCode)) {
          category = "doubleSidedIms";

        } else if (foldedIms.includes(imCode)) {
          category = "foldedIms";
        } else if (
          looseFitIms.includes(imCode) 
        ) {
          category = "looseFitIms";
          if (size.includes("-T")) {
            tempImcode = imCode + "/725946";
            sizeGroup = "TALL";
          }
          if (size.includes("-S")) {
            sizeGroup = "SMALL";
            tempImcode = imCode + "/725947";
          }
        } else if (
          overSizedFit.includes(imCode)
        ) {
          category = "overSizeFitIms";
          if (size.includes("-T")) {
            tempImcode = imCode + "/725946";
            sizeGroup = "TALL";
          }
          if (size.includes("-S")) {
            sizeGroup = "SMALL";
            tempImcode = imCode + "/725947";
          }
        } else if (driFitIms.includes(imCode)) {
          category = "driFitIms";
          if (size.includes("-T")) {
            tempImcode = imCode + "/725946";
            sizeGroup = "TALL";
          }
          if (size.includes("-S")) {
            sizeGroup = "SMALL";
            tempImcode = imCode + "/725947";
          }
        } else if (standardFitIms.includes(imCode)) {
          if (size.includes("-T")) {
            tempImcode = imCode + "/725946";
            sizeGroup = "TALL";
          }
          if (size.includes("-S")) {
            sizeGroup = "SMALL";
            tempImcode = imCode + "/725947";
          }
          category = "standardFitIms";
        } else if (womensInsert.includes(imCode)) {
          category = "womensInsert";
          insertPresentFlag = true;
          tempGeoCode = destination;
        } else if (chinaFleeceInsert.includes(imCode)) {
          insertPresentFlag = true;
          category = "chinaFleeceInsert";
          tempGeoCode = destination;
        } else if (koreanInsert.includes(imCode)) {
          insertPresentFlag = true;
          category = "koreanInsert";
          tempGeoCode = destination;
        } else if (thailandInsert.includes(imCode)) {
          insertPresentFlag = true;
          category = "thailandInsert";
          tempGeoCode = destination;
        } else if (otherInserts.includes(imCode)) {
          insertPresentFlag = true;
          category = "otherInserts";
        }
        // intilaize new empty object for each category
        if (!result[category]) {
          result[category] = {};
        }

        let key = `${itemNo}-${tempImcode}`;

        if (!result[category][key]) {
          result[category][key] = {
            geoCode: tempGeoCode,
            styleNumber,
            description,
            use,
            imCode: tempImcode,
            itemNo,
            bomQty: 0,
            destination,
            itemId,
            poNumber,
            gender,
            season,
            year,
            shipToNumber,
            sizeGroup,
          };
        }
        // console.log(styleNumber, bomQty, poNumber)
        result[category][key].bomQty += Number(bomQty);
        if (!result[category][key].styleNumber.includes(styleNumber)) {
          result[category][key].styleNumber += "/" + styleNumber;
        }

        if (!result[category][key].geoCode.includes(tempGeoCode)) {
          result[category][key].geoCode += "/" + tempGeoCode;
        }
        return result;
      },
      {}
    );

    // Flatten the groupedData object to an array
    const transformedData: any = {};
    for (const category in groupedData) {
      transformedData[category] = Object.values(groupedData[category]);
    }
    return new CommonResponseModel(true, 11, "Data retreived", transformedData);
  }

  async generateBomForThread(
    req: ThreadBomGenerationReq
  ): Promise<CommonResponseModel> {
    const transactionManager = new GenericTransactionManager(this.dataSource);
    await transactionManager.startTransaction();
    try {
      const { poLine, updatedSizes } = req;
      const poData = await this.dpomRepo.getPoDataForBomGeneration({ poLine });
      // console.log(poData.length, 'po data length')
      const destinations = await this.destinationsRepo.find({
        select: ["destination", "geoCode"],
      });
      const styleDataMap = new Map<string, BomDataForStyleAndSeasonModel[]>();
      const regionDataMap = new Map<
        string,
        { poData: PoDataForBomGenerationModel[]; totalQty: number }
      >();
      // moq logic for wash care label

      function getUpdatedQty(poLine: string, poQty) {
        if (updatedSizes.length) {
          const updatedSize = updatedSizes.find((u) => u.poLine == poLine);
          if (updatedSize) {
            return updatedSize.qty;
          }
        }
        return poQty;
      }

      const poBomEntities: PoBomEntity[] = [];

      poDataLoop: for (const po of poData) {
        let styleData: BomDataForStyleAndSeasonModel[] = [];
        if (!styleDataMap.has(po.styleNumber)) {
          styleData = await this.bomRepo.getTrimBomDataForStyleAndSeason({
            style: po.styleNumber,
            season: po.season,
            year: po.year,
            itemId: 9,
          });
          styleDataMap.set(po.styleNumber, styleData);
        } else {
          styleData = styleDataMap.get(po.styleNumber);
        }
        const updatedQty = getUpdatedQty(po.poLineNo, po.qty);
        for (const styleBom of styleData) {
          const poBomEntity = new PoBomEntity();
          const bom = new BomEntity();

          bom.id = styleBom.bomId;
          poBomEntity.bom = bom;
          poBomEntity.consumption = 1;
          poBomEntity.moq = 1;
          poBomEntity.wastage = 1;
          poBomEntity.bomQty = 0;
          poBomEntity.poQty = po.qty;
          poBomEntity.opUom = UOMEnum.PCS;
          poBomEntity.ipUom = UOMEnum.PCS;
          const dpom = new DpomEntity();
          dpom.id = po.id;
          poBomEntity.dpom = dpom;
          poBomEntities.push(poBomEntity);
          // await transactionManager.getRepository(PoBomEntity).insert(poBomEntity)
        }
      }

      for (const rec of poBomEntities) {
        const isBomRecExist = await this.poBomRepo.checkIfBomGenerated(
          rec.dpom.id,
          rec.bom ? rec.bom.id : null,
          rec.zFactorBom ? rec.zFactorBom.id : null
        );
        if (isBomRecExist) {
          await transactionManager
            .getRepository(PoBomEntity)
            .update({ id: isBomRecExist.id }, { ...rec });
        } else {
          await transactionManager.getRepository(PoBomEntity).insert(rec);
        }
      }

      await transactionManager.completeTransaction();
      if (poBomEntities.length) {
        return new CommonResponseModel(
          true,
          11111,
          "Bom generated sucessfully"
        );
      } else {
        return new CommonResponseModel(
          true,
          11111,
          "Bom not found for the selected item"
        );
      }
    } catch (err) {
      await transactionManager.releaseTransaction();
      throw err;
    }
  }

  async createBomFromForm(req: BomFormDto): Promise<CommonResponseModel> {
    try {
      const { imCode, itemName, description, sequence, styleId } = req;

      const existingRecordQuery = `
                SELECT COUNT(*) as count 
                FROM bom 
                WHERE im_code = ? AND item_id = ? AND description = ?
              `;
      const [result] = await this.bomRepo.query(existingRecordQuery, [
        imCode,
        itemName,
        description,
      ]);

      if (result.count > 0) {
        return new CommonResponseModel(
          false,
          400,
          "Record with this combination already exists"
        );
      }

      const insertQuery = `
                INSERT INTO bom (im_code, item_id, description, sequence, style_id)
                VALUES (?, ?, ?, ?, ?)
              `;
      await this.bomRepo.query(insertQuery, [
        imCode,
        itemName,
        description,
        sequence,
        styleId,
      ]);
      return new CommonResponseModel(true, 200, "Created Successfully");
    } catch (err) {
      console.error("Error creating BOM record:", err);
      return new CommonResponseModel(false, 500, "Internal Server Error");
    }
  }

  async getStylesForSelectedPos(
    req: SelectedItemsDto
  ): Promise<CommonResponseModel> {
    const data = await this.poBomRepo.getStylesForSelectedPos(req);
    return new CommonResponseModel(true, 1111, "data retreived", data);
  }

  async getItemsForSelectedPos(
    req: SelectedItemsDto
  ): Promise<CommonResponseModel> {
    const data = await this.poBomRepo.getItemsForSelectedPos(req);
    return new CommonResponseModel(true, 1111, "data retreived", data);
  }

  // async mainLabelextraction(req:BomProposalReq): Promise<any> {
  //     try{
  //     let response: CommonResponseModel;
  //     let data: any[] = [];
  //     response = await this.getMainWovenLableData(req);
  //     data = response.data;

  //     // const transactionManager = new GenericTransactionManager(this.dataSource);
  //     try {

  //         const url = 'http://165.22.220.143/bom/gtstoinfor/packages/services/common/src/assets/main-label.xlsx';

  //         const workbook = await this.readExcelFromUrl(url)
  //         const worksheet = workbook.getWorksheet(1);

  //         const firstTableStarting = 24;
  //         const secondTableStarting = 39;
  //         const thirdTableStarting = 54;

  //         let currentRow = firstTableStarting;
  //         worksheet.getRow(8).getCell(3).value = 'sizeItem.size';
  //         worksheet.getCell('H3').value = 'Akhil';
  //         data.forEach(item => {
  //             item.sizeWiseQty.forEach(sizeItem => {
  //                 worksheet.getRow(currentRow).getCell(8).value = sizeItem.size; // Adjust column index if needed
  //                 worksheet.getRow(currentRow).getCell(9).value = sizeItem.qty;
  //                 worksheet.getRow(currentRow).getCell(9).fill = {
  //                     type: 'pattern',
  //                     pattern: 'solid',
  //                     fgColor: { argb: '00FFFF' } // Aqua blue background color
  //                 };
  //                 currentRow++;
  //             });
  //         });

  //         currentRow = secondTableStarting;
  //         data.forEach(item => {
  //             item.TsizeWiseqty.forEach(sizeItem => {
  //                 worksheet.getRow(currentRow).g8etCell(9).value = sizeItem.size;
  //                 worksheet.getRow(currentRow).getCell(10).value = sizeItem.qty;
  //                 worksheet.getRow(currentRow).getCell(10).fill = {
  //                     type: 'pattern',
  //                     pattern: 'solid',
  //                     fgColor: { argb: '00FFFF' }
  //                 };
  //                 currentRow++;
  //             });
  //         });

  //         currentRow = thirdTableStarting;
  //         data.forEach(item => {
  //             item.SsizeWiseqty.forEach(sizeItem => {
  //                 worksheet.getRow(currentRow).getCell(9).value = sizeItem.size; // Adjust column index if needed
  //                 worksheet.getRow(currentRow).getCell(10).value = sizeItem.qty;
  //                 worksheet.getRow(currentRow).getCell(10).fill = {
  //                     type: 'pattern',
  //                     pattern: 'solid',
  //                     fgColor: { argb: '00FFFF' } // Aqua blue background color
  //                 };
  //                 currentRow++;
  //             });
  //         });

  //         const buffer = workbook.xlsx.writeBuffer();
  //         return buffer;

  //     }

  //     catch (error) {
  //         // await transactionManager.rollbackTransaction();
  //         throw new Error(`Error processing file: ${error.message}`);
  //     }}catch (error) {
  //         // await transactionManager.rollbackTransaction();
  //         // throw new Error(`Error processing file: ${error.message}`);
  //         return new CommonResponseModel(false,1200,'unable to process order forms')
  //     }
  // }

  async saveExcelFile(buffer: Buffer, filename: string) {
    const outputPath = path.join(__dirname, "..", "assets", filename);
    fs.writeFileSync(outputPath, buffer);
    return outputPath;
  }

  async readExcelFromUrl(url): Promise<any> {
    try {
      const response = await axios.get(url, { responseType: "arraybuffer" });

      const buffer = Buffer.from(response.data); // Create a buffer from the arraybuffer response

      const workbook = new ExcelJS.Workbook();
      await workbook.xlsx.load(buffer); // Load the buffer into the workbook

      workbook.worksheets.forEach((worksheet, index) => { });

      return workbook;
    } catch (error) {
      console.error("Error reading Excel file:", error);
      throw error;
    }
  }

  async bskOrderForm(req: BomProposalReq): Promise<any> {
    let response: CommonResponseModel;
    let data: any[] = [];
    switch (req.itemId[0]) {
      case 22:
        response = await this.generateProposalForButton(req);
        data = response.data;
        break;
      case 23:
        response = await this.generateProposalForNeckTape(req);
        data = response.data;
        break;
      case 53:
        response = await this.getPatchLabel(req);
        data = response.data;
        break;
      default:
        break;
    }
    try {
      const info = [
        {
          address:
            "Unit A1-06, 10th Floor, Hang Fung Industrial Building, Phase 1, No. 2G Hok Yuen Street, Hung Hom, Kowloon, Hong Kong.",
          buyerName: "NIKE",
          division: "",
          season: "",
          merchandiser: "SHOBHA",
          orderDate: "",
          orderBy: "Jas / Chandra",
          reqShipDate: "",
          style: "",
        },
      ];
      if (data.length > 0) {
        //Button trim 👇
        if (req.itemId[0] === 22) {
          try {
            //this are only used for local changes and local testing this process wont work for deployed code  so we use altenative method as url
            const folderPath = path.resolve(
              "packages",
              "services",
              "common",
              "src",
              "assets"
            );
            const fileName = "bsksource.xlsx";
            const filePath = path.join(folderPath, fileName);
            //this are only used for local changes and local testing this process wont work for deployed code  so we use altenative method as url
            //Method := File Path
            // const workbook = new ExcelJS.Workbook();
            // await workbook.xlsx.readFile(filePath);
            //this url is used for deployed code for local changes we can use file path method
            const url =
              "http://165.22.220.143/bom/gtstoinfor/dist/packages/services/common/assets/bsksource.xlsx";
            const workbook = await this.readExcelFromUrl(url);
            const worksheet = workbook.getWorksheet(1);
            const startingRow = 20;
            const filterDataByImCodes = (data, imCodes) => {
              return data.filter((item) => imCodes.includes(item.imCode));
            };
            const filteredData = filterDataByImCodes(data, req.imCodes);

            if (filteredData.length > 0) {
              worksheet.spliceRows(
                startingRow,
                0,
                ...new Array(filteredData.length).fill([])
              );
            }
            let totalBomQty = 0;
            interface ItemData {
              description: string;
              imCode: string;
              color: string;
              buttonSize: string;
              season: string;
              bomQty: number;
              unit: string;
              itemNo: string;
              styleNumber: string;
              year: string;
              combination: string;
              opUom: string;
              itemColor: string;
            }

            const groupedData: Record<string, ItemData[]> = filteredData.reduce(
              (acc: Record<string, ItemData[]>, item: ItemData) => {
                acc[item.itemNo] = acc[item.itemNo] || [];
                acc[item.itemNo].push(item);
                return acc;
              },
              {}
            );
            const uniqueStyles = [
              ...new Set(filteredData.map((item) => item.styleNumber)),
            ].join("/");
            const uniqueSeasons = [
              ...new Set(
                filteredData.map(
                  (item) => `${item.season}${item.year.slice(-2)}`
                )
              ),
            ].join("/");
            let currentRow = startingRow;
            Object.values(groupedData).forEach((group: ItemData[]) => {
              if (!group) throw Error("group not found");
              if (!group.length) throw Error("Group length less than 1");
              const groupSize = group.length;
              group.forEach((item, index) => {
                const rowIndex = currentRow + index;
                const row = worksheet.getRow(rowIndex);
                totalBomQty += Math.ceil(item.bomQty);
                row.getCell(4).value = item.imCode; // Column D
                //row.getCell(6).value = `${item.combination !== null ? item.combination : ''}-${item.color !== null ? item.color : ''}`;
                row.getCell(6).value = `${item.itemColor !== null ? item.itemColor : ""
                  }`;
                row.getCell(7).value = "18 L";
                row.getCell(8).value = `${item.season}${item.year.slice(-2)}`;
                row.getCell(9).value = item.itemNo;
                row.getCell(10).value = item.styleNumber;
                row.getCell(11).value = Math.ceil(item.bomQty);
                row.getCell(12).value = item.opUom;
                const sumRowIndex = currentRow + group.length;
                const sumRow = worksheet.getRow(sumRowIndex);
                sumRow.getCell(11).value = Math.ceil(totalBomQty);

                for (let col = 4; col <= 12; col++) {
                  const cell = row.getCell(col);
                  cell.border = {
                    top: { style: "thin" },
                    left: { style: "thin" },
                    bottom: { style: "thin" },
                    right: { style: "thin" },
                  };
                }

                // Set special fonts
                row.getCell(4).font = { name: "Calibri", size: 16 };
                row.getCell(6).font = { name: "Verdana", size: 12 };
                row.getCell(7).font = { name: "Calibri", size: 16 };
                row.getCell(8).font = { name: "Calibri", size: 16 };
                row.getCell(9).font = { name: "Calibri", size: 16 };
                row.getCell(10).font = { name: "Calibri", size: 16 };
                row.getCell(11).font = { name: "Verdana", size: 12 };
                row.getCell(12).font = {
                  name: "Verdana",
                  size: 12,
                  bold: true,
                };

                // Set Calibri 16 font and center alignment
                row.getCell(4).alignment = {
                  vertical: "middle",
                  horizontal: "center",
                };
                row.getCell(6).alignment = {
                  vertical: "middle",
                  horizontal: "center",
                  wrapText: true,
                };
                row.getCell(7).alignment = {
                  vertical: "middle",
                  horizontal: "center",
                };
                row.getCell(8).alignment = {
                  vertical: "middle",
                  horizontal: "center",
                };
                row.getCell(9).alignment = {
                  vertical: "middle",
                  horizontal: "center",
                };
                row.getCell(10).alignment = {
                  vertical: "middle",
                  horizontal: "center",
                };
                row.getCell(11).alignment = {
                  vertical: "middle",
                  horizontal: "center",
                };
                row.getCell(12).alignment = {
                  vertical: "middle",
                  horizontal: "center",
                };
              });

              if (groupSize > 1) {
                worksheet.mergeCells(
                  `I${currentRow}:I${currentRow + groupSize - 1}`
                );
                worksheet.mergeCells(
                  `J${currentRow}:J${currentRow + groupSize - 1}`
                );
              }

              currentRow += groupSize;
            });

            if (filteredData && filteredData.length > 0) {
              const endingRow = startingRow + filteredData.length - 1;

              worksheet.mergeCells(`G${startingRow}:G${endingRow}`);
              worksheet.mergeCells(`H${startingRow}:H${endingRow}`);
            }
            worksheet.unMergeCells(`B${startingRow}:C${startingRow}`);
            if (filteredData && filteredData.length > 0) {
              const endingRow = startingRow + filteredData.length + 3;
              if (Number(endingRow) - Number(startingRow) >= 14) {
                worksheet.mergeCells(`B${startingRow}:C33`);
                //temprory solution
                //  worksheet.unMergeCells(`B34:C${endingRow}`);
              } else {
                worksheet.mergeCells(`B${startingRow}:C${endingRow}`);
              }

              const mergedCell = worksheet.getCell(`B${startingRow}`);
              mergedCell.value = filteredData[0].description;

              mergedCell.alignment = {
                vertical: "middle",
                horizontal: "center",
                wrapText: true,
              };
              mergedCell.font = { name: "Calibri Light", size: 14 };
            } else {
              throw Error("Data not found");
            }
            const currentDate = new Date();
            const reShipDate = new Date();
            reShipDate.setDate(currentDate.getDate() + 14);

            worksheet.getCell("N9").value = currentDate.toLocaleDateString();
            worksheet.getCell("N10").value = `${info[0].orderBy}`;
            worksheet.getCell("N11").value = reShipDate.toLocaleDateString();

            worksheet.mergeCells("G9:H9");
            worksheet.getCell("G9").value = info[0].buyerName;
            worksheet.mergeCells("G10:H10");
            worksheet.getCell("G10").value = `SPORTSWEAR`;
            worksheet.mergeCells("G11:H11");
            worksheet.getCell("G11").value = uniqueSeasons;
            worksheet.getCell("G11").font = { name: "Calibri", size: 16 };
            worksheet.mergeCells("G12:H12");
            worksheet.getCell("G12").value = uniqueStyles;
            worksheet.getCell("G12").font = { name: "Calibri", size: 16 };
            worksheet.mergeCells("G13:H13");
            worksheet.getCell("G13").value = info[0].merchandiser;

            worksheet.mergeCells("B10:D13");
            worksheet.getCell("B10").value = info[0].address;
            worksheet.getCell(
              "B19"
            ).value = `Supplier:${filteredData[0].vendorName}`;
            worksheet.getCell("B19").font = {
              name: "Arial Narrow",
              size: 18,
              bold: true,
            };

            worksheet.getCell("B10").alignment = {
              vertical: "middle",
              horizontal: "center",
              wrapText: true,
            };
            worksheet.getCell("B10").font = {
              name: "Arial Narrow",
              size: 18,
              bold: true,
              color: { argb: "FFA04000" },
            };

            const cell = worksheet.getCell("B8:D13");
            cell.border = {
              top: { style: "thin" },
              left: { style: "thin" },
              right: { style: "thin" },
              bottom: { style: "thin" },
            };
            const cell1 = worksheet.getCell("B9:D13");
            cell1.border = {
              left: { style: "thin" },
              right: { style: "thin" },
            };
            const cell2 = worksheet.getCell("B10:D13");
            cell2.border = {
              left: { style: "thin" },
              bottom: { style: "thin" },
              right: { style: "thin" },
            };

            //2d table border
            const cell3 = worksheet.getCell("F8:H13");
            cell3.border = {
              left: { style: "thin" },
              right: { style: "thin" },
              top: { style: "thin" },
            };
            const cell4 = worksheet.getCell("F9:F13");
            cell4.border = {
              left: { style: "thin", bottom: { style: "thin" } },
            };
            const cell5 = worksheet.getCell("H9:H13");
            cell5.border = { right: { style: "thin" } };
            const cell6 = worksheet.getCell("F14");
            cell6.border = { top: { style: "thin" } };

            //  await workbook.xlsx.writeFile(outputFile);
            const buffer = workbook.xlsx.writeBuffer();

            return buffer;
          } catch (error) {
            // await transactionManager.rollbackTransaction();
            console.log(error);
            throw new Error(`Error processing file: ${error}`);
          }
        }
        //Neck tape 👇
        else if (req.itemId[0] === 23) {
          const folderPath = path.resolve(
            "packages",
            "services",
            "common",
            "src",
            "assets"
          );
          const fileName = "NeckTape.xlsx";
          const filePath = path.join(folderPath, fileName);
          const info = [
            {
              address:
                "Unit A1-06, 10th Floor, Hang Fung Industrial Building, Phase 1, No. 2G Hok Yuen Street, Hung Hom, Kowloon, Hong Kong.",
              buyerName: "NIKE",
              division: "",
              season: "",
              merchandiser: "SHOBHA",
              orderDate: "",
              orderBy: "Jas / Chandra",
              reqShipDate: "",
              style: "",
            },
          ];
          try {
            const filterDataByImCodes = (data, imCodes) => {
              return data.filter((item) => imCodes.includes(item.imCode));
            };

            const filteredData = filterDataByImCodes(data, req.imCodes);
            // this structured data is constructed here
            const transformedData = {
              data: filteredData.flatMap((item) =>
                item.colors.map((color) => ({
                  geoCode: item.geoCode,
                  styleNumber: item.styleNumber,
                  description: item.description,
                  use: item.use,
                  season: item.season,
                  year: item.year,
                  imCode: item.imCode,
                  itemNo: item.itemNo,
                  ...color,
                }))
              ),
            };
            // const workbook = new ExcelJS.Workbook();
            //  await workbook.xlsx.readFile(filePath);

            const url =
              "http://165.22.220.143/bom/gtstoinfor/dist/packages/services/common/assets/NeckTape.xlsx";
            const workbook = await this.readExcelFromUrl(url);
            const worksheet = workbook.getWorksheet(1);
            const startingRow = 20;

            if (transformedData.data.length > 0) {
              worksheet.spliceRows(
                startingRow,
                0,
                ...new Array(transformedData.data.length).fill([])
              );
            }

            let currentRow = startingRow;

            interface ItemData {
              description: string;
              imCode: string;
              key: string;
              color: string;
              itemColor: string;
              bomQty: number;
              combination: string;
              season: string;
              year: string;
              itemNo: string;
              styleNumber: string;
              opUom: string;
            }

            const groupedData: Record<string, ItemData[]> =
              transformedData.data.reduce(
                (acc: Record<string, ItemData[]>, item: ItemData) => {
                  acc[item.itemNo] = acc[item.itemNo] || [];
                  acc[item.itemNo].push(item);
                  return acc;
                },
                {}
              );

            const uniqueStyles = [
              ...new Set(filteredData.map((item) => item.styleNumber)),
            ].join("/");
            const uniqueSeasons = [
              ...new Set(
                filteredData.map(
                  (item) => `${item.season}${item.year.slice(-2)}`
                )
              ),
            ].join("/");

            let totalSum = 0;

            Object.values(groupedData).forEach((group: ItemData[]) => {
              const groupSize = group.length;
              let totalBomQty = 0; // Initialize totalBomQty for the current group

              group.forEach((item, index) => {
                const rowIndex = currentRow + index;
                const row = worksheet.getRow(rowIndex);
                row.getCell(4).value = item.imCode;
                //row.getCell(7).value = '18 L';
                row.getCell(8).value = `${item.season}${item.year.slice(-2)}`;
                row.getCell(9).value = item.itemNo;
                row.getCell(10).value = item.styleNumber;

                //  row.getCell(6).value = `${item.combination}-${item.color}`;
                row.getCell(6).value = `${item.itemColor}`;

                row.getCell(11).value = Math.ceil(item.bomQty);
                row.getCell(12).value = `YARDS`;

                totalBomQty += Math.ceil(item.bomQty);
                totalSum += Math.ceil(item.bomQty); // Accumulate total sum

                for (let col = 4; col <= 12; col++) {
                  const cell = row.getCell(col);
                  cell.border = {
                    top: { style: "thin" },
                    left: { style: "thin" },
                    bottom: { style: "thin" },
                    right: { style: "thin" },
                  };

                  row.getCell(4).font = { name: "Calibri", size: 16 };
                  row.getCell(6).font = { name: "Verdana", size: 12 };
                  row.getCell(7).font = { name: "Calibri", size: 16 };
                  row.getCell(8).font = { name: "Calibri", size: 16 };
                  row.getCell(9).font = { name: "Calibri", size: 16 };
                  row.getCell(10).font = { name: "Calibri", size: 16 };
                  row.getCell(11).font = { name: "Verdana", size: 12 };
                  row.getCell(12).font = {
                    name: "Verdana",
                    size: 12,
                    bold: true,
                  };

                  // Set Calibri 16 font and center alignment
                  row.getCell(4).alignment = {
                    vertical: "middle",
                    horizontal: "center",
                  };
                  row.getCell(6).alignment = {
                    vertical: "middle",
                    horizontal: "center",
                    wrapText: true,
                  };
                  row.getCell(7).alignment = {
                    vertical: "middle",
                    horizontal: "center",
                  };
                  row.getCell(8).alignment = {
                    vertical: "middle",
                    horizontal: "center",
                  };
                  row.getCell(9).alignment = {
                    vertical: "middle",
                    horizontal: "center",
                  };
                  row.getCell(10).alignment = {
                    vertical: "middle",
                    horizontal: "center",
                  };
                  row.getCell(11).alignment = {
                    vertical: "middle",
                    horizontal: "center",
                  };
                  row.getCell(12).alignment = {
                    vertical: "middle",
                    horizontal: "center",
                  };
                }
              });
              // Merge cells for itemNo and styleNumber columns if there is more than one item in the group
              if (groupSize > 1) {
                worksheet.mergeCells(
                  `I${currentRow}:I${currentRow + groupSize - 1}`
                );
                worksheet.mergeCells(
                  `J${currentRow}:J${currentRow + groupSize - 1}`
                );
              }

              currentRow += groupSize; // Move to the next row after processing the current group
            });
            if (transformedData.data && transformedData.data.length > 0) {
              const endingRow = startingRow + transformedData.data.length - 1;

              worksheet.mergeCells(`G${startingRow}:G${endingRow}`);
              worksheet.mergeCells(`H${startingRow}:H${endingRow}`);

              const mergedCell = worksheet.getCell(`B${startingRow}`);
              mergedCell.value = transformedData.data[0].description;

              mergedCell.alignment = {
                vertical: "middle",
                horizontal: "center",
                wrapText: true,
              };
              mergedCell.font = { name: "Calibri Light", size: 14 };
            }
            if (transformedData.data && transformedData.data.length > 0) {
              const endingRow = startingRow + transformedData.data.length + 3;
              // worksheet.mergeCells(`B${startingRow}:C${endingRow}`);
              if (Number(endingRow) - Number(startingRow) >= 14) {
                worksheet.mergeCells(`B${startingRow}:C33`);
                //temprory solution
                //  worksheet.unMergeCells(`B34:C${endingRow}`);
                //  worksheet.mergeCells(`B34:C${endingRow}`);
              } else {
                worksheet.mergeCells(`B${startingRow}:C${endingRow}`);
              }
              const mergedCell = worksheet.getCell(`B${startingRow}`);
              mergedCell.value = transformedData.data[0].description;

              mergedCell.alignment = {
                vertical: "middle",
                horizontal: "center",
                wrapText: true,
              };
              mergedCell.font = { name: "Calibri Light", size: 14 };
            }

            // if (transformedData.data.length > 0) {
            //     const endingRow = startingRow + transformedData.data.length - 1;

            //     worksheet.mergeCells(`B${startingRow}:C${endingRow + 2}`);
            //     worksheet.mergeCells(`G${startingRow}:G${endingRow}`);
            //     worksheet.mergeCells(`H${startingRow}:H${endingRow}`);

            //     const mergedCell = worksheet.getCell(`B${startingRow}`);
            //     mergedCell.value = transformedData.data[0].description;
            //     mergedCell.alignment = { vertical: 'middle', horizontal: 'center', wrapText: true };
            //     mergedCell.font = { name: 'Calibri Light', size: 14 };
            // }

            // Add the total sum row at the end of the data
            const totalSumRowIndex = startingRow + transformedData.data.length;
            const totalSumRow = worksheet.getRow(totalSumRowIndex);
            totalSumRow.getCell(11).value = Math.ceil(totalSum);

            //staring 3 tables
            const currentDate = new Date();
            const reShipDate = new Date();
            reShipDate.setDate(currentDate.getDate() + 14);

            worksheet.getCell("N9").value = currentDate.toLocaleDateString();
            worksheet.getCell("N10").value = `${info[0].orderBy}`;
            worksheet.getCell("N11").value = reShipDate.toLocaleDateString();

            worksheet.mergeCells("G9:H9");
            worksheet.getCell("G9").value = info[0].buyerName;
            worksheet.mergeCells("G10:H10");
            worksheet.getCell("G10").value = `SPORTSWEAR`;
            worksheet.mergeCells("G11:H11");
            worksheet.getCell("G11").value = uniqueSeasons;
            worksheet.getCell("G11").font = { name: "Calibri", size: 16 };
            worksheet.mergeCells("G12:H12");
            worksheet.getCell("G12").value = uniqueStyles;
            worksheet.getCell("G12").font = { name: "Calibri", size: 16 };
            worksheet.mergeCells("G13:H13");
            worksheet.getCell("G13").value = info[0].merchandiser;

            worksheet.mergeCells("B10:D13");
            worksheet.getCell("B10").value = info[0].address;
            worksheet.getCell(
              "B19"
            ).value = `Supplier:${filteredData[0].vendorName}`;
            worksheet.getCell("B19").font = {
              name: "Arial Narrow",
              size: 18,
              bold: true,
            };

            worksheet.getCell("B10").alignment = {
              vertical: "middle",
              horizontal: "center",
              wrapText: true,
            };
            worksheet.getCell("B10").font = {
              name: "Arial Narrow",
              size: 18,
              bold: true,
              color: { argb: "FFA04000" },
            };

            const cell = worksheet.getCell("B8:D13");
            cell.border = {
              top: { style: "thin" },
              left: { style: "thin" },
              right: { style: "thin" },
              bottom: { style: "thin" },
            };
            const cell1 = worksheet.getCell("B9:D13");
            cell1.border = {
              left: { style: "thin" },
              right: { style: "thin" },
            };
            const cell2 = worksheet.getCell("B10:D13");
            cell2.border = {
              left: { style: "thin" },
              bottom: { style: "thin" },
              right: { style: "thin" },
            };

            //2d table border
            const cell3 = worksheet.getCell("F8:H13");
            cell3.border = {
              left: { style: "thin" },
              right: { style: "thin" },
              top: { style: "thin" },
            };
            const cell4 = worksheet.getCell("F9:F13");
            cell4.border = {
              left: { style: "thin", bottom: { style: "thin" } },
            };
            const cell5 = worksheet.getCell("H9:H13");
            cell5.border = { right: { style: "thin" } };
            const cell6 = worksheet.getCell("F14");
            cell6.border = { top: { style: "thin" } };

            const buffer = workbook.xlsx.writeBuffer();
            return buffer;
          } catch (error) {
            console.error("Error processing the Excel file:", error);
            throw error;
          }
        }
        //Patch Label 👇
        else if (req.itemId[0] === 53) {
          try {
            const info = [
              {
                address:
                  "Unit A1-06, 10th Floor, Hang Fung Industrial Building, Phase 1, No. 2G Hok Yuen Street, Hung Hom, Kowloon, Hong Kong.",
                buyerName: "NIKE",
                division: "",
                season: "",
                merchandiser: "SHOBHA",
                orderDate: "",
                orderBy: "Jas / Chandra",
                reqShipDate: "",
                style: "",
              },
            ];
            const folderPath = path.resolve(
              "packages",
              "services",
              "common",
              "src",
              "assets"
            );
            const fileName = "bskPatch.xlsx";
            const filePath = path.join(folderPath, fileName);
            //this are only used for local changes and local testing this process wont work for deployed code  so we use altenative method as url
            // const workbook = new ExcelJS.Workbook();
            // await workbook.xlsx.readFile(filePath);
            //this url is used for deployed code for local changes we can use file path method
            const url =
              "http://165.22.220.143/bom/gtstoinfor/dist/packages/services/common/assets/bskPatch.xlsx";
            const workbook = await this.readExcelFromUrl(url);

            const worksheet = workbook.getWorksheet(1);
            const startingRow = 20;
            const filterDataByImCodes = (data, imCodes) => {
              return data.filter((item) => imCodes.includes(item.imCode));
            };
            const filteredData = filterDataByImCodes(data, req.imCodes);
            if (filteredData.length > 0) {
              worksheet.spliceRows(
                startingRow,
                0,
                ...new Array(filteredData.length).fill([])
              );
            }
            let totalBomQty = 0;
            // Define the type for your data
            interface ItemData {
              description: string;
              imCode: string;
              color: string;
              buttonSize: string;
              season: string;
              bomQty: number;
              unit: string;
              itemNo: string;
              styleNumber: string;
              year: string;
              combination: string;
              opUom: string;
            }

            const groupedData: Record<string, ItemData[]> = filteredData.reduce(
              (acc: Record<string, ItemData[]>, item: ItemData) => {
                acc[item.itemNo] = acc[item.itemNo] || [];
                acc[item.itemNo].push(item);
                return acc;
              },
              {}
            );

            const uniqueStyles = [
              ...new Set(filteredData.map((item) => item.styleNumber)),
            ].join("/");
            const uniqueSeasons = [
              ...new Set(
                filteredData.map(
                  (item) => `${item.season}${item.year.slice(-2)}`
                )
              ),
            ].join("/");

            let currentRow = startingRow;

            Object.values(groupedData).forEach((group: ItemData[]) => {
              const groupSize = group.length;

              group.forEach((item, index) => {
                const rowIndex = currentRow + index;
                const row = worksheet.getRow(rowIndex);
                totalBomQty += item.bomQty;
                row.getCell(4).value = item.imCode; // Column D
                // row.getCell(6).value = `${item.combination !== null ? item.combination : ''}-${item.color !== null ? item.color : ''}`;
                row.getCell(6).value = `${item.color !== null
                  ? [...new Set(item.color.split(",").filter(Boolean))].join(
                    "/"
                  )
                  : "-"
                  }`;
                // row.getCell(7).value = '18 L';
                row.getCell(8).value = `${item.season}${item.year.slice(-2)}`;
                row.getCell(9).value = item.itemNo;
                row.getCell(10).value = item.styleNumber;
                row.getCell(11).value = Math.ceil(item.bomQty);
                row.getCell(12).value = `PCS`;

                const sumRowIndex = currentRow + group.length;
                const sumRow = worksheet.getRow(sumRowIndex);
                sumRow.getCell(11).value = Math.ceil(totalBomQty);

                for (let col = 4; col <= 12; col++) {
                  const cell = row.getCell(col);
                  cell.border = {
                    top: { style: "thin" },
                    left: { style: "thin" },
                    bottom: { style: "thin" },
                    right: { style: "thin" },
                  };
                }

                // Set special fonts
                row.getCell(4).font = { name: "Calibri", size: 16 };
                row.getCell(6).font = { name: "Verdana", size: 12 };
                row.getCell(7).font = { name: "Calibri", size: 16 };
                row.getCell(8).font = { name: "Calibri", size: 16 };
                row.getCell(9).font = { name: "Calibri", size: 16 };
                row.getCell(10).font = { name: "Calibri", size: 16 };
                row.getCell(11).font = { name: "Verdana", size: 12 };
                row.getCell(12).font = {
                  name: "Verdana",
                  size: 12,
                  bold: true,
                };

                // Set Calibri 16 font and center alignment
                row.getCell(4).alignment = {
                  vertical: "middle",
                  horizontal: "center",
                };
                row.getCell(6).alignment = {
                  vertical: "middle",
                  horizontal: "center",
                  wrapText: true,
                };
                row.getCell(7).alignment = {
                  vertical: "middle",
                  horizontal: "center",
                };
                row.getCell(8).alignment = {
                  vertical: "middle",
                  horizontal: "center",
                };
                row.getCell(9).alignment = {
                  vertical: "middle",
                  horizontal: "center",
                };
                row.getCell(10).alignment = {
                  vertical: "middle",
                  horizontal: "center",
                };
                row.getCell(11).alignment = {
                  vertical: "middle",
                  horizontal: "center",
                };
                row.getCell(12).alignment = {
                  vertical: "middle",
                  horizontal: "center",
                };
              });

              // Merge cells for the item column (column I, index 9)
              if (groupSize > 1) {
                worksheet.mergeCells(
                  `I${currentRow}:I${currentRow + groupSize - 1}`
                );
                worksheet.mergeCells(
                  `J${currentRow}:J${currentRow + groupSize - 1}`
                );
              }

              currentRow += groupSize;
            });

            // Handle merged cells for the first row in the range
            // if (filteredData.length > 0) {
            //     const endingRow = startingRow + filteredData.length - 1;
            //     worksheet.mergeCells(`B${startingRow}:C${endingRow + 1}`);
            //     worksheet.mergeCells(`G${startingRow}:G${endingRow}`);
            //     worksheet.mergeCells(`H${startingRow}:H${endingRow}`);

            //     const mergedCell = worksheet.getCell(`B${startingRow}`);
            //     // mergedCell.value = data.map(item => item.descriptions);
            //     mergedCell.value = filteredData[0].description;

            //     mergedCell.alignment = { vertical: 'middle', horizontal: 'center', wrapText: true };
            //     mergedCell.font = { name: 'Calibri Light', size: 14 };

            // }
            if (filteredData && filteredData.length > 0) {
              const endingRow = startingRow + filteredData.length - 1;

              worksheet.mergeCells(`G${startingRow}:G${endingRow}`);
              worksheet.mergeCells(`H${startingRow}:H${endingRow}`);

              const mergedCell = worksheet.getCell(`B${startingRow}`);
              mergedCell.value = filteredData[0].description;

              mergedCell.alignment = {
                vertical: "middle",
                horizontal: "center",
                wrapText: true,
              };
              mergedCell.font = { name: "Calibri Light", size: 14 };
            }
            if (filteredData && filteredData.length > 0) {
              const endingRow = startingRow + filteredData.length + 3;
              // worksheet.mergeCells(`B${startingRow}:C${endingRow}`);
              if (Number(endingRow) - Number(startingRow) >= 14) {
                worksheet.mergeCells(`B${startingRow}:C33`);
                //temprory solution
                //  worksheet.unMergeCells(`B34:C${endingRow}`);
                //  worksheet.mergeCells(`B34:C${endingRow}`);
              } else {
                worksheet.mergeCells(`B${startingRow}:C${endingRow}`);
              }
              const mergedCell = worksheet.getCell(`B${startingRow}`);
              mergedCell.value = filteredData[0].description;

              mergedCell.alignment = {
                vertical: "middle",
                horizontal: "center",
                wrapText: true,
              };
              mergedCell.font = { name: "Calibri Light", size: 14 };
            }

            //staring 3 tables
            const currentDate = new Date();
            const reShipDate = new Date();
            reShipDate.setDate(currentDate.getDate() + 14);

            worksheet.getCell("N9").value = currentDate.toLocaleDateString();
            worksheet.getCell("N10").value = `${info[0].orderBy}`;
            worksheet.getCell("N11").value = reShipDate.toLocaleDateString();

            worksheet.mergeCells("G9:H9");
            worksheet.getCell("G9").value = info[0].buyerName;
            worksheet.mergeCells("G10:H10");
            worksheet.getCell("G10").value = `SPORTSWEAR`;
            worksheet.mergeCells("G11:H11");
            worksheet.getCell("G11").value = uniqueSeasons;
            worksheet.getCell("G11").font = { name: "Calibri", size: 16 };
            worksheet.mergeCells("G12:H12");
            worksheet.getCell("G12").value = uniqueStyles;
            worksheet.getCell("G12").font = { name: "Calibri", size: 16 };
            worksheet.mergeCells("G13:H13");
            worksheet.getCell("G13").value = info[0].merchandiser;

            worksheet.mergeCells("B10:D13");
            worksheet.getCell("B10").value = info[0].address;
            worksheet.getCell(
              "B19"
            ).value = `Supplier:${filteredData[0].vendorName}`;
            worksheet.getCell("B19").font = {
              name: "Arial Narrow",
              size: 18,
              bold: true,
            };

            worksheet.getCell("B10").alignment = {
              vertical: "middle",
              horizontal: "center",
              wrapText: true,
            };
            worksheet.getCell("B10").font = {
              name: "Arial Narrow",
              size: 18,
              bold: true,
              color: { argb: "FFA04000" },
            };

            const cell = worksheet.getCell("B8:D13");
            cell.border = {
              top: { style: "thin" },
              left: { style: "thin" },
              right: { style: "thin" },
              bottom: { style: "thin" },
            };
            const cell1 = worksheet.getCell("B9:D13");
            cell1.border = {
              left: { style: "thin" },
              right: { style: "thin" },
            };
            const cell2 = worksheet.getCell("B10:D13");
            cell2.border = {
              left: { style: "thin" },
              bottom: { style: "thin" },
              right: { style: "thin" },
            };

            //2d table border
            const cell3 = worksheet.getCell("F8:H13");
            cell3.border = {
              left: { style: "thin" },
              right: { style: "thin" },
              top: { style: "thin" },
            };
            const cell4 = worksheet.getCell("F9:F13");
            cell4.border = {
              left: { style: "thin", bottom: { style: "thin" } },
            };
            const cell5 = worksheet.getCell("H9:H13");
            cell5.border = { right: { style: "thin" } };
            const cell6 = worksheet.getCell("F14");
            cell6.border = { top: { style: "thin" } };

            const buffer = workbook.xlsx.writeBuffer();
            return buffer;
          } catch (error) {
            // await transactionManager.rollbackTransaction();
            throw new Error(`Error processing file: ${error.message}`);
          }
        } //Error loging 👇
        else {
          console.log("nothing found");
        }
      } else {
        return new CommonResponseModel(
          false,
          23245,
          "Selected item has no data , file genration is failed"
        );
      }
    } catch (error) {
      // await transactionManager.rollbackTransaction();
      return new CommonResponseModel(
        false,
        1200,
        "not able to edit order form "
      );
    }
  }

  async tagTimeextraction(req: BomProposalReq): Promise<any> {
    let response: CommonResponseModel;
    let data: any[] = [];
    response = await this.getPatchLabel(req);
    data = response.data;

    //this are only used for local changes and local testing this process wont work for deployed code  so we user altenative method as url
    const folderPath = path.resolve(
      "packages",
      "services",
      "common",
      "src",
      "assets"
    );
    const fileName = "tagTime.xlsx";
    const filePath = path.join(folderPath, fileName);
    //filter the data with imcodes
    const filterDataByImCodes = (data, imCodes) => {
      return data.filter((item) => imCodes.includes(item.imCode));
    };
    const filteredData = filterDataByImCodes(data, req.imCodes);

    const aggregatedData = filteredData.reduce((acc: any, item: any) => {
      if (!acc[item.imCode]) {
        acc[item.imCode] = { ...item, bomQty: 0, itemColor: new Set<string>() };
      }
      acc[item.imCode].bomQty += Math.ceil(item.bomQty);
      item.itemColor
        .split(",")
        .forEach((color: string) => acc[item.imCode].itemColor.add(color));
      return acc;
    }, {});

    const aggregatedDataArray = Object.values(aggregatedData).map(
      (item: any) => ({
        ...item,
        itemColor: Array.from(item.itemColor).join("\n"),
      })
    );

    const uniqueStyleNumbers = Array.from(
      new Set(filteredData.map((item: any) => item.styleNumber))
    ).join(", ");
    const season =
      aggregatedDataArray.length > 0 ? aggregatedDataArray[0].season : "";
    const year =
      aggregatedDataArray.length > 0 ? aggregatedDataArray[0].year : "";

    try {
      //this are only used for local changes and local testing this process wont work for deployed code  so we user altenative method as url
      // const workbook = new ExcelJS.Workbook();
      // await workbook.xlsx.readFile(filePath);
      // this url is  used for live already deployed changes in file will be applied on our screen
      const url =
        "http://165.22.220.143/bom/gtstoinfor/dist/packages/services/common/assets/tagTime.xlsx";
      const workbook = await this.readExcelFromUrl(url);
      const worksheet = workbook.getWorksheet(1);

      aggregatedDataArray.forEach((item: any, index: number) => {
        const rowIndex = 21 + index;
        const row = worksheet.insertRow(rowIndex, [
          index + 1,
          `${item.imCode}\n - GCW#1 \n${item.itemColor}\n`,
          null,
          null,
          null,
          Math.ceil(item.bomQty),
        ]);

        // This is for creating a dynamic table
        for (let col = 1; col <= 7; col++) {
          const cell = row.getCell(col);
          cell.border = {
            top: { style: "thick" },
            left: { style: "thick" },
            bottom: { style: "thick" },
            right: { style: "thick" },
          };
        }
      });
      const currentDate = new Date();
      worksheet.getCell("E6").value = currentDate.toLocaleDateString();
      worksheet.unMergeCells(`E${6}:G${6}`);
      worksheet.mergeCells(`E${6}:G${6}`);
      worksheet.getCell("E6").alignment = {
        vertical: "middle",
        horizontal: "center",
        wrapText: true,
      };

      // This is for creating a dynamic table and merging
      for (let len = 1; len <= aggregatedDataArray.length; len++) {
        const rowLength = 20 + len;
        const rangeBtoE = `B${rowLength}:E${rowLength}`;
        const rangeFtoG = `F${rowLength}:G${rowLength}`;
        worksheet.unMergeCells(rangeBtoE);
        worksheet.unMergeCells(rangeFtoG);
        worksheet.mergeCells(rangeBtoE);
        worksheet.mergeCells(rangeFtoG);
        worksheet.getCell(`A${rowLength}`).alignment = {
          vertical: "middle",
          horizontal: "center",
          wrapText: true,
        };
        worksheet.getCell(`B${rowLength}`).alignment = {
          vertical: "middle",
          horizontal: "center",
          wrapText: true,
        };
        worksheet.getCell(`F${rowLength}`).alignment = {
          vertical: "middle",
          horizontal: "center",
          wrapText: true,
        };
        worksheet.getCell(`B${rowLength}`).font = { bold: true };
        worksheet.getCell(`F${rowLength}`).font = { bold: true };
        worksheet.getCell(`B${rowLength}`).fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "FFFF00" },
        };
        worksheet.getCell(`F${rowLength}`).fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "FFFF00" },
        };
      }
      const lastRow = 20 + aggregatedDataArray.length;
      const newRow = lastRow + 8;
      const stylesRow = lastRow + 9;
      worksheet.getCell(`B${newRow}`).value = `${season}${year.slice(-2)}`;
      worksheet.getCell(`B${stylesRow}`).value = ` ${uniqueStyleNumbers}`;

      const buffer = await workbook.xlsx.writeBuffer();
      return buffer;
    } catch (error) {
      console.error(error);
      throw new Error("Error processing the file");
    }
  }
  async averyPatchlableextraction(req: BomProposalReq): Promise<any> {
    try {
      let response: CommonResponseModel;
      let data: any[] = [];
      response = await this.getPatchLabel(req);
      data = response.data;

      type GroupedItem = {
        imCode: string;
        poNumber: string;
        bomQty: number;
        itemColor: Set<string>;
        season: string;
        year: string;
      };
      //filter the data with imcodes
      const filterDataByImCodes = (data, imCodes) => {
        return data.filter((item) => imCodes.includes(item.imCode));
      };
      const filteredData = filterDataByImCodes(data, req.imCodes);

      const groupedData = filteredData.reduce(
        (acc: Record<string, GroupedItem>, item) => {
          const { imCode, poNumber, bomQty, itemColor, season, year } = item;

          if (!acc[imCode]) {
            acc[imCode] = {
              imCode,
              poNumber,
              bomQty: 0,
              itemColor: new Set<string>(),
              season,
              year,
            };
          }

          acc[imCode].bomQty += bomQty;

          itemColor
            .split(",")
            .forEach((color: string) =>
              acc[imCode].itemColor.add(color.trim())
            );

          return acc;
        },
        {} as Record<string, GroupedItem>
      );

      const groupedDataArray: GroupedItem[] = Object.values(groupedData);

      //this are only used for local changes and local testing this process wont work for deployed code  so we use altenative method as url
      const folderPath = path.resolve(
        "packages",
        "services",
        "common",
        "src",
        "assets"
      );
      const fileName = "averyPatch.xlsx";
      const filePath = path.join(folderPath, fileName);

      try {
        //this are only used for local changes and local testing this process wont work for deployed code  so we use altenative method as url
        // const workbook = new ExcelJS.Workbook();
        // await workbook.xlsx.readFile(filePath);
        //this is for the live
        const url =
          "http://165.22.220.143/bom/gtstoinfor/dist/packages/services/common/assets/averyPatch.xlsx";
        const workbook = await this.readExcelFromUrl(url);
        workbook.eachSheet((worksheet) => {
          const excelData: any[][] = [];

          worksheet.eachRow({ includeEmpty: true }, (row, rowNumber) => {
            const rowData: any[] = [];
            row.eachCell({ includeEmpty: true }, (cell, colNumber) => {
              rowData[colNumber - 1] = cell.value;
            });
            excelData[rowNumber - 1] = rowData;
          });

          const currentDate = new Date();
          worksheet.getCell("G8").value = currentDate.toLocaleDateString();
          worksheet.unMergeCells(`G${8}:H${8}`);
          worksheet.mergeCells(`G${8}:H${8}`);
          worksheet.getCell("G8").alignment = {
            vertical: "middle",
            horizontal: "center",
            wrapText: true,
          };

          if (excelData.length > 1 && excelData[1].length > 1) {
            groupedDataArray.forEach((item, index) => {
              const rowIndex = 22 + index;

              const updateCell = (row: number, col: number, value: any) => {
                const cell = worksheet.getRow(row).getCell(col);
                cell.value = value;
              };

              const mergeAndConcatColumnGH = (row: number) => {
                const cellG = worksheet.getRow(row).getCell(7).value || "";
                const cellH = worksheet.getRow(row).getCell(8).value || "";
                const concatenatedValue = `${cellG} ${cellH}`.trim();

                worksheet.mergeCells(row, 7, row, 8);
                updateCell(row, 7, concatenatedValue);

                return concatenatedValue;
              };

              const uniqueItemColorsString = Array.from(item.itemColor).join(
                "\n"
              );

              //updateCell(rowIndex, 1, item.poNumber);
              updateCell(rowIndex, 2, item.imCode);
              updateCell(rowIndex, 3, uniqueItemColorsString);
              +updateCell(rowIndex, 4, Math.ceil(item.bomQty));
              updateCell(rowIndex, 5, `${item.season}${item.year.slice(-2)}`);
              updateCell(
                rowIndex,
                7,
                `IM# ${item.imCode}  ${uniqueItemColorsString}`
              );
              mergeAndConcatColumnGH(rowIndex);
              for (let col = 2; col <= 5; col++) {
                worksheet.getCell(rowIndex, col).alignment = {
                  vertical: "middle",
                  horizontal: "center",
                  wrapText: true,
                };
                worksheet.getCell(rowIndex, col).font = {
                  name: "Arial",
                  size: 10,
                  bold: true,
                };
                //  worksheet.getCell(rowIndex, col).fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFFF00' } };
                //Arial 10
              }
              worksheet.getCell(`G${rowIndex}`).font = {
                name: "Arial",
                size: 10,
                bold: true,
              };
            });
          }

          for (
            let rowIndex = 22;
            rowIndex <= 22 + groupedDataArray.length - 1;
            rowIndex++
          ) {
            // console.log(groupedDataArray, "groupedDataArray")
            const row = worksheet.getRow(rowIndex);
            for (let col = 1; col <= 8; col++) {
              const cell = row.getCell(col);
              cell.border = {
                top: { style: "thin" },
                left: { style: "thin" },
                bottom: { style: "thin" },
                right: { style: "thin" },
              };
            }
          }
        });

        const buffer = await workbook.xlsx.writeBuffer();
        return buffer;
      } catch (error) {
        console.error("Error processing Excel file:", error);
        throw error;
      }
    } catch (error) {
      return new CommonResponseModel(
        false,
        1200,
        "unable to process order forms"
      );
    }
  }
  sizeWiseExcessQty(bomQty: number) {
    if (bomQty < 150) return Math.ceil(bomQty - bomQty * (1.2 / 100) + 5);
    return Math.ceil(bomQty);
  }

  sizeWiseMOQQty(bomWithExcessQty: number, moqQty: number) {
    if (bomWithExcessQty < moqQty) return Math.ceil(moqQty);
    return Math.ceil(bomWithExcessQty);
  }
  async sizeStripEtraction(req: BomProposalReq): Promise<any> {

    try {

      let response;
      let data = [];
      response = await this.getSizeStrip(req);
      data = response.data;
      //this are only used for local changes and local testing this process wont work for deployed code  so we use altenative method as url
      const folderPath = path.resolve(
        "packages",
        "services",
        "common",
        "src",
        "assets"
      );
      const fileName = "sizeStrip.xlsx";
      const filePath = path.join(folderPath, fileName);
      //this are only used for local changes and local testing this process wont work for deployed code  so we use altenative method as url
      // const workbook = new ExcelJS.Workbook();
      // await workbook.xlsx.readFile(filePath);

      const filterDataByStyleNumber = (data, styleNumber) => {
        return data.filter((item) => styleNumber.includes(item.styleNumber));
      };
      //initiall we did with style wise on mnth of aug (08) 
      // modefied on 23/11/2024 frm filterDataByStyleNumber to item wise again
      const filterDataByitemNumber = (data, itemNo) => {
        return data.filter((item) => itemNo.includes(item.itemNo));
      };

      const filteredData = filterDataByitemNumber(data, req.styleNumber);

      const transformedData = filteredData.map((item) => ({
        ...item,
        sizeWiseQty: item.sizeWiseQty.map((sizeItem) => ({
          ...sizeItem,
          size:
            sizeItem.size === "2XL"
              ? "XXL"
              : sizeItem.size === "2XLT"
                ? "XXLT"
                : sizeItem.size === "2XL-T"
                  ? "XXL TALL"
                  : sizeItem.size === "2XL-S"
                    ? "XXL SHORT"
                    : sizeItem.size === "2XLTT"
                      ? "XXLTT"
                      : sizeItem.size === "2XS"
                        ? "XXS"
                        : sizeItem.size === "3XL-S"
                          ? "3XL SHORT"
                          : sizeItem.size === "3XL-T"
                            ? "3XL TALL"
                            : sizeItem.size === "4XL-S"
                              ? "4XL SHORT"
                              : sizeItem.size === "4XL-T"
                                ? "4XL TALL"
                                : sizeItem.size === "L-S"
                                  ? "L SHORT"
                                  : sizeItem.size === "L-T"
                                    ? "L TALL"
                                    : sizeItem.size === "M-S"
                                      ? "M SHORT"
                                      : sizeItem.size === "M-T"
                                        ? "M TALL"
                                        : sizeItem.size === "S-S"
                                          ? "S SHORT"
                                          : sizeItem.size === "S-T"
                                            ? "S TALL"
                                            : sizeItem.size === "XL-S"
                                              ? "XL SHORT"
                                              : sizeItem.size === "XL-T"
                                                ? "XL TALL"
                                                : sizeItem.size === "XS-S"
                                                  ? "XS SHORT"
                                                  : sizeItem.size === "XS-T"
                                                    ? "XS TALL"
                                                    : sizeItem.size === "XS+"
                                                      ? "XS[+]"
                                                      : sizeItem.size === "XSTT"
                                                        ? "XSTT"
                                                        : sizeItem.size,
        })),
      }));

      const url =
        "http://165.22.220.143/bom/gtstoinfor/dist/packages/services/common/assets/sizeStrip.xlsx";
      const workbook = await this.readExcelFromUrl(url);
      const worksheet = workbook.getWorksheet("Nike size stripe");
      const startRow = 20;
      const endRow = 36;
      const sizeColumns = ["A", "D", "G", "J", "L"];
      const quantityColumns = ["B", "E", "H", "K", "M"];

      const sizeRowMap = {};

      for (let rowNumber = startRow; rowNumber <= endRow; rowNumber++) {
        const row = worksheet.getRow(rowNumber);
        sizeColumns.forEach((col, index) => {
          const cellValue = row.getCell(col).value;
          if (cellValue) {
            sizeRowMap[cellValue] = {
              row: rowNumber,
              qtyCol: quantityColumns[index],
            };
          }
        });
      }

      const aggregatedDataMap = new Map<
        string,
        { size: string; qty: number; moqqty: number }
      >();

      transformedData.forEach((item) => {
        item.sizeWiseQty.forEach((sizeItem) => {
          const sizeKey = sizeItem.size;
          const qty = this.sizeWiseExcessQty(sizeItem.qty);
          const moqqty = this.sizeWiseMOQQty(qty, 50);

          // Aggregate both qty and moqqty
          if (!aggregatedDataMap.has(sizeKey)) {
            aggregatedDataMap.set(sizeKey, {
              size: sizeItem.size,
              qty: qty,
              moqqty: moqqty,
            });
          } else {
            const existing = aggregatedDataMap.get(sizeKey);
            existing.qty += qty;
            existing.moqqty += moqqty;
            aggregatedDataMap.set(sizeKey, existing);
          }
        });
      });

      aggregatedDataMap.forEach((value, key) => {
        const rowInfo = sizeRowMap[value.size];
        if (rowInfo) {
          const { row, qtyCol } = rowInfo;
          const qtyCell = worksheet.getRow(row).getCell(qtyCol);

          if (value.moqqty > value.qty) {
            qtyCell.value = `${value.qty} (${value.moqqty})`;
          } else {
            qtyCell.value = value.qty;
          }
          qtyCell.alignment = { horizontal: "right" };
        }
      });

      const buffer = await workbook.xlsx.writeBuffer();
      return buffer;
    } catch (error) {
      console.error("Error processing size strip:", error);
    }
  }

  async contentAndCareCode(style: any): Promise<any> {
    const query = `
            SELECT 
                MAX(CASE WHEN b.description LIKE '%CONTENT%' THEN b.im_code ELSE NULL END) AS contentCode,
                MAX(CASE WHEN b.description LIKE '%CARE%' THEN b.im_code ELSE NULL END) AS careCode
            FROM 
                styles s
            LEFT JOIN  bom b ON b.style_id = s.id
            WHERE 
                b.item_id = 1 
                AND s.style = '${style}'
                AND (b.description LIKE '%CONTENT%' OR b.description LIKE '%CARE%')
                AND b.im_code IS NOT NULL
        `;

    const data = await this.bomRepo.query(query);
    if (data.length > 0) {
      const result = data[0];
      return new CommonResponseModel(true, 1, "data retrieved", {
        contentCode: result.contentCode,
        careCode: result.careCode,
      });
    } else {
      return new CommonResponseModel(false, 0, "no data found");
    }
  }

  async hTextraction(req: any): Promise<any> {
    try {
      const folderPath = path.resolve(
        "packages",
        "services",
        "common",
        "src",
        "assets"
      );
      const fileName = "htLabel.xlsx";
      const filePath = path.join(folderPath, fileName);

      const styleNumbersArray = req.styleNumber.split(",");

      const uniqueStyleNumbers = [...new Set(styleNumbersArray)];

      const firstStyleNumber = uniqueStyleNumbers[0];

      const washCareCodes = await this.contentAndCareCode(firstStyleNumber);

      const customOrder = [
        "2XS",
        "XS",
        "S",
        "M",
        "L",
        "XL",
        "2XL",
        "3XL",
        "4XL",
        "5XL",
        "XS-S",
        "S-S",
        "M-S",
        "L-S",
        "XL-S",
        "2XL-S",
        "3XL-S",
        "4XL-S",
        "XS-T",
        "S-T",
        "M-T",
        "L-T",
        "XL-T",
        "2XL-T",
        "3XL-T",
        "4XL-T",
        "5XL-T",
        "STT",
        "MTT",
        "LTT",
        "XLTT",
        "2XLTT",
        "3XLTT",
        "S+",
        "M+",
        "L+",
        "Custm",
      ];
      try {
        let totalQty = 0;
        let moqRowTotal = 0;
        const url =
          "http://165.22.220.143/bom/gtstoinfor/dist/packages/services/common/assets/htLabel.xlsx";
        const workbook = await this.readExcelFromUrl(url);

        const worksheet = workbook.getWorksheet(1);
        const startingRow = 36;
        let currentRow = startingRow;

        const constentCodes = washCareCodes.data;
        totalQty += Math.ceil(req.bomQty);
        let sumQty = 0;

        req.sizeWiseQty.sort((a, b) => {
          const aIndex = customOrder.indexOf(a.size);
          const bIndex = customOrder.indexOf(b.size);
          return aIndex - bIndex;
        });

        const currentDate = new Date();
        worksheet.getCell("C4").value = currentDate.toLocaleDateString();
        worksheet.getCell("B16").value = req.imCode;
        worksheet.getCell("B18").value = req.itemColor;
        // worksheet.getCell("B27").value = constentCodes?.contentCode;
        // worksheet.getCell("B30").value = constentCodes?.careCode;
        worksheet.getCell("B27").value =
          constentCodes?.contentCode?.length === 6
            ? constentCodes.contentCode
            : constentCodes?.contentCode?.padStart(6, "0");

        worksheet.getCell("B30").value =
          constentCodes?.careCode?.length === 6
            ? constentCodes.careCode
            : constentCodes?.careCode?.padStart(6, "0");

        worksheet.getCell("G24").value = `FABRIC IM# : `;
        worksheet.getCell("H24").value = ` ${req.fabricCode}`;

        let b20Value;
        req.sizeWiseQty.forEach((sizeItem) => {
          if (sizeItem.size.endsWith("TT")) {
            b20Value = "173253";
          } else if (sizeItem.size.endsWith("-T")) {
            b20Value = "A0009687-TALL";
          } else if (sizeItem.size.endsWith("-S")) {
            b20Value = "A0009687-SHORT";
          } else {
            b20Value = "A0009687";
          }
        });

        worksheet.getCell("B20").value = b20Value;

        const uniqueStyleNumbers = Array.from(
          new Set(req.styleNumber.split(","))
        ).join(", ");
        const season = Array.from(new Set(req.season.split(","))).join(", ");
        worksheet.getCell("G20").value = `Season code :`;
        worksheet.getCell("H20").value = `${season}`;

        worksheet.getCell("G22").value = `Style (if any) :`;
        worksheet.getCell("H22").value = `${uniqueStyleNumbers}`;
        worksheet.mergeCells("C32:D32");
        worksheet.getCell("C32").value =
          // req.fit && req.fit.toUpperCase() === "LOOSE FIT"
          //   ? `IM#703383 - ${req.fit}`
          //   : ``;
          worksheet.getCell("C32").value = (() => {
            if (!req.fit) return "";

            const fit = req.fit.toUpperCase();

            switch (fit) {
              case "LOOSE FIT":
                return `IM#703383 - LOOSE FIT`;
              case "SLIM FIT":
                return `IM#703380 - ${fit}`;
              case "TIGHT FIT":
                return `IM#703379 - ${fit}`;
              case "OVERSIZED FIT":
                return `IM#710384 - ${fit}`;
              case "STANDARD FIT":
                return "";
              default:
                return "";
            }
          })();

        worksheet.getCell("C32").alignment = {
          vertical: "middle",
          horizontal: "center",
        };
        worksheet.getCell("C32").fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "FFFF00" },
        };

        req.sizeWiseQty.forEach((sizeItem, idx) => {
          const colIndex = 2 + idx;
          const sizeCell = worksheet.getRow(36).getCell(colIndex);
          const qtyCell = worksheet.getRow(37).getCell(colIndex);

          const qty = Math.ceil(this.sizeWiseExcessQty(sizeItem.qty));
          const moqqty = Math.ceil(this.sizeWiseMOQQty(qty, 100));

          if (moqqty > qty) {
            qtyCell.value = `${qty} (${moqqty})`;
          } else {
            qtyCell.value = qty;
          }

          sizeCell.value = sizeItem.size;

          let qtyCellValue = qtyCell.value;
          let extractedQty =
            typeof qtyCellValue === "string" && qtyCellValue.includes("(")
              ? qtyCellValue.split("(")[0].trim()
              : qtyCellValue;

          sumQty += Math.ceil(Number(extractedQty));
          moqRowTotal += moqqty;

          sizeCell.font = { name: "Calibri", size: 12, bold: true };
          qtyCell.font = { name: "Arial", size: 11 };

          sizeCell.alignment = { vertical: "middle", horizontal: "center" };
          qtyCell.alignment = { vertical: "middle", horizontal: "center" };

          sizeCell.border = {
            top: { style: "thin" },
            left: { style: "thin" },
            bottom: { style: "thin" },
            right: { style: "thin" },
          };
          qtyCell.border = {
            top: { style: "thin" },
            left: { style: "thin" },
            bottom: { style: "thin" },
            right: { style: "thin" },
          };

          sizeCell.fill = {
            type: "pattern",
            pattern: "solid",
            fgColor: { argb: "FFFF00" },
          };
        });

        const sumCell = worksheet.getRow(34).getCell(2);
        sumCell.value = `${sumQty} (${moqRowTotal})`;
        sumCell.font = { name: "Arial", size: 10, bold: true };
        sumCell.alignment = { vertical: "middle", horizontal: "center" };
        sumCell.border = {
          top: { style: "thin" },
          left: { style: "thin" },
          bottom: { style: "thin" },
          right: { style: "thin" },
        };

        const buffer = await workbook.xlsx.writeBuffer();
        return buffer;
      } catch (error) {
        throw new Error(`Error processing file: ${error.message}`);
      }
    } catch (error) {
      return new CommonResponseModel(
        false,
        1200,
        "unable to process order forms"
      );
    }
  }

  async mainLabelextraction(req: BomProposalReq): Promise<any> {
    try {
      const response = await this.getMainWovenLableData1(req);
      const data = response.data.flat();
      const filteredData = data.filter((item) =>
        req.itemNo.includes(item.itemNo)
      );
      const customOrder = [
        "2XS",
        "XS",
        "S",
        "M",
        "L",
        "XL",
        "2XL",
        "3XL",
        "4XL",
        "5XL",
        "XS-S",
        "S-S",
        "M-S",
        "L-S",
        "XL-S",
        "2XL-S",
        "3XL-S",
        "4XL-S",
        "XS-T",
        "S-T",
        "M-T",
        "L-T",
        "XL-T",
        "2XL-T",
        "3XL-T",
        "4XL-T",
        "5XL-T",
        "STT",
        "MTT",
        "LTT",
        "XLTT",
        "2XLTT",
        "3XLTT",
        "S+",
        "M+",
        "L+",
        "Custm",
      ];

      const sortBySizeOrder = (a, b) => {
        return customOrder.indexOf(a.size) - customOrder.indexOf(b.size);
      };

      filteredData.forEach((item) => {
        const sizeMap = new Map();

        item.sizeWiseQty.forEach((sizeQty) => {
          if (sizeMap.has(sizeQty.size)) {
            sizeMap.set(sizeQty.size, sizeMap.get(sizeQty.size) + sizeQty.qty);
          } else {
            sizeMap.set(sizeQty.size, sizeQty.qty);
          }
        });

        item.sizeWiseQty = Array.from(sizeMap, ([size, qty]) => ({
          size,
          qty,
        }));

        item.sizeWiseQty.sort(sortBySizeOrder);
      });
      try {
        //this are only used for local changes and local testing this process wont work for deployed code  so we use altenative method as url
        const folderPath = path.resolve(
          "packages",
          "services",
          "common",
          "src",
          "assets"
        );
        const fileName = "main.xlsx";
        const filePath = path.join(folderPath, fileName);

        const url =
          "http://165.22.220.143/bom/gtstoinfor/dist/packages/services/common/assets/main.xlsx";
        const workbook = await this.readExcelFromUrl(url);
        //this are only used for local changes and local testing this process wont work for deployed code  so we use altenative method as url
        //  const workbook = new ExcelJS.Workbook();
        //  await workbook.xlsx.readFile(filePath);
        const worksheet = workbook.getWorksheet(1);
        const firstTableStarting = 24;
        const secondTableStarting = 39;
        const thirdTableStarting = 54;
        let moqRowTotal1 = 0;
        let moqRowTotal2 = 0;
        let moqRowTotal3 = 0;

        let currentRow = firstTableStarting;
        let totalQtySum = 0;

        const currentDate = new Date();
        const formattedDate = currentDate.toLocaleDateString();
        worksheet.getRow(8).getCell(15).value = formattedDate;
        const reShipDate = new Date();
        reShipDate.setDate(currentDate.getDate() + 14);
        worksheet.getCell("N13").value = reShipDate.toLocaleDateString();

        currentRow = firstTableStarting;

        const season = Array.from(
          new Set(filteredData[0].season.split(","))
        ).join(", ");

        filteredData.forEach((item) => {
          item?.sizeWiseQty.forEach((sizeItem) => {
            if (
              !sizeItem.size.includes("-T") &&
              !sizeItem.size.includes("-S")
            ) {
              const sizeCell = worksheet.getRow(currentRow).getCell(9);
              worksheet.getCell("B24").value = item.imCode;
              worksheet.getCell("C24").value = ` ${season}`;
              worksheet.getCell("F24").value = `INDIA`;
              worksheet.getCell("G24").value = `9687`;
              worksheet.getCell("H24").value = `REGULAR`;
              worksheet.getCell("M29").value = `ZOOM FROM LAYOUT`;
              worksheet.getCell("M30").value = `Season Code :`;
              worksheet.getCell("N30").value = `${season}`;
              worksheet.getCell("M31").value = `COO IN ENGLISH :`;
              worksheet.getCell("N31").value = `MADE IN INDIA`;
              worksheet.getCell("M32").value = `COO IN FRENCH :`;
              worksheet.getCell("N32").value = `FABRIQUE EN INDE`;
              worksheet.getCell("M33").value = `Garment Style :`;
              worksheet.unMergeCells("M34:N34");
              worksheet.mergeCells("M34:N34");
              worksheet.getCell("M34").value =
                "Size matrix/Performance matrix#";
              worksheet.getCell("O34").value = "9687";
              worksheet.getCell("M35").value = "Inseam Style:";
              worksheet.getCell("N35").value = "REGULAR";

              sizeCell.value = sizeItem.size;

              const qtyCell = worksheet.getRow(currentRow).getCell(10);
              const qty = Number(
                Math.ceil(this.sizeWiseExcessQty(sizeItem.qty))
              );
              const moqqty = Math.ceil(this.sizeWiseMOQQty(qty, 100));
              moqRowTotal1 += moqqty;

              qtyCell.value = moqqty > qty ? `${qty} (${moqqty})` : qty;
              totalQtySum += qty;
              currentRow++;
            }
          });
        });
        const totalQtyCell = worksheet.getRow(34).getCell(10);
        totalQtyCell.value = `${totalQtySum} (${moqRowTotal1})`;

        let totalTQtySum = 0;
        currentRow = secondTableStarting;
        filteredData.forEach((item) => {
          item?.sizeWiseQty.forEach((sizeItem) => {
            if (sizeItem.size.includes("-T")) {
              const sizeCell = worksheet.getRow(currentRow).getCell(9);
              sizeCell.value = sizeItem.size;
              worksheet.getCell("B39").value = item.imCode;
              worksheet.getCell("C39").value = ` ${season}`;
              worksheet.getCell("F39").value = `INDIA`;
              worksheet.getCell("G39").value = `9687`;
              worksheet.getCell("H39").value = `TALL`;
              worksheet.getCell("M44").value = `ZOOM FROM LAYOUT`;
              worksheet.getCell("M45").value = `Season Code :`;
              worksheet.getCell("N45").value = `${season}`;
              worksheet.getCell("M46").value = `COO IN ENGLISH :`;
              worksheet.getCell("N46").value = `MADE IN INDIA`;
              worksheet.getCell("M47").value = `COO IN FRENCH :`;
              worksheet.getCell("N47").value = `FABRIQUE EN INDE`;
              worksheet.getCell("M48").value = `Garment Style :`;
              worksheet.unMergeCells("M49:N49");
              worksheet.mergeCells("M49:N49");
              worksheet.getCell("M49").value =
                "Size matrix/Performance matrix#";
              worksheet.getCell("O49").value = "9687";
              worksheet.getCell("M50").value = "Inseam Style:";
              worksheet.getCell("N50").value = "TALL";
              const qtyCell = worksheet.getRow(currentRow).getCell(10);
              const qty = Number(
                Math.ceil(this.sizeWiseExcessQty(sizeItem.qty))
              );
              const moqqty = Math.ceil(this.sizeWiseMOQQty(qty, 100));
              moqRowTotal2 += moqqty;
              qtyCell.value = moqqty > qty ? `${qty} (${moqqty})` : qty;
              totalTQtySum += qty;
              currentRow++;
            }
          });
        });
        const totalTQtyCell = worksheet.getRow(49).getCell(10);
        totalTQtyCell.value = `${totalTQtySum}(${moqRowTotal2}) `;

        let totalSQtySum = 0;
        currentRow = thirdTableStarting;
        filteredData.forEach((item) => {
          item?.sizeWiseQty.forEach((sizeItem) => {
            if (sizeItem.size.includes("-S")) {
              const sizeCell = worksheet.getRow(currentRow).getCell(9);
              sizeCell.value = sizeItem.size;
              worksheet.getCell("B54").value = item.imCode;
              worksheet.getCell("C54").value = ` ${season}`;
              worksheet.getCell("F54").value = `INDIA`;
              worksheet.getCell("G54").value = `9687`;
              worksheet.getCell("H54").value = `SHORT`;
              worksheet.getCell("M59").value = `ZOOM FROM LAYOUT`;
              worksheet.getCell("M60").value = `Season Code :`;
              worksheet.getCell("N60").value = `${season}`;
              worksheet.getCell("M61").value = `COO IN ENGLISH :`;
              worksheet.getCell("N61").value = `MADE IN INDIA`;
              worksheet.getCell("M62").value = `COO IN FRENCH :`;
              worksheet.getCell("N62").value = `FABRIQUE EN INDE`;
              worksheet.getCell("M63").value = `Garment Style :`;
              worksheet.unMergeCells("M64:N64");
              worksheet.mergeCells("M64:N64");
              worksheet.getCell("M64").value =
                "Size matrix/Performance matrix#";
              worksheet.getCell("O64").value = "9687";
              worksheet.getCell("M65").value = "Inseam Style:";
              worksheet.getCell("N65").value = "SHORT";

              const qtyCell = worksheet.getRow(currentRow).getCell(10);
              const qty = Number(
                Math.ceil(this.sizeWiseExcessQty(sizeItem.qty))
              );
              const moqqty = Math.ceil(this.sizeWiseMOQQty(qty, 100));
              moqRowTotal3 += moqqty;

              qtyCell.value = moqqty > qty ? `${qty} (${moqqty})` : qty;
              totalSQtySum += qty;
              currentRow++;
            }
          });
        });
        const totalSQtyCell = worksheet.getRow(64).getCell(10);
        totalSQtyCell.value = `${totalSQtySum}(${moqRowTotal3})`;

        const buffer = workbook.xlsx.writeBuffer();
        return buffer;
      } catch (error) {
        throw new Error(`Error processing file: ${error.message}`);
      }
    } catch (error) {
      return new CommonResponseModel(
        false,
        1200,
        "unable to process order forms"
      );
    }
  }

  async getAllBOMs(): Promise<CommonResponseModel> {
    const res = await this.styleRepo.getYearAndSeasonWiseBom();
    if (res.length) {
      return new CommonResponseModel(
        true,
        1111,
        "Data retreived successfully",
        res
      );
    } else {
      return new CommonResponseModel(true, 1100, "No data found");
    }
  }

  async deleteBom(req: NikeBomsModal): Promise<CommonResponseModel> {
    const res = await this.styleRepo.delete({
      season: req.season,
      year: req.year,
    });
    if (res.affected) {
      return new CommonResponseModel(
        true,
        1111,
        "Bom deleted successfully",
        res
      );
    } else {
      return new CommonResponseModel(true, 1100, "No data found");
    }
  }

  async getNotMappedIMsList(): Promise<CommonResponseModel> {
    const imCodes = await this.bomRepo.getNotMappedImCodes()
    if (imCodes.length) {
      return new CommonResponseModel(true, 1111, "Data retreived", imCodes)
    }
  }

  async mapImCodeToItemId(req: ImCodeItemMapReq) {
    const itemEnt = new ItemEntity()
    itemEnt.itemId = req.itemId
    const updateItemId = await this.bomRepo.update({ imCode: req.imCode }, {
      itemEntity: itemEnt
    })

    if (updateItemId.affected) {
      return new CommonResponseModel(true, 1111, "Data updated successfully")
    } else {
      return new CommonResponseModel(false, 1100, "No data found")
    }
  }

  async updateOrderFormimMappingBomTable(
    req: OrderFormMappingDto
  ): Promise<CommonResponseModel> {
    try {
      for (const imCode of req.imCode) {
        await this.bomRepo.update(
          { imCode },
          { orderForm: req.orderForm, vendorName: req.vendorName }
        );
      }

      return new CommonResponseModel(
        true,
        200,
        "Mapped Order Form IMs Successfully"
      );
    } catch (err) {
      throw err;
    }
  }
  async getImcodesForMapping(): Promise<CommonResponseModel> {
    const data = await this.bomRepo.getImcode();
    if (data) {
      return new CommonResponseModel(true, 1, "Data Retrived", data);
    } else {
      return new CommonResponseModel(false, 0, "No Data", []);
    }
  }

  async getItemsForNecktapeConsumption(
    req: SelectedItemsDto
  ): Promise<CommonResponseModel> {
    const data = await this.poBomRepo.getItemsForNecktapeConsumption(req);
    return new CommonResponseModel(true, 1111, "data retreived", data);
  }

  async generateBomForNecktape(req: BomGenerationReq) {
    const transactionManager = new GenericTransactionManager(this.dataSource);
    await transactionManager.startTransaction();
    try {
      const { poLine, updatedSizes, isConsumptionRequired, fileId } = req;
      const poData = await this.ppmDataRepo.getPoDataForBomGeneration({
        poLine,
        fileId,
      });
      // console.log(poData.length, 'po data length')
      const destinations = await this.destinationsRepo.find({
        select: ["destination", "geoCode"],
      });
      const styleDataMap = new Map<string, BomDataForStyleAndSeasonModel[]>();
      function calculateBomQty(
        poQty: number,
        consumption: number,
        directExcess: number,
        distributeExcess: number,
        shippingType: ShippingTypeEnum,
        toUOM: UOMEnum,
        fromUOM: UOMEnum,
        geoCode?: string,
        zfactorId?: number
      ) {
        // console.log(poQty,consumption,directExcess,distributeExcess,shippingType)
        // const excessQty = shippingType == ShippingTypeEnum.DIRECT ? 1.02 : 1.03
        const convertedQty = convertDimensions(fromUOM, toUOM, poQty);
        let excessQty =
          shippingType == ShippingTypeEnum.DIRECT
            ? directExcess
            : distributeExcess;
        const factor = 1 + excessQty / 100;
        const bomQty = convertedQty * consumption;
        return bomQty * factor;
      }

      const poBomEntities: PoBomEntity[] = [];
      poDataLoop: for (const po of poData) {
        const bomDestinations = destinations.find(
          (v) => v.destination == po.destination
        );

        const { geoCode } = bomDestinations;

        let styleData: BomDataForStyleAndSeasonModel[] = [];
        const seasonStyleKey = po.styleNumber + po.season + po.year;
        if (!styleDataMap.has(seasonStyleKey)) {
          styleData = await this.bomRepo.getTrimBomDataForStyleAndSeason({
            style: po.styleNumber,
            season: po.season,
            year: po.year,
            itemId: req.itemId,
          });
          styleDataMap.set(seasonStyleKey, styleData);
        } else {
          styleData = styleDataMap.get(seasonStyleKey);
        }
        // console.log(po)
        for (const styleBom of styleData) {

          const consumptions = req.updatedConsumptions.find(c => c.item === po.item && styleBom.use.trim() === c.use.trim())
          // console.log(consumptions)
          const { consumption, fromUOM, toUOM } = consumptions ? consumptions : { consumption: 1, fromUOM: UOMEnum.METER, toUOM: UOMEnum.YARD }
          console.log(consumptions, "consumptions");
          // console.log(po.size, tempConsumption)
          const bomQty = calculateBomQty(
            po.qty,
            consumption,
            req.updatedExcessPercentages.DIRECT,
            req.updatedExcessPercentages.DISTRIBUTION_CENTER,
            po.shippingType,
            toUOM,
            fromUOM,
            geoCode
          );


          const poBomEntity = new PoBomEntity();
          const bom = new BomEntity();

          bom.id = styleBom.bomId;
          poBomEntity.bom = bom;
          poBomEntity.consumption = consumption
          poBomEntity.moq = 1;
          poBomEntity.wastage =
            po.shippingType == ShippingTypeEnum.DIRECT ? 1.02 : 1.03;
          poBomEntity.bomQty = bomQty;
          poBomEntity.poQty = po.qty;
          poBomEntity.opUom = toUOM;
          poBomEntity.ipUom = fromUOM;
          const dpom = new DpomEntity();
          dpom.id = po.id;
          poBomEntity.dpom = dpom;

          // console.log(zfactors, 'z factors')

          poBomEntities.push(poBomEntity);
        }

      }
      // console.log(poBomEntities)
      await transactionManager
        .getRepository(PoBomEntity)
        .createQueryBuilder()
        .delete()
        .execute();
      const save = await transactionManager.getRepository(PoBomEntity).insert(poBomEntities)
      await transactionManager.completeTransaction()
      if (poBomEntities.length) {
        return new CommonResponseModel(
          true,
          11111,
          "Bom generated sucessfully"
        );
      } else {
        return new CommonResponseModel(
          true,
          11111,
          "Bom not found for the selected item"
        );
      }

      // moq
    } catch (err) {
      console.log(err);
      await transactionManager.releaseTransaction()
      throw (err)
    }
  }

  async getAllUnmappedItems(): Promise<CommonResponseModel> {
    try {
      const info = await this.bomRepo.findUnmappedIms()
      if (info) {
        return new CommonResponseModel(true, 1, 'Data retrieved', info)
      } else {
        return new CommonResponseModel(false, 0, 'No data found')
      }
    } catch (err) {
      return new CommonResponseModel(false, 0, 'Something went wrong', err)
    }
  }

  async generateBomForHangTag() {

  }
}
